/*!
 * lodash.core.min.js
 */
/**
 * @license
 * lodash 4.5.1 (Custom Build) lodash.com/license | Underscore.js 1.8.3 underscorejs.org/LICENSE
 * Build: `lodash core -o ./dist/lodash.core.js`
 */
if (
  (function () {
    function e(e, t) {
      for (var n = -1, i = t.length, r = e.length; ++n < i; ) e[r + n] = t[n];
      return e;
    }
    function t(e, t, n) {
      for (var i = -1, r = e.length; ++i < r; ) {
        var o = e[i],
          s = t(o);
        if (null != s && (a === le ? s === s : n(s, a)))
          var a = s,
            l = o;
      }
      return l;
    }
    function n(e, t, n) {
      var i;
      return (
        n(e, function (e, n, r) {
          return t(e, n, r) ? ((i = e), !1) : void 0;
        }),
        i
      );
    }
    function i(e, t, n, i, r) {
      return (
        r(e, function (e, r, o) {
          n = i ? ((i = !1), e) : t(n, e, r, o);
        }),
        n
      );
    }
    function r(e, t) {
      return S(t, function (t) {
        return e[t];
      });
    }
    function o(e) {
      return e && e.Object === Object ? e : null;
    }
    function s(e) {
      return he[e];
    }
    function a(e) {
      var t = !1;
      if (null != e && "function" != typeof e.toString)
        try {
          t = !!(e + "");
        } catch (e) {}
      return t;
    }
    function l(e, t) {
      return (
        (e = "number" == typeof e || de.test(e) ? +e : -1),
        e > -1 && 0 == e % 1 && (null == t ? 9007199254740991 : t) > e
      );
    }
    function c(e) {
      if (Q(e) && !Fe(e)) {
        if (e instanceof u) return e;
        if (Te.call(e, "__wrapped__")) {
          var t = new u(e.__wrapped__, e.__chain__);
          return (t.__actions__ = $(e.__actions__)), t;
        }
      }
      return new u(e);
    }
    function u(e, t) {
      (this.__wrapped__ = e), (this.__actions__ = []), (this.__chain__ = !!t);
    }
    function p(e, t, n, i) {
      var r;
      return (
        (r = e === le) ||
          ((r = Se[n]),
          (r = (e === r || (e !== e && r !== r)) && !Te.call(i, n))),
        r ? t : e
      );
    }
    function d(e) {
      return J(e) ? Ae(e) : {};
    }
    function h(e, t, n) {
      if ("function" != typeof e) throw new TypeError("Expected a function");
      return setTimeout(function () {
        e.apply(le, n);
      }, t);
    }
    function f(e, t) {
      var n = !0;
      return (
        je(e, function (e, i, r) {
          return (n = !!t(e, i, r));
        }),
        n
      );
    }
    function v(e, t) {
      var n = [];
      return (
        je(e, function (e, i, r) {
          t(e, i, r) && n.push(e);
        }),
        n
      );
    }
    function g(t, n, i, r) {
      r || (r = []);
      for (var o = -1, s = t.length; ++o < s; ) {
        var a = t[o];
        n > 0 && Q(a) && K(a) && (i || Fe(a) || X(a))
          ? n > 1
            ? g(a, n - 1, i, r)
            : e(r, a)
          : i || (r[r.length] = a);
      }
      return r;
    }
    function m(e, t) {
      return e && He(e, t, ie);
    }
    function y(e, t) {
      return v(t, function (t) {
        return Y(e[t]);
      });
    }
    function b(e, t, n, i, r) {
      return (
        e === t ||
        (null == e || null == t || (!J(e) && !Q(t))
          ? e !== e && t !== t
          : k(e, t, b, n, i, r))
      );
    }
    function k(e, t, n, i, r, o) {
      var s = Fe(e),
        l = Fe(t),
        c = "[object Array]",
        u = "[object Array]";
      s ||
        ((c = Ee.call(e)),
        "[object Arguments]" == c && (c = "[object Object]")),
        l ||
          ((u = Ee.call(t)),
          "[object Arguments]" == u && (u = "[object Object]"));
      var p = "[object Object]" == c && !a(e),
        l = "[object Object]" == u && !a(t);
      return !(u = c == u) || s || p
        ? 2 & r ||
          ((c = p && Te.call(e, "__wrapped__")),
          (l = l && Te.call(t, "__wrapped__")),
          !c && !l)
          ? !!u &&
            (o || (o = []),
            (c = B(o, function (t) {
              return t[0] === e;
            })) && c[1]
              ? c[1] == t
              : (o.push([e, t]),
                (t = (s ? j : I)(e, t, n, i, r, o)),
                o.pop(),
                t))
          : n(c ? e.value() : e, l ? t.value() : t, i, r, o)
        : H(e, t, c);
    }
    function w(e) {
      var t = typeof e;
      return "function" == t ? e : null == e ? se : ("object" == t ? T : E)(e);
    }
    function x(e) {
      e = null == e ? e : Object(e);
      var t,
        n = [];
      for (t in e) n.push(t);
      return n;
    }
    function S(e, t) {
      var n = -1,
        i = K(e) ? Array(e.length) : [];
      return (
        je(e, function (e, r, o) {
          i[++n] = t(e, r, o);
        }),
        i
      );
    }
    function T(e) {
      var t = ie(e);
      return function (n) {
        var i = t.length;
        if (null == n) return !i;
        for (n = Object(n); i--; ) {
          var r = t[i];
          if (!(r in n && b(e[r], n[r], le, 3))) return !1;
        }
        return !0;
      };
    }
    function C(e, t) {
      return (
        (e = Object(e)),
        z(
          t,
          function (t, n) {
            return n in e && (t[n] = e[n]), t;
          },
          {}
        )
      );
    }
    function E(e) {
      return function (t) {
        return null == t ? le : t[e];
      };
    }
    function P(e, t, n) {
      var i = -1,
        r = e.length;
      for (
        0 > t && (t = -t > r ? 0 : r + t),
          n = n > r ? r : n,
          0 > n && (n += r),
          r = t > n ? 0 : (n - t) >>> 0,
          t >>>= 0,
          n = Array(r);
        ++i < r;

      )
        n[i] = e[i + t];
      return n;
    }
    function $(e) {
      return P(e, 0, e.length);
    }
    function _(e, t) {
      var n;
      return (
        je(e, function (e, i, r) {
          return (n = t(e, i, r)), !n;
        }),
        !!n
      );
    }
    function A(t, n) {
      return z(
        n,
        function (t, n) {
          return n.func.apply(n.thisArg, e([t], n.args));
        },
        t
      );
    }
    function N(e, t, n, i) {
      n || (n = {});
      for (var r = -1, o = t.length; ++r < o; ) {
        var s = t[r],
          a = i ? i(n[s], e[s], s, n, e) : e[s],
          l = n,
          c = l[s];
        (Te.call(l, s) &&
          (c === a || (c !== c && a !== a)) &&
          (a !== le || s in l)) ||
          (l[s] = a);
      }
      return n;
    }
    function L(e) {
      return U(function (t, n) {
        var i = -1,
          r = n.length,
          o = r > 1 ? n[r - 1] : le,
          o = "function" == typeof o ? (r--, o) : le;
        for (t = Object(t); ++i < r; ) {
          var s = n[i];
          s && e(t, s, i, o);
        }
        return t;
      });
    }
    function O(e) {
      return function () {
        var t = arguments,
          n = d(e.prototype),
          t = e.apply(n, t);
        return J(t) ? t : n;
      };
    }
    function D(e, t, n) {
      function i() {
        for (
          var o = -1,
            s = arguments.length,
            a = -1,
            l = n.length,
            c = Array(l + s),
            u = this && this !== we && this instanceof i ? r : e;
          ++a < l;

        )
          c[a] = n[a];
        for (; s--; ) c[a++] = arguments[++o];
        return u.apply(t, c);
      }
      if ("function" != typeof e) throw new TypeError("Expected a function");
      var r = O(e);
      return i;
    }
    function j(e, t, n, i, r, o) {
      var s = -1,
        a = 1 & r,
        l = e.length,
        c = t.length;
      if (l != c && !(2 & r && c > l)) return !1;
      for (c = !0; ++s < l; ) {
        var u = e[s],
          p = t[s];
        if (void 0 !== le) {
          c = !1;
          break;
        }
        if (a) {
          if (
            !_(t, function (e) {
              return u === e || n(u, e, i, r, o);
            })
          ) {
            c = !1;
            break;
          }
        } else if (u !== p && !n(u, p, i, r, o)) {
          c = !1;
          break;
        }
      }
      return c;
    }
    function H(e, t, n) {
      switch (n) {
        case "[object Boolean]":
        case "[object Date]":
          return +e == +t;
        case "[object Error]":
          return e.name == t.name && e.message == t.message;
        case "[object Number]":
          return e != +e ? t != +t : e == +t;
        case "[object RegExp]":
        case "[object String]":
          return e == t + "";
      }
      return !1;
    }
    function I(e, t, n, i, r, o) {
      var s = 2 & r,
        a = ie(e),
        l = a.length,
        c = ie(t).length;
      if (l != c && !s) return !1;
      for (var u = l; u--; ) {
        var p = a[u];
        if (!(s ? p in t : Te.call(t, p))) return !1;
      }
      for (c = !0; ++u < l; ) {
        var p = a[u],
          d = e[p],
          h = t[p];
        if (void 0 !== le || (d !== h && !n(d, h, i, r, o))) {
          c = !1;
          break;
        }
        s || (s = "constructor" == p);
      }
      return (
        c &&
          !s &&
          ((n = e.constructor),
          (i = t.constructor),
          n != i &&
            "constructor" in e &&
            "constructor" in t &&
            !(
              "function" == typeof n &&
              n instanceof n &&
              "function" == typeof i &&
              i instanceof i
            ) &&
            (c = !1)),
        c
      );
    }
    function M(e) {
      var t = e ? e.length : le;
      if (G(t) && (Fe(e) || ee(e) || X(e))) {
        e = String;
        for (var n = -1, i = Array(t); ++n < t; ) i[n] = e(n);
        t = i;
      } else t = null;
      return t;
    }
    function R(e) {
      var t = e && e.constructor,
        t = (Y(t) && t.prototype) || Se;
      return e === t;
    }
    function q(e) {
      return e ? e[0] : le;
    }
    function B(e, t) {
      return n(e, w(t), je);
    }
    function F(e, t) {
      return je(e, "function" == typeof t ? t : se);
    }
    function z(e, t, n) {
      return i(e, w(t), n, 3 > arguments.length, je);
    }
    function W(e, t) {
      var n;
      if ("function" != typeof t) throw new TypeError("Expected a function");
      return (
        (e = ze(e)),
        function () {
          return (
            0 < --e && (n = t.apply(this, arguments)), 1 >= e && (t = le), n
          );
        }
      );
    }
    function U(e) {
      var t;
      if ("function" != typeof e) throw new TypeError("Expected a function");
      return (
        (t = De(t === le ? e.length - 1 : ze(t), 0)),
        function () {
          for (
            var n = arguments, i = -1, r = De(n.length - t, 0), o = Array(r);
            ++i < r;

          )
            o[i] = n[t + i];
          for (r = Array(t + 1), i = -1; ++i < t; ) r[i] = n[i];
          return (r[t] = o), e.apply(this, r);
        }
      );
    }
    function V(e, t) {
      return e > t;
    }
    function X(e) {
      return (
        Q(e) &&
        K(e) &&
        Te.call(e, "callee") &&
        (!Ne.call(e, "callee") || "[object Arguments]" == Ee.call(e))
      );
    }
    function K(e) {
      return null != e && !("function" == typeof e && Y(e)) && G(Ie(e));
    }
    function Y(e) {
      return (
        (e = J(e) ? Ee.call(e) : ""),
        "[object Function]" == e || "[object GeneratorFunction]" == e
      );
    }
    function G(e) {
      return (
        "number" == typeof e && e > -1 && 0 == e % 1 && 9007199254740991 >= e
      );
    }
    function J(e) {
      var t = typeof e;
      return !!e && ("object" == t || "function" == t);
    }
    function Q(e) {
      return !!e && "object" == typeof e;
    }
    function Z(e) {
      return "number" == typeof e || (Q(e) && "[object Number]" == Ee.call(e));
    }
    function ee(e) {
      return (
        "string" == typeof e ||
        (!Fe(e) && Q(e) && "[object String]" == Ee.call(e))
      );
    }
    function te(e, t) {
      return t > e;
    }
    function ne(e) {
      return "string" == typeof e ? e : null == e ? "" : e + "";
    }
    function ie(e) {
      var t = R(e);
      if (!t && !K(e)) return Oe(Object(e));
      var n,
        i = M(e),
        r = !!i,
        i = i || [],
        o = i.length;
      for (n in e)
        !Te.call(e, n) ||
          (r && ("length" == n || l(n, o))) ||
          (t && "constructor" == n) ||
          i.push(n);
      return i;
    }
    function re(e) {
      for (
        var t = -1,
          n = R(e),
          i = x(e),
          r = i.length,
          o = M(e),
          s = !!o,
          o = o || [],
          a = o.length;
        ++t < r;

      ) {
        var c = i[t];
        (s && ("length" == c || l(c, a))) ||
          ("constructor" == c && (n || !Te.call(e, c))) ||
          o.push(c);
      }
      return o;
    }
    function oe(e) {
      return e ? r(e, ie(e)) : [];
    }
    function se(e) {
      return e;
    }
    function ae(t, n, i) {
      var r = ie(n),
        o = y(n, r);
      null != i ||
        (J(n) && (o.length || !r.length)) ||
        ((i = n), (n = t), (t = this), (o = y(n, ie(n))));
      var s = !(J(i) && "chain" in i) || i.chain,
        a = Y(t);
      return (
        je(o, function (i) {
          var r = n[i];
          (t[i] = r),
            a &&
              (t.prototype[i] = function () {
                var n = this.__chain__;
                if (s || n) {
                  var i = t(this.__wrapped__);
                  return (
                    (i.__actions__ = $(this.__actions__)).push({
                      func: r,
                      args: arguments,
                      thisArg: t,
                    }),
                    (i.__chain__ = n),
                    i
                  );
                }
                return r.apply(t, e([this.value()], arguments));
              });
        }),
        t
      );
    }
    var le,
      ce = 1 / 0,
      ue = /[&<>"'`]/g,
      pe = RegExp(ue.source),
      de = /^(?:0|[1-9]\d*)$/,
      he = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;",
        "`": "&#96;",
      },
      fe = { function: !0, object: !0 },
      ve = fe[typeof exports] && exports && !exports.nodeType ? exports : le,
      ge = fe[typeof module] && module && !module.nodeType ? module : le,
      me = ge && ge.exports === ve ? ve : le,
      ye = o(fe[typeof self] && self),
      be = o(fe[typeof window] && window),
      ke = o(fe[typeof this] && this),
      we =
        o(ve && ge && "object" == typeof global && global) ||
        (be !== (ke && ke.window) && be) ||
        ye ||
        ke ||
        Function("return this")(),
      xe = Array.prototype,
      Se = Object.prototype,
      Te = Se.hasOwnProperty,
      Ce = 0,
      Ee = Se.toString,
      Pe = we._,
      $e = we.Reflect,
      _e = $e ? $e.f : le,
      Ae = Object.create,
      Ne = Se.propertyIsEnumerable,
      Le = we.isFinite,
      Oe = Object.keys,
      De = Math.max,
      je = (function (e, t) {
        return function (n, i) {
          if (null == n) return n;
          if (!K(n)) return e(n, i);
          for (
            var r = n.length, o = t ? r : -1, s = Object(n);
            (t ? o-- : ++o < r) && !1 !== i(s[o], o, s);

          );
          return n;
        };
      })(m),
      He = (function (e) {
        return function (t, n, i) {
          var r = -1,
            o = Object(t);
          i = i(t);
          for (var s = i.length; s--; ) {
            var a = i[e ? s : ++r];
            if (!1 === n(o[a], a, o)) break;
          }
          return t;
        };
      })();
    _e &&
      !Ne.call({ valueOf: 1 }, "valueOf") &&
      (x = function (e) {
        e = _e(e);
        for (var t, n = []; !(t = e.next()).done; ) n.push(t.value);
        return n;
      });
    var Ie = E("length"),
      Me = U(function (t, n) {
        return (
          Fe(t) || (t = null == t ? [] : [Object(t)]), g(n, 1), e($(t), oe)
        );
      }),
      Re = U(function (e, t, n) {
        return D(e, t, n);
      }),
      qe = U(function (e, t) {
        return h(e, 1, t);
      }),
      Be = U(function (e, t, n) {
        return h(e, We(t) || 0, n);
      }),
      Fe = Array.isArray,
      ze = Number,
      We = Number,
      Ue = L(function (e, t) {
        N(t, ie(t), e);
      }),
      Ve = L(function (e, t) {
        N(t, re(t), e);
      }),
      Xe = L(function (e, t, n, i) {
        N(t, re(t), e, i);
      }),
      Ke = U(function (e) {
        return e.push(le, p), Xe.apply(le, e);
      }),
      Ye = U(function (e, t) {
        return null == e ? {} : C(e, g(t, 1));
      }),
      Ge = w;
    (u.prototype = d(c.prototype)),
      (u.prototype.constructor = u),
      (c.assignIn = Ve),
      (c.before = W),
      (c.bind = Re),
      (c.chain = function (e) {
        return (e = c(e)), (e.__chain__ = !0), e;
      }),
      (c.compact = function (e) {
        return v(e, Boolean);
      }),
      (c.concat = Me),
      (c.create = function (e, t) {
        var n = d(e);
        return t ? Ue(n, t) : n;
      }),
      (c.defaults = Ke),
      (c.defer = qe),
      (c.delay = Be),
      (c.filter = function (e, t) {
        return v(e, w(t));
      }),
      (c.flatten = function (e) {
        return e && e.length ? g(e, 1) : [];
      }),
      (c.flattenDeep = function (e) {
        return e && e.length ? g(e, ce) : [];
      }),
      (c.iteratee = Ge),
      (c.keys = ie),
      (c.map = function (e, t) {
        return S(e, w(t));
      }),
      (c.matches = function (e) {
        return T(Ue({}, e));
      }),
      (c.mixin = ae),
      (c.negate = function (e) {
        if ("function" != typeof e) throw new TypeError("Expected a function");
        return function () {
          return !e.apply(this, arguments);
        };
      }),
      (c.once = function (e) {
        return W(2, e);
      }),
      (c.pick = Ye),
      (c.slice = function (e, t, n) {
        var i = e ? e.length : 0;
        return (n = n === le ? i : +n), i ? P(e, null == t ? 0 : +t, n) : [];
      }),
      (c.sortBy = function (e, t) {
        var n = 0;
        return (
          (t = w(t)),
          S(
            S(e, function (e, i, r) {
              return { c: e, b: n++, a: t(e, i, r) };
            }).sort(function (e, t) {
              var n;
              e: {
                n = e.a;
                var i = t.a;
                if (n !== i) {
                  var r = null === n,
                    o = n === le,
                    s = n === n,
                    a = null === i,
                    l = i === le,
                    c = i === i;
                  if ((n > i && !a) || !s || (r && !l && c) || (o && c)) {
                    n = 1;
                    break e;
                  }
                  if ((i > n && !r) || !c || (a && !o && s) || (l && s)) {
                    n = -1;
                    break e;
                  }
                }
                n = 0;
              }
              return n || e.b - t.b;
            }),
            E("c")
          )
        );
      }),
      (c.tap = function (e, t) {
        return t(e), e;
      }),
      (c.thru = function (e, t) {
        return t(e);
      }),
      (c.toArray = function (e) {
        return K(e) ? (e.length ? $(e) : []) : oe(e);
      }),
      (c.values = oe),
      (c.extend = Ve),
      ae(c, c),
      (c.clone = function (e) {
        return J(e) ? (Fe(e) ? $(e) : N(e, ie(e))) : e;
      }),
      (c.escape = function (e) {
        return (e = ne(e)) && pe.test(e) ? e.replace(ue, s) : e;
      }),
      (c.every = function (e, t, n) {
        return (t = n ? le : t), f(e, w(t));
      }),
      (c.find = B),
      (c.forEach = F),
      (c.has = function (e, t) {
        return null != e && Te.call(e, t);
      }),
      (c.head = q),
      (c.identity = se),
      (c.indexOf = function (e, t, n) {
        var i = e ? e.length : 0;
        (n = "number" == typeof n ? (0 > n ? De(i + n, 0) : n) : 0),
          (n = (n || 0) - 1);
        for (var r = t === t; ++n < i; ) {
          var o = e[n];
          if (r ? o === t : o !== o) return n;
        }
        return -1;
      }),
      (c.isArguments = X),
      (c.isArray = Fe),
      (c.isBoolean = function (e) {
        return (
          !0 === e || !1 === e || (Q(e) && "[object Boolean]" == Ee.call(e))
        );
      }),
      (c.isDate = function (e) {
        return Q(e) && "[object Date]" == Ee.call(e);
      }),
      (c.isEmpty = function (e) {
        if (K(e) && (Fe(e) || ee(e) || Y(e.splice) || X(e))) return !e.length;
        for (var t in e) if (Te.call(e, t)) return !1;
        return !0;
      }),
      (c.isEqual = function (e, t) {
        return b(e, t);
      }),
      (c.isFinite = function (e) {
        return "number" == typeof e && Le(e);
      }),
      (c.isFunction = Y),
      (c.isNaN = function (e) {
        return Z(e) && e != +e;
      }),
      (c.isNull = function (e) {
        return null === e;
      }),
      (c.isNumber = Z),
      (c.isObject = J),
      (c.isRegExp = function (e) {
        return J(e) && "[object RegExp]" == Ee.call(e);
      }),
      (c.isString = ee),
      (c.isUndefined = function (e) {
        return e === le;
      }),
      (c.last = function (e) {
        var t = e ? e.length : 0;
        return t ? e[t - 1] : le;
      }),
      (c.max = function (e) {
        return e && e.length ? t(e, se, V) : le;
      }),
      (c.min = function (e) {
        return e && e.length ? t(e, se, te) : le;
      }),
      (c.noConflict = function () {
        return we._ === this && (we._ = Pe), this;
      }),
      (c.noop = function () {}),
      (c.reduce = z),
      (c.result = function (e, t, n) {
        return (
          (t = null == e ? le : e[t]), t === le && (t = n), Y(t) ? t.call(e) : t
        );
      }),
      (c.size = function (e) {
        return null == e ? 0 : ((e = K(e) ? e : ie(e)), e.length);
      }),
      (c.some = function (e, t, n) {
        return (t = n ? le : t), _(e, w(t));
      }),
      (c.uniqueId = function (e) {
        var t = ++Ce;
        return ne(e) + t;
      }),
      (c.each = F),
      (c.first = q),
      ae(
        c,
        (function () {
          var e = {};
          return (
            m(c, function (t, n) {
              Te.call(c.prototype, n) || (e[n] = t);
            }),
            e
          );
        })(),
        { chain: !1 }
      ),
      (c.VERSION = "4.5.1"),
      je(
        "pop join replace reverse split push shift sort splice unshift".split(
          " "
        ),
        function (e) {
          var t = (/^(?:replace|split)$/.test(e) ? String.prototype : xe)[e],
            n = /^(?:push|sort|unshift)$/.test(e) ? "tap" : "thru",
            i = /^(?:pop|join|replace|shift)$/.test(e);
          c.prototype[e] = function () {
            var e = arguments;
            return i && !this.__chain__
              ? t.apply(this.value(), e)
              : this[n](function (n) {
                  return t.apply(n, e);
                });
          };
        }
      ),
      (c.prototype.toJSON =
        c.prototype.valueOf =
        c.prototype.value =
          function () {
            return A(this.__wrapped__, this.__actions__);
          }),
      ((be || ye || {})._ = c),
      "function" == typeof define && "object" == typeof define.amd && define.amd
        ? define(function () {
            return c;
          })
        : ve && ge
        ? (me && ((ge.exports = c)._ = c), (ve._ = c))
        : (we._ = c);
  }.call(this)
  /*!
   * jquery.min.js
   */,
  /*! jQuery v2.2.3 | (c) jQuery Foundation | jquery.org/license */
  !(function (e, t) {
    "object" == typeof module && "object" == typeof module.exports
      ? (module.exports = e.document
          ? t(e, !0)
          : function (e) {
              if (!e.document)
                throw new Error("jQuery requires a window with a document");
              return t(e);
            })
      : t(e);
  })("undefined" != typeof window ? window : this, function (e, t) {
    function n(e) {
      var t = !!e && "length" in e && e.length,
        n = oe.type(e);
      return (
        "function" !== n &&
        !oe.isWindow(e) &&
        ("array" === n ||
          0 === t ||
          ("number" == typeof t && t > 0 && t - 1 in e))
      );
    }
    function i(e, t, n) {
      if (oe.isFunction(t))
        return oe.grep(e, function (e, i) {
          return !!t.call(e, i, e) !== n;
        });
      if (t.nodeType)
        return oe.grep(e, function (e) {
          return (e === t) !== n;
        });
      if ("string" == typeof t) {
        if (ve.test(t)) return oe.filter(t, e, n);
        t = oe.filter(t, e);
      }
      return oe.grep(e, function (e) {
        return Z.call(t, e) > -1 !== n;
      });
    }
    function r(e, t) {
      for (; (e = e[t]) && 1 !== e.nodeType; );
      return e;
    }
    function o(e) {
      var t = {};
      return (
        oe.each(e.match(we) || [], function (e, n) {
          t[n] = !0;
        }),
        t
      );
    }
    function s() {
      Y.removeEventListener("DOMContentLoaded", s),
        e.removeEventListener("load", s),
        oe.ready();
    }
    function a() {
      this.expando = oe.expando + a.uid++;
    }
    function l(e, t, n) {
      var i;
      if (void 0 === n && 1 === e.nodeType)
        if (
          ((i = "data-" + t.replace($e, "-$&").toLowerCase()),
          (n = e.getAttribute(i)),
          "string" == typeof n)
        ) {
          try {
            n =
              "true" === n ||
              ("false" !== n &&
                ("null" === n
                  ? null
                  : +n + "" === n
                  ? +n
                  : Pe.test(n)
                  ? oe.parseJSON(n)
                  : n));
          } catch (e) {}
          Ee.set(e, t, n);
        } else n = void 0;
      return n;
    }
    function c(e, t, n, i) {
      var r,
        o = 1,
        s = 20,
        a = i
          ? function () {
              return i.cur();
            }
          : function () {
              return oe.css(e, t, "");
            },
        l = a(),
        c = (n && n[3]) || (oe.cssNumber[t] ? "" : "px"),
        u = (oe.cssNumber[t] || ("px" !== c && +l)) && Ae.exec(oe.css(e, t));
      if (u && u[3] !== c) {
        (c = c || u[3]), (n = n || []), (u = +l || 1);
        do (o = o || ".5"), (u /= o), oe.style(e, t, u + c);
        while (o !== (o = a() / l) && 1 !== o && --s);
      }
      return (
        n &&
          ((u = +u || +l || 0),
          (r = n[1] ? u + (n[1] + 1) * n[2] : +n[2]),
          i && ((i.unit = c), (i.start = u), (i.end = r))),
        r
      );
    }
    function u(e, t) {
      var n =
        "undefined" != typeof e.getElementsByTagName
          ? e.getElementsByTagName(t || "*")
          : "undefined" != typeof e.querySelectorAll
          ? e.querySelectorAll(t || "*")
          : [];
      return void 0 === t || (t && oe.nodeName(e, t)) ? oe.merge([e], n) : n;
    }
    function p(e, t) {
      for (var n = 0, i = e.length; i > n; n++)
        Ce.set(e[n], "globalEval", !t || Ce.get(t[n], "globalEval"));
    }
    function d(e, t, n, i, r) {
      for (
        var o,
          s,
          a,
          l,
          c,
          d,
          h = t.createDocumentFragment(),
          f = [],
          v = 0,
          g = e.length;
        g > v;
        v++
      )
        if (((o = e[v]), o || 0 === o))
          if ("object" === oe.type(o)) oe.merge(f, o.nodeType ? [o] : o);
          else if (Ie.test(o)) {
            for (
              s = s || h.appendChild(t.createElement("div")),
                a = (De.exec(o) || ["", ""])[1].toLowerCase(),
                l = He[a] || He._default,
                s.innerHTML = l[1] + oe.htmlPrefilter(o) + l[2],
                d = l[0];
              d--;

            )
              s = s.lastChild;
            oe.merge(f, s.childNodes), (s = h.firstChild), (s.textContent = "");
          } else f.push(t.createTextNode(o));
      for (h.textContent = "", v = 0; (o = f[v++]); )
        if (i && oe.inArray(o, i) > -1) r && r.push(o);
        else if (
          ((c = oe.contains(o.ownerDocument, o)),
          (s = u(h.appendChild(o), "script")),
          c && p(s),
          n)
        )
          for (d = 0; (o = s[d++]); ) je.test(o.type || "") && n.push(o);
      return h;
    }
    function h() {
      return !0;
    }
    function f() {
      return !1;
    }
    function v() {
      try {
        return Y.activeElement;
      } catch (e) {}
    }
    function g(e, t, n, i, r, o) {
      var s, a;
      if ("object" == typeof t) {
        "string" != typeof n && ((i = i || n), (n = void 0));
        for (a in t) g(e, a, n, i, t[a], o);
        return e;
      }
      if (
        (null == i && null == r
          ? ((r = n), (i = n = void 0))
          : null == r &&
            ("string" == typeof n
              ? ((r = i), (i = void 0))
              : ((r = i), (i = n), (n = void 0))),
        r === !1)
      )
        r = f;
      else if (!r) return e;
      return (
        1 === o &&
          ((s = r),
          (r = function (e) {
            return oe().off(e), s.apply(this, arguments);
          }),
          (r.guid = s.guid || (s.guid = oe.guid++))),
        e.each(function () {
          oe.event.add(this, t, r, i, n);
        })
      );
    }
    function m(e, t) {
      return oe.nodeName(e, "table") &&
        oe.nodeName(11 !== t.nodeType ? t : t.firstChild, "tr")
        ? e.getElementsByTagName("tbody")[0] ||
            e.appendChild(e.ownerDocument.createElement("tbody"))
        : e;
    }
    function y(e) {
      return (e.type = (null !== e.getAttribute("type")) + "/" + e.type), e;
    }
    function b(e) {
      var t = We.exec(e.type);
      return t ? (e.type = t[1]) : e.removeAttribute("type"), e;
    }
    function k(e, t) {
      var n, i, r, o, s, a, l, c;
      if (1 === t.nodeType) {
        if (
          Ce.hasData(e) &&
          ((o = Ce.access(e)), (s = Ce.set(t, o)), (c = o.events))
        ) {
          delete s.handle, (s.events = {});
          for (r in c)
            for (n = 0, i = c[r].length; i > n; n++)
              oe.event.add(t, r, c[r][n]);
        }
        Ee.hasData(e) &&
          ((a = Ee.access(e)), (l = oe.extend({}, a)), Ee.set(t, l));
      }
    }
    function w(e, t) {
      var n = t.nodeName.toLowerCase();
      "input" === n && Oe.test(e.type)
        ? (t.checked = e.checked)
        : ("input" !== n && "textarea" !== n) ||
          (t.defaultValue = e.defaultValue);
    }
    function x(e, t, n, i) {
      t = J.apply([], t);
      var r,
        o,
        s,
        a,
        l,
        c,
        p = 0,
        h = e.length,
        f = h - 1,
        v = t[0],
        g = oe.isFunction(v);
      if (g || (h > 1 && "string" == typeof v && !ie.checkClone && ze.test(v)))
        return e.each(function (r) {
          var o = e.eq(r);
          g && (t[0] = v.call(this, r, o.html())), x(o, t, n, i);
        });
      if (
        h &&
        ((r = d(t, e[0].ownerDocument, !1, e, i)),
        (o = r.firstChild),
        1 === r.childNodes.length && (r = o),
        o || i)
      ) {
        for (s = oe.map(u(r, "script"), y), a = s.length; h > p; p++)
          (l = r),
            p !== f &&
              ((l = oe.clone(l, !0, !0)), a && oe.merge(s, u(l, "script"))),
            n.call(e[p], l, p);
        if (a)
          for (
            c = s[s.length - 1].ownerDocument, oe.map(s, b), p = 0;
            a > p;
            p++
          )
            (l = s[p]),
              je.test(l.type || "") &&
                !Ce.access(l, "globalEval") &&
                oe.contains(c, l) &&
                (l.src
                  ? oe._evalUrl && oe._evalUrl(l.src)
                  : oe.globalEval(l.textContent.replace(Ue, "")));
      }
      return e;
    }
    function S(e, t, n) {
      for (var i, r = t ? oe.filter(t, e) : e, o = 0; null != (i = r[o]); o++)
        n || 1 !== i.nodeType || oe.cleanData(u(i)),
          i.parentNode &&
            (n && oe.contains(i.ownerDocument, i) && p(u(i, "script")),
            i.parentNode.removeChild(i));
      return e;
    }
    function T(e, t) {
      var n = oe(t.createElement(e)).appendTo(t.body),
        i = oe.css(n[0], "display");
      return n.detach(), i;
    }
    function C(e) {
      var t = Y,
        n = Xe[e];
      return (
        n ||
          ((n = T(e, t)),
          ("none" !== n && n) ||
            ((Ve = (
              Ve || oe("<iframe frameborder='0' width='0' height='0'/>")
            ).appendTo(t.documentElement)),
            (t = Ve[0].contentDocument),
            t.write(),
            t.close(),
            (n = T(e, t)),
            Ve.detach()),
          (Xe[e] = n)),
        n
      );
    }
    function E(e, t, n) {
      var i,
        r,
        o,
        s,
        a = e.style;
      return (
        (n = n || Ge(e)),
        (s = n ? n.getPropertyValue(t) || n[t] : void 0),
        ("" !== s && void 0 !== s) ||
          oe.contains(e.ownerDocument, e) ||
          (s = oe.style(e, t)),
        n &&
          !ie.pixelMarginRight() &&
          Ye.test(s) &&
          Ke.test(t) &&
          ((i = a.width),
          (r = a.minWidth),
          (o = a.maxWidth),
          (a.minWidth = a.maxWidth = a.width = s),
          (s = n.width),
          (a.width = i),
          (a.minWidth = r),
          (a.maxWidth = o)),
        void 0 !== s ? s + "" : s
      );
    }
    function P(e, t) {
      return {
        get: function () {
          return e()
            ? void delete this.get
            : (this.get = t).apply(this, arguments);
        },
      };
    }
    function $(e) {
      if (e in it) return e;
      for (var t = e[0].toUpperCase() + e.slice(1), n = nt.length; n--; )
        if (((e = nt[n] + t), e in it)) return e;
    }
    function _(e, t, n) {
      var i = Ae.exec(t);
      return i ? Math.max(0, i[2] - (n || 0)) + (i[3] || "px") : t;
    }
    function A(e, t, n, i, r) {
      for (
        var o = n === (i ? "border" : "content") ? 4 : "width" === t ? 1 : 0,
          s = 0;
        4 > o;
        o += 2
      )
        "margin" === n && (s += oe.css(e, n + Ne[o], !0, r)),
          i
            ? ("content" === n && (s -= oe.css(e, "padding" + Ne[o], !0, r)),
              "margin" !== n &&
                (s -= oe.css(e, "border" + Ne[o] + "Width", !0, r)))
            : ((s += oe.css(e, "padding" + Ne[o], !0, r)),
              "padding" !== n &&
                (s += oe.css(e, "border" + Ne[o] + "Width", !0, r)));
      return s;
    }
    function N(t, n, i) {
      var r = !0,
        o = "width" === n ? t.offsetWidth : t.offsetHeight,
        s = Ge(t),
        a = "border-box" === oe.css(t, "boxSizing", !1, s);
      if (
        (Y.msFullscreenElement &&
          e.top !== e &&
          t.getClientRects().length &&
          (o = Math.round(100 * t.getBoundingClientRect()[n])),
        0 >= o || null == o)
      ) {
        if (
          ((o = E(t, n, s)),
          (0 > o || null == o) && (o = t.style[n]),
          Ye.test(o))
        )
          return o;
        (r = a && (ie.boxSizingReliable() || o === t.style[n])),
          (o = parseFloat(o) || 0);
      }
      return o + A(t, n, i || (a ? "border" : "content"), r, s) + "px";
    }
    function L(e, t) {
      for (var n, i, r, o = [], s = 0, a = e.length; a > s; s++)
        (i = e[s]),
          i.style &&
            ((o[s] = Ce.get(i, "olddisplay")),
            (n = i.style.display),
            t
              ? (o[s] || "none" !== n || (i.style.display = ""),
                "" === i.style.display &&
                  Le(i) &&
                  (o[s] = Ce.access(i, "olddisplay", C(i.nodeName))))
              : ((r = Le(i)),
                ("none" === n && r) ||
                  Ce.set(i, "olddisplay", r ? n : oe.css(i, "display"))));
      for (s = 0; a > s; s++)
        (i = e[s]),
          i.style &&
            ((t && "none" !== i.style.display && "" !== i.style.display) ||
              (i.style.display = t ? o[s] || "" : "none"));
      return e;
    }
    function O(e, t, n, i, r) {
      return new O.prototype.init(e, t, n, i, r);
    }
    function D() {
      return (
        e.setTimeout(function () {
          rt = void 0;
        }),
        (rt = oe.now())
      );
    }
    function j(e, t) {
      var n,
        i = 0,
        r = { height: e };
      for (t = t ? 1 : 0; 4 > i; i += 2 - t)
        (n = Ne[i]), (r["margin" + n] = r["padding" + n] = e);
      return t && (r.opacity = r.width = e), r;
    }
    function H(e, t, n) {
      for (
        var i,
          r = (R.tweeners[t] || []).concat(R.tweeners["*"]),
          o = 0,
          s = r.length;
        s > o;
        o++
      )
        if ((i = r[o].call(n, t, e))) return i;
    }
    function I(e, t, n) {
      var i,
        r,
        o,
        s,
        a,
        l,
        c,
        u,
        p = this,
        d = {},
        h = e.style,
        f = e.nodeType && Le(e),
        v = Ce.get(e, "fxshow");
      n.queue ||
        ((a = oe._queueHooks(e, "fx")),
        null == a.unqueued &&
          ((a.unqueued = 0),
          (l = a.empty.fire),
          (a.empty.fire = function () {
            a.unqueued || l();
          })),
        a.unqueued++,
        p.always(function () {
          p.always(function () {
            a.unqueued--, oe.queue(e, "fx").length || a.empty.fire();
          });
        })),
        1 === e.nodeType &&
          ("height" in t || "width" in t) &&
          ((n.overflow = [h.overflow, h.overflowX, h.overflowY]),
          (c = oe.css(e, "display")),
          (u = "none" === c ? Ce.get(e, "olddisplay") || C(e.nodeName) : c),
          "inline" === u &&
            "none" === oe.css(e, "float") &&
            (h.display = "inline-block")),
        n.overflow &&
          ((h.overflow = "hidden"),
          p.always(function () {
            (h.overflow = n.overflow[0]),
              (h.overflowX = n.overflow[1]),
              (h.overflowY = n.overflow[2]);
          }));
      for (i in t)
        if (((r = t[i]), st.exec(r))) {
          if (
            (delete t[i],
            (o = o || "toggle" === r),
            r === (f ? "hide" : "show"))
          ) {
            if ("show" !== r || !v || void 0 === v[i]) continue;
            f = !0;
          }
          d[i] = (v && v[i]) || oe.style(e, i);
        } else c = void 0;
      if (oe.isEmptyObject(d))
        "inline" === ("none" === c ? C(e.nodeName) : c) && (h.display = c);
      else {
        v ? "hidden" in v && (f = v.hidden) : (v = Ce.access(e, "fxshow", {})),
          o && (v.hidden = !f),
          f
            ? oe(e).show()
            : p.done(function () {
                oe(e).hide();
              }),
          p.done(function () {
            var t;
            Ce.remove(e, "fxshow");
            for (t in d) oe.style(e, t, d[t]);
          });
        for (i in d)
          (s = H(f ? v[i] : 0, i, p)),
            i in v ||
              ((v[i] = s.start),
              f &&
                ((s.end = s.start),
                (s.start = "width" === i || "height" === i ? 1 : 0)));
      }
    }
    function M(e, t) {
      var n, i, r, o, s;
      for (n in e)
        if (
          ((i = oe.camelCase(n)),
          (r = t[i]),
          (o = e[n]),
          oe.isArray(o) && ((r = o[1]), (o = e[n] = o[0])),
          n !== i && ((e[i] = o), delete e[n]),
          (s = oe.cssHooks[i]),
          s && "expand" in s)
        ) {
          (o = s.expand(o)), delete e[i];
          for (n in o) n in e || ((e[n] = o[n]), (t[n] = r));
        } else t[i] = r;
    }
    function R(e, t, n) {
      var i,
        r,
        o = 0,
        s = R.prefilters.length,
        a = oe.Deferred().always(function () {
          delete l.elem;
        }),
        l = function () {
          if (r) return !1;
          for (
            var t = rt || D(),
              n = Math.max(0, c.startTime + c.duration - t),
              i = n / c.duration || 0,
              o = 1 - i,
              s = 0,
              l = c.tweens.length;
            l > s;
            s++
          )
            c.tweens[s].run(o);
          return (
            a.notifyWith(e, [c, o, n]),
            1 > o && l ? n : (a.resolveWith(e, [c]), !1)
          );
        },
        c = a.promise({
          elem: e,
          props: oe.extend({}, t),
          opts: oe.extend(
            !0,
            { specialEasing: {}, easing: oe.easing._default },
            n
          ),
          originalProperties: t,
          originalOptions: n,
          startTime: rt || D(),
          duration: n.duration,
          tweens: [],
          createTween: function (t, n) {
            var i = oe.Tween(
              e,
              c.opts,
              t,
              n,
              c.opts.specialEasing[t] || c.opts.easing
            );
            return c.tweens.push(i), i;
          },
          stop: function (t) {
            var n = 0,
              i = t ? c.tweens.length : 0;
            if (r) return this;
            for (r = !0; i > n; n++) c.tweens[n].run(1);
            return (
              t
                ? (a.notifyWith(e, [c, 1, 0]), a.resolveWith(e, [c, t]))
                : a.rejectWith(e, [c, t]),
              this
            );
          },
        }),
        u = c.props;
      for (M(u, c.opts.specialEasing); s > o; o++)
        if ((i = R.prefilters[o].call(c, e, u, c.opts)))
          return (
            oe.isFunction(i.stop) &&
              (oe._queueHooks(c.elem, c.opts.queue).stop = oe.proxy(i.stop, i)),
            i
          );
      return (
        oe.map(u, H, c),
        oe.isFunction(c.opts.start) && c.opts.start.call(e, c),
        oe.fx.timer(oe.extend(l, { elem: e, anim: c, queue: c.opts.queue })),
        c
          .progress(c.opts.progress)
          .done(c.opts.done, c.opts.complete)
          .fail(c.opts.fail)
          .always(c.opts.always)
      );
    }
    function q(e) {
      return (e.getAttribute && e.getAttribute("class")) || "";
    }
    function B(e) {
      return function (t, n) {
        "string" != typeof t && ((n = t), (t = "*"));
        var i,
          r = 0,
          o = t.toLowerCase().match(we) || [];
        if (oe.isFunction(n))
          for (; (i = o[r++]); )
            "+" === i[0]
              ? ((i = i.slice(1) || "*"), (e[i] = e[i] || []).unshift(n))
              : (e[i] = e[i] || []).push(n);
      };
    }
    function F(e, t, n, i) {
      function r(a) {
        var l;
        return (
          (o[a] = !0),
          oe.each(e[a] || [], function (e, a) {
            var c = a(t, n, i);
            return "string" != typeof c || s || o[c]
              ? s
                ? !(l = c)
                : void 0
              : (t.dataTypes.unshift(c), r(c), !1);
          }),
          l
        );
      }
      var o = {},
        s = e === Et;
      return r(t.dataTypes[0]) || (!o["*"] && r("*"));
    }
    function z(e, t) {
      var n,
        i,
        r = oe.ajaxSettings.flatOptions || {};
      for (n in t) void 0 !== t[n] && ((r[n] ? e : i || (i = {}))[n] = t[n]);
      return i && oe.extend(!0, e, i), e;
    }
    function W(e, t, n) {
      for (var i, r, o, s, a = e.contents, l = e.dataTypes; "*" === l[0]; )
        l.shift(),
          void 0 === i &&
            (i = e.mimeType || t.getResponseHeader("Content-Type"));
      if (i)
        for (r in a)
          if (a[r] && a[r].test(i)) {
            l.unshift(r);
            break;
          }
      if (l[0] in n) o = l[0];
      else {
        for (r in n) {
          if (!l[0] || e.converters[r + " " + l[0]]) {
            o = r;
            break;
          }
          s || (s = r);
        }
        o = o || s;
      }
      return o ? (o !== l[0] && l.unshift(o), n[o]) : void 0;
    }
    function U(e, t, n, i) {
      var r,
        o,
        s,
        a,
        l,
        c = {},
        u = e.dataTypes.slice();
      if (u[1]) for (s in e.converters) c[s.toLowerCase()] = e.converters[s];
      for (o = u.shift(); o; )
        if (
          (e.responseFields[o] && (n[e.responseFields[o]] = t),
          !l && i && e.dataFilter && (t = e.dataFilter(t, e.dataType)),
          (l = o),
          (o = u.shift()))
        )
          if ("*" === o) o = l;
          else if ("*" !== l && l !== o) {
            if (((s = c[l + " " + o] || c["* " + o]), !s))
              for (r in c)
                if (
                  ((a = r.split(" ")),
                  a[1] === o && (s = c[l + " " + a[0]] || c["* " + a[0]]))
                ) {
                  s === !0
                    ? (s = c[r])
                    : c[r] !== !0 && ((o = a[0]), u.unshift(a[1]));
                  break;
                }
            if (s !== !0)
              if (s && e.throws) t = s(t);
              else
                try {
                  t = s(t);
                } catch (e) {
                  return {
                    state: "parsererror",
                    error: s ? e : "No conversion from " + l + " to " + o,
                  };
                }
          }
      return { state: "success", data: t };
    }
    function V(e, t, n, i) {
      var r;
      if (oe.isArray(t))
        oe.each(t, function (t, r) {
          n || At.test(e)
            ? i(e, r)
            : V(
                e + "[" + ("object" == typeof r && null != r ? t : "") + "]",
                r,
                n,
                i
              );
        });
      else if (n || "object" !== oe.type(t)) i(e, t);
      else for (r in t) V(e + "[" + r + "]", t[r], n, i);
    }
    function X(e) {
      return oe.isWindow(e) ? e : 9 === e.nodeType && e.defaultView;
    }
    var K = [],
      Y = e.document,
      G = K.slice,
      J = K.concat,
      Q = K.push,
      Z = K.indexOf,
      ee = {},
      te = ee.toString,
      ne = ee.hasOwnProperty,
      ie = {},
      re = "2.2.3",
      oe = function (e, t) {
        return new oe.fn.init(e, t);
      },
      se = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
      ae = /^-ms-/,
      le = /-([\da-z])/gi,
      ce = function (e, t) {
        return t.toUpperCase();
      };
    (oe.fn = oe.prototype =
      {
        jquery: re,
        constructor: oe,
        selector: "",
        length: 0,
        toArray: function () {
          return G.call(this);
        },
        get: function (e) {
          return null != e
            ? 0 > e
              ? this[e + this.length]
              : this[e]
            : G.call(this);
        },
        pushStack: function (e) {
          var t = oe.merge(this.constructor(), e);
          return (t.prevObject = this), (t.context = this.context), t;
        },
        each: function (e) {
          return oe.each(this, e);
        },
        map: function (e) {
          return this.pushStack(
            oe.map(this, function (t, n) {
              return e.call(t, n, t);
            })
          );
        },
        slice: function () {
          return this.pushStack(G.apply(this, arguments));
        },
        first: function () {
          return this.eq(0);
        },
        last: function () {
          return this.eq(-1);
        },
        eq: function (e) {
          var t = this.length,
            n = +e + (0 > e ? t : 0);
          return this.pushStack(n >= 0 && t > n ? [this[n]] : []);
        },
        end: function () {
          return this.prevObject || this.constructor();
        },
        push: Q,
        sort: K.sort,
        splice: K.splice,
      }),
      (oe.extend = oe.fn.extend =
        function () {
          var e,
            t,
            n,
            i,
            r,
            o,
            s = arguments[0] || {},
            a = 1,
            l = arguments.length,
            c = !1;
          for (
            "boolean" == typeof s && ((c = s), (s = arguments[a] || {}), a++),
              "object" == typeof s || oe.isFunction(s) || (s = {}),
              a === l && ((s = this), a--);
            l > a;
            a++
          )
            if (null != (e = arguments[a]))
              for (t in e)
                (n = s[t]),
                  (i = e[t]),
                  s !== i &&
                    (c && i && (oe.isPlainObject(i) || (r = oe.isArray(i)))
                      ? (r
                          ? ((r = !1), (o = n && oe.isArray(n) ? n : []))
                          : (o = n && oe.isPlainObject(n) ? n : {}),
                        (s[t] = oe.extend(c, o, i)))
                      : void 0 !== i && (s[t] = i));
          return s;
        }),
      oe.extend({
        expando: "jQuery" + (re + Math.random()).replace(/\D/g, ""),
        isReady: !0,
        error: function (e) {
          throw new Error(e);
        },
        noop: function () {},
        isFunction: function (e) {
          return "function" === oe.type(e);
        },
        isArray: Array.isArray,
        isWindow: function (e) {
          return null != e && e === e.window;
        },
        isNumeric: function (e) {
          var t = e && e.toString();
          return !oe.isArray(e) && t - parseFloat(t) + 1 >= 0;
        },
        isPlainObject: function (e) {
          var t;
          if ("object" !== oe.type(e) || e.nodeType || oe.isWindow(e))
            return !1;
          if (
            e.constructor &&
            !ne.call(e, "constructor") &&
            !ne.call(e.constructor.prototype || {}, "isPrototypeOf")
          )
            return !1;
          for (t in e);
          return void 0 === t || ne.call(e, t);
        },
        isEmptyObject: function (e) {
          var t;
          for (t in e) return !1;
          return !0;
        },
        type: function (e) {
          return null == e
            ? e + ""
            : "object" == typeof e || "function" == typeof e
            ? ee[te.call(e)] || "object"
            : typeof e;
        },
        globalEval: function (e) {
          var t,
            n = eval;
          (e = oe.trim(e)),
            e &&
              (1 === e.indexOf("use strict")
                ? ((t = Y.createElement("script")),
                  (t.text = e),
                  Y.head.appendChild(t).parentNode.removeChild(t))
                : n(e));
        },
        camelCase: function (e) {
          return e.replace(ae, "ms-").replace(le, ce);
        },
        nodeName: function (e, t) {
          return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase();
        },
        each: function (e, t) {
          var i,
            r = 0;
          if (n(e))
            for (i = e.length; i > r && t.call(e[r], r, e[r]) !== !1; r++);
          else for (r in e) if (t.call(e[r], r, e[r]) === !1) break;
          return e;
        },
        trim: function (e) {
          return null == e ? "" : (e + "").replace(se, "");
        },
        makeArray: function (e, t) {
          var i = t || [];
          return (
            null != e &&
              (n(Object(e))
                ? oe.merge(i, "string" == typeof e ? [e] : e)
                : Q.call(i, e)),
            i
          );
        },
        inArray: function (e, t, n) {
          return null == t ? -1 : Z.call(t, e, n);
        },
        merge: function (e, t) {
          for (var n = +t.length, i = 0, r = e.length; n > i; i++)
            e[r++] = t[i];
          return (e.length = r), e;
        },
        grep: function (e, t, n) {
          for (var i, r = [], o = 0, s = e.length, a = !n; s > o; o++)
            (i = !t(e[o], o)), i !== a && r.push(e[o]);
          return r;
        },
        map: function (e, t, i) {
          var r,
            o,
            s = 0,
            a = [];
          if (n(e))
            for (r = e.length; r > s; s++)
              (o = t(e[s], s, i)), null != o && a.push(o);
          else for (s in e) (o = t(e[s], s, i)), null != o && a.push(o);
          return J.apply([], a);
        },
        guid: 1,
        proxy: function (e, t) {
          var n, i, r;
          return (
            "string" == typeof t && ((n = e[t]), (t = e), (e = n)),
            oe.isFunction(e)
              ? ((i = G.call(arguments, 2)),
                (r = function () {
                  return e.apply(t || this, i.concat(G.call(arguments)));
                }),
                (r.guid = e.guid = e.guid || oe.guid++),
                r)
              : void 0
          );
        },
        now: Date.now,
        support: ie,
      }),
      "function" == typeof Symbol &&
        (oe.fn[Symbol.iterator] = K[Symbol.iterator]),
      oe.each(
        "Boolean Number String Function Array Date RegExp Object Error Symbol".split(
          " "
        ),
        function (e, t) {
          ee["[object " + t + "]"] = t.toLowerCase();
        }
      );
    var ue = (function (e) {
      function t(e, t, n, i) {
        var r,
          o,
          s,
          a,
          l,
          c,
          p,
          h,
          f = t && t.ownerDocument,
          v = t ? t.nodeType : 9;
        if (
          ((n = n || []),
          "string" != typeof e || !e || (1 !== v && 9 !== v && 11 !== v))
        )
          return n;
        if (
          !i &&
          ((t ? t.ownerDocument || t : q) !== L && N(t), (t = t || L), D)
        ) {
          if (11 !== v && (c = me.exec(e)))
            if ((r = c[1])) {
              if (9 === v) {
                if (!(s = t.getElementById(r))) return n;
                if (s.id === r) return n.push(s), n;
              } else if (
                f &&
                (s = f.getElementById(r)) &&
                M(t, s) &&
                s.id === r
              )
                return n.push(s), n;
            } else {
              if (c[2]) return Q.apply(n, t.getElementsByTagName(e)), n;
              if (
                (r = c[3]) &&
                w.getElementsByClassName &&
                t.getElementsByClassName
              )
                return Q.apply(n, t.getElementsByClassName(r)), n;
            }
          if (w.qsa && !U[e + " "] && (!j || !j.test(e))) {
            if (1 !== v) (f = t), (h = e);
            else if ("object" !== t.nodeName.toLowerCase()) {
              for (
                (a = t.getAttribute("id"))
                  ? (a = a.replace(be, "\\$&"))
                  : t.setAttribute("id", (a = R)),
                  p = C(e),
                  o = p.length,
                  l = de.test(a) ? "#" + a : "[id='" + a + "']";
                o--;

              )
                p[o] = l + " " + d(p[o]);
              (h = p.join(",")), (f = (ye.test(e) && u(t.parentNode)) || t);
            }
            if (h)
              try {
                return Q.apply(n, f.querySelectorAll(h)), n;
              } catch (e) {
              } finally {
                a === R && t.removeAttribute("id");
              }
          }
        }
        return P(e.replace(ae, "$1"), t, n, i);
      }
      function n() {
        function e(n, i) {
          return (
            t.push(n + " ") > x.cacheLength && delete e[t.shift()],
            (e[n + " "] = i)
          );
        }
        var t = [];
        return e;
      }
      function i(e) {
        return (e[R] = !0), e;
      }
      function r(e) {
        var t = L.createElement("div");
        try {
          return !!e(t);
        } catch (e) {
          return !1;
        } finally {
          t.parentNode && t.parentNode.removeChild(t), (t = null);
        }
      }
      function o(e, t) {
        for (var n = e.split("|"), i = n.length; i--; ) x.attrHandle[n[i]] = t;
      }
      function s(e, t) {
        var n = t && e,
          i =
            n &&
            1 === e.nodeType &&
            1 === t.nodeType &&
            (~t.sourceIndex || X) - (~e.sourceIndex || X);
        if (i) return i;
        if (n) for (; (n = n.nextSibling); ) if (n === t) return -1;
        return e ? 1 : -1;
      }
      function a(e) {
        return function (t) {
          var n = t.nodeName.toLowerCase();
          return "input" === n && t.type === e;
        };
      }
      function l(e) {
        return function (t) {
          var n = t.nodeName.toLowerCase();
          return ("input" === n || "button" === n) && t.type === e;
        };
      }
      function c(e) {
        return i(function (t) {
          return (
            (t = +t),
            i(function (n, i) {
              for (var r, o = e([], n.length, t), s = o.length; s--; )
                n[(r = o[s])] && (n[r] = !(i[r] = n[r]));
            })
          );
        });
      }
      function u(e) {
        return e && "undefined" != typeof e.getElementsByTagName && e;
      }
      function p() {}
      function d(e) {
        for (var t = 0, n = e.length, i = ""; n > t; t++) i += e[t].value;
        return i;
      }
      function h(e, t, n) {
        var i = t.dir,
          r = n && "parentNode" === i,
          o = F++;
        return t.first
          ? function (t, n, o) {
              for (; (t = t[i]); ) if (1 === t.nodeType || r) return e(t, n, o);
            }
          : function (t, n, s) {
              var a,
                l,
                c,
                u = [B, o];
              if (s) {
                for (; (t = t[i]); )
                  if ((1 === t.nodeType || r) && e(t, n, s)) return !0;
              } else
                for (; (t = t[i]); )
                  if (1 === t.nodeType || r) {
                    if (
                      ((c = t[R] || (t[R] = {})),
                      (l = c[t.uniqueID] || (c[t.uniqueID] = {})),
                      (a = l[i]) && a[0] === B && a[1] === o)
                    )
                      return (u[2] = a[2]);
                    if (((l[i] = u), (u[2] = e(t, n, s)))) return !0;
                  }
            };
      }
      function f(e) {
        return e.length > 1
          ? function (t, n, i) {
              for (var r = e.length; r--; ) if (!e[r](t, n, i)) return !1;
              return !0;
            }
          : e[0];
      }
      function v(e, n, i) {
        for (var r = 0, o = n.length; o > r; r++) t(e, n[r], i);
        return i;
      }
      function g(e, t, n, i, r) {
        for (var o, s = [], a = 0, l = e.length, c = null != t; l > a; a++)
          (o = e[a]) && ((n && !n(o, i, r)) || (s.push(o), c && t.push(a)));
        return s;
      }
      function m(e, t, n, r, o, s) {
        return (
          r && !r[R] && (r = m(r)),
          o && !o[R] && (o = m(o, s)),
          i(function (i, s, a, l) {
            var c,
              u,
              p,
              d = [],
              h = [],
              f = s.length,
              m = i || v(t || "*", a.nodeType ? [a] : a, []),
              y = !e || (!i && t) ? m : g(m, d, e, a, l),
              b = n ? (o || (i ? e : f || r) ? [] : s) : y;
            if ((n && n(y, b, a, l), r))
              for (c = g(b, h), r(c, [], a, l), u = c.length; u--; )
                (p = c[u]) && (b[h[u]] = !(y[h[u]] = p));
            if (i) {
              if (o || e) {
                if (o) {
                  for (c = [], u = b.length; u--; )
                    (p = b[u]) && c.push((y[u] = p));
                  o(null, (b = []), c, l);
                }
                for (u = b.length; u--; )
                  (p = b[u]) &&
                    (c = o ? ee(i, p) : d[u]) > -1 &&
                    (i[c] = !(s[c] = p));
              }
            } else (b = g(b === s ? b.splice(f, b.length) : b)), o ? o(null, s, b, l) : Q.apply(s, b);
          })
        );
      }
      function y(e) {
        for (
          var t,
            n,
            i,
            r = e.length,
            o = x.relative[e[0].type],
            s = o || x.relative[" "],
            a = o ? 1 : 0,
            l = h(
              function (e) {
                return e === t;
              },
              s,
              !0
            ),
            c = h(
              function (e) {
                return ee(t, e) > -1;
              },
              s,
              !0
            ),
            u = [
              function (e, n, i) {
                var r =
                  (!o && (i || n !== $)) ||
                  ((t = n).nodeType ? l(e, n, i) : c(e, n, i));
                return (t = null), r;
              },
            ];
          r > a;
          a++
        )
          if ((n = x.relative[e[a].type])) u = [h(f(u), n)];
          else {
            if (((n = x.filter[e[a].type].apply(null, e[a].matches)), n[R])) {
              for (i = ++a; r > i && !x.relative[e[i].type]; i++);
              return m(
                a > 1 && f(u),
                a > 1 &&
                  d(
                    e
                      .slice(0, a - 1)
                      .concat({ value: " " === e[a - 2].type ? "*" : "" })
                  ).replace(ae, "$1"),
                n,
                i > a && y(e.slice(a, i)),
                r > i && y((e = e.slice(i))),
                r > i && d(e)
              );
            }
            u.push(n);
          }
        return f(u);
      }
      function b(e, n) {
        var r = n.length > 0,
          o = e.length > 0,
          s = function (i, s, a, l, c) {
            var u,
              p,
              d,
              h = 0,
              f = "0",
              v = i && [],
              m = [],
              y = $,
              b = i || (o && x.find.TAG("*", c)),
              k = (B += null == y ? 1 : Math.random() || 0.1),
              w = b.length;
            for (
              c && ($ = s === L || s || c);
              f !== w && null != (u = b[f]);
              f++
            ) {
              if (o && u) {
                for (
                  p = 0, s || u.ownerDocument === L || (N(u), (a = !D));
                  (d = e[p++]);

                )
                  if (d(u, s || L, a)) {
                    l.push(u);
                    break;
                  }
                c && (B = k);
              }
              r && ((u = !d && u) && h--, i && v.push(u));
            }
            if (((h += f), r && f !== h)) {
              for (p = 0; (d = n[p++]); ) d(v, m, s, a);
              if (i) {
                if (h > 0) for (; f--; ) v[f] || m[f] || (m[f] = G.call(l));
                m = g(m);
              }
              Q.apply(l, m),
                c && !i && m.length > 0 && h + n.length > 1 && t.uniqueSort(l);
            }
            return c && ((B = k), ($ = y)), v;
          };
        return r ? i(s) : s;
      }
      var k,
        w,
        x,
        S,
        T,
        C,
        E,
        P,
        $,
        _,
        A,
        N,
        L,
        O,
        D,
        j,
        H,
        I,
        M,
        R = "sizzle" + 1 * new Date(),
        q = e.document,
        B = 0,
        F = 0,
        z = n(),
        W = n(),
        U = n(),
        V = function (e, t) {
          return e === t && (A = !0), 0;
        },
        X = 1 << 31,
        K = {}.hasOwnProperty,
        Y = [],
        G = Y.pop,
        J = Y.push,
        Q = Y.push,
        Z = Y.slice,
        ee = function (e, t) {
          for (var n = 0, i = e.length; i > n; n++) if (e[n] === t) return n;
          return -1;
        },
        te =
          "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
        ne = "[\\x20\\t\\r\\n\\f]",
        ie = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
        re =
          "\\[" +
          ne +
          "*(" +
          ie +
          ")(?:" +
          ne +
          "*([*^$|!~]?=)" +
          ne +
          "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" +
          ie +
          "))|)" +
          ne +
          "*\\]",
        oe =
          ":(" +
          ie +
          ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" +
          re +
          ")*)|.*)\\)|)",
        se = new RegExp(ne + "+", "g"),
        ae = new RegExp(
          "^" + ne + "+|((?:^|[^\\\\])(?:\\\\.)*)" + ne + "+$",
          "g"
        ),
        le = new RegExp("^" + ne + "*," + ne + "*"),
        ce = new RegExp("^" + ne + "*([>+~]|" + ne + ")" + ne + "*"),
        ue = new RegExp("=" + ne + "*([^\\]'\"]*?)" + ne + "*\\]", "g"),
        pe = new RegExp(oe),
        de = new RegExp("^" + ie + "$"),
        he = {
          ID: new RegExp("^#(" + ie + ")"),
          CLASS: new RegExp("^\\.(" + ie + ")"),
          TAG: new RegExp("^(" + ie + "|[*])"),
          ATTR: new RegExp("^" + re),
          PSEUDO: new RegExp("^" + oe),
          CHILD: new RegExp(
            "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
              ne +
              "*(even|odd|(([+-]|)(\\d*)n|)" +
              ne +
              "*(?:([+-]|)" +
              ne +
              "*(\\d+)|))" +
              ne +
              "*\\)|)",
            "i"
          ),
          bool: new RegExp("^(?:" + te + ")$", "i"),
          needsContext: new RegExp(
            "^" +
              ne +
              "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
              ne +
              "*((?:-\\d)?\\d*)" +
              ne +
              "*\\)|)(?=[^-]|$)",
            "i"
          ),
        },
        fe = /^(?:input|select|textarea|button)$/i,
        ve = /^h\d$/i,
        ge = /^[^{]+\{\s*\[native \w/,
        me = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
        ye = /[+~]/,
        be = /'|\\/g,
        ke = new RegExp("\\\\([\\da-f]{1,6}" + ne + "?|(" + ne + ")|.)", "ig"),
        we = function (e, t, n) {
          var i = "0x" + t - 65536;
          return i !== i || n
            ? t
            : 0 > i
            ? String.fromCharCode(i + 65536)
            : String.fromCharCode((i >> 10) | 55296, (1023 & i) | 56320);
        },
        xe = function () {
          N();
        };
      try {
        Q.apply((Y = Z.call(q.childNodes)), q.childNodes),
          Y[q.childNodes.length].nodeType;
      } catch (e) {
        Q = {
          apply: Y.length
            ? function (e, t) {
                J.apply(e, Z.call(t));
              }
            : function (e, t) {
                for (var n = e.length, i = 0; (e[n++] = t[i++]); );
                e.length = n - 1;
              },
        };
      }
      (w = t.support = {}),
        (T = t.isXML =
          function (e) {
            var t = e && (e.ownerDocument || e).documentElement;
            return !!t && "HTML" !== t.nodeName;
          }),
        (N = t.setDocument =
          function (e) {
            var t,
              n,
              i = e ? e.ownerDocument || e : q;
            return i !== L && 9 === i.nodeType && i.documentElement
              ? ((L = i),
                (O = L.documentElement),
                (D = !T(L)),
                (n = L.defaultView) &&
                  n.top !== n &&
                  (n.addEventListener
                    ? n.addEventListener("unload", xe, !1)
                    : n.attachEvent && n.attachEvent("onunload", xe)),
                (w.attributes = r(function (e) {
                  return (e.className = "i"), !e.getAttribute("className");
                })),
                (w.getElementsByTagName = r(function (e) {
                  return (
                    e.appendChild(L.createComment("")),
                    !e.getElementsByTagName("*").length
                  );
                })),
                (w.getElementsByClassName = ge.test(L.getElementsByClassName)),
                (w.getById = r(function (e) {
                  return (
                    (O.appendChild(e).id = R),
                    !L.getElementsByName || !L.getElementsByName(R).length
                  );
                })),
                w.getById
                  ? ((x.find.ID = function (e, t) {
                      if ("undefined" != typeof t.getElementById && D) {
                        var n = t.getElementById(e);
                        return n ? [n] : [];
                      }
                    }),
                    (x.filter.ID = function (e) {
                      var t = e.replace(ke, we);
                      return function (e) {
                        return e.getAttribute("id") === t;
                      };
                    }))
                  : (delete x.find.ID,
                    (x.filter.ID = function (e) {
                      var t = e.replace(ke, we);
                      return function (e) {
                        var n =
                          "undefined" != typeof e.getAttributeNode &&
                          e.getAttributeNode("id");
                        return n && n.value === t;
                      };
                    })),
                (x.find.TAG = w.getElementsByTagName
                  ? function (e, t) {
                      return "undefined" != typeof t.getElementsByTagName
                        ? t.getElementsByTagName(e)
                        : w.qsa
                        ? t.querySelectorAll(e)
                        : void 0;
                    }
                  : function (e, t) {
                      var n,
                        i = [],
                        r = 0,
                        o = t.getElementsByTagName(e);
                      if ("*" === e) {
                        for (; (n = o[r++]); ) 1 === n.nodeType && i.push(n);
                        return i;
                      }
                      return o;
                    }),
                (x.find.CLASS =
                  w.getElementsByClassName &&
                  function (e, t) {
                    return "undefined" != typeof t.getElementsByClassName && D
                      ? t.getElementsByClassName(e)
                      : void 0;
                  }),
                (H = []),
                (j = []),
                (w.qsa = ge.test(L.querySelectorAll)) &&
                  (r(function (e) {
                    (O.appendChild(e).innerHTML =
                      "<a id='" +
                      R +
                      "'></a><select id='" +
                      R +
                      "-\r\\' msallowcapture=''><option selected=''></option></select>"),
                      e.querySelectorAll("[msallowcapture^='']").length &&
                        j.push("[*^$]=" + ne + "*(?:''|\"\")"),
                      e.querySelectorAll("[selected]").length ||
                        j.push("\\[" + ne + "*(?:value|" + te + ")"),
                      e.querySelectorAll("[id~=" + R + "-]").length ||
                        j.push("~="),
                      e.querySelectorAll(":checked").length ||
                        j.push(":checked"),
                      e.querySelectorAll("a#" + R + "+*").length ||
                        j.push(".#.+[+~]");
                  }),
                  r(function (e) {
                    var t = L.createElement("input");
                    t.setAttribute("type", "hidden"),
                      e.appendChild(t).setAttribute("name", "D"),
                      e.querySelectorAll("[name=d]").length &&
                        j.push("name" + ne + "*[*^$|!~]?="),
                      e.querySelectorAll(":enabled").length ||
                        j.push(":enabled", ":disabled"),
                      e.querySelectorAll("*,:x"),
                      j.push(",.*:");
                  })),
                (w.matchesSelector = ge.test(
                  (I =
                    O.matches ||
                    O.webkitMatchesSelector ||
                    O.mozMatchesSelector ||
                    O.oMatchesSelector ||
                    O.msMatchesSelector)
                )) &&
                  r(function (e) {
                    (w.disconnectedMatch = I.call(e, "div")),
                      I.call(e, "[s!='']:x"),
                      H.push("!=", oe);
                  }),
                (j = j.length && new RegExp(j.join("|"))),
                (H = H.length && new RegExp(H.join("|"))),
                (t = ge.test(O.compareDocumentPosition)),
                (M =
                  t || ge.test(O.contains)
                    ? function (e, t) {
                        var n = 9 === e.nodeType ? e.documentElement : e,
                          i = t && t.parentNode;
                        return (
                          e === i ||
                          !(
                            !i ||
                            1 !== i.nodeType ||
                            !(n.contains
                              ? n.contains(i)
                              : e.compareDocumentPosition &&
                                16 & e.compareDocumentPosition(i))
                          )
                        );
                      }
                    : function (e, t) {
                        if (t)
                          for (; (t = t.parentNode); ) if (t === e) return !0;
                        return !1;
                      }),
                (V = t
                  ? function (e, t) {
                      if (e === t) return (A = !0), 0;
                      var n =
                        !e.compareDocumentPosition - !t.compareDocumentPosition;
                      return n
                        ? n
                        : ((n =
                            (e.ownerDocument || e) === (t.ownerDocument || t)
                              ? e.compareDocumentPosition(t)
                              : 1),
                          1 & n ||
                          (!w.sortDetached &&
                            t.compareDocumentPosition(e) === n)
                            ? e === L || (e.ownerDocument === q && M(q, e))
                              ? -1
                              : t === L || (t.ownerDocument === q && M(q, t))
                              ? 1
                              : _
                              ? ee(_, e) - ee(_, t)
                              : 0
                            : 4 & n
                            ? -1
                            : 1);
                    }
                  : function (e, t) {
                      if (e === t) return (A = !0), 0;
                      var n,
                        i = 0,
                        r = e.parentNode,
                        o = t.parentNode,
                        a = [e],
                        l = [t];
                      if (!r || !o)
                        return e === L
                          ? -1
                          : t === L
                          ? 1
                          : r
                          ? -1
                          : o
                          ? 1
                          : _
                          ? ee(_, e) - ee(_, t)
                          : 0;
                      if (r === o) return s(e, t);
                      for (n = e; (n = n.parentNode); ) a.unshift(n);
                      for (n = t; (n = n.parentNode); ) l.unshift(n);
                      for (; a[i] === l[i]; ) i++;
                      return i
                        ? s(a[i], l[i])
                        : a[i] === q
                        ? -1
                        : l[i] === q
                        ? 1
                        : 0;
                    }),
                L)
              : L;
          }),
        (t.matches = function (e, n) {
          return t(e, null, null, n);
        }),
        (t.matchesSelector = function (e, n) {
          if (
            ((e.ownerDocument || e) !== L && N(e),
            (n = n.replace(ue, "='$1']")),
            w.matchesSelector &&
              D &&
              !U[n + " "] &&
              (!H || !H.test(n)) &&
              (!j || !j.test(n)))
          )
            try {
              var i = I.call(e, n);
              if (
                i ||
                w.disconnectedMatch ||
                (e.document && 11 !== e.document.nodeType)
              )
                return i;
            } catch (e) {}
          return t(n, L, null, [e]).length > 0;
        }),
        (t.contains = function (e, t) {
          return (e.ownerDocument || e) !== L && N(e), M(e, t);
        }),
        (t.attr = function (e, t) {
          (e.ownerDocument || e) !== L && N(e);
          var n = x.attrHandle[t.toLowerCase()],
            i =
              n && K.call(x.attrHandle, t.toLowerCase()) ? n(e, t, !D) : void 0;
          return void 0 !== i
            ? i
            : w.attributes || !D
            ? e.getAttribute(t)
            : (i = e.getAttributeNode(t)) && i.specified
            ? i.value
            : null;
        }),
        (t.error = function (e) {
          throw new Error("Syntax error, unrecognized expression: " + e);
        }),
        (t.uniqueSort = function (e) {
          var t,
            n = [],
            i = 0,
            r = 0;
          if (
            ((A = !w.detectDuplicates),
            (_ = !w.sortStable && e.slice(0)),
            e.sort(V),
            A)
          ) {
            for (; (t = e[r++]); ) t === e[r] && (i = n.push(r));
            for (; i--; ) e.splice(n[i], 1);
          }
          return (_ = null), e;
        }),
        (S = t.getText =
          function (e) {
            var t,
              n = "",
              i = 0,
              r = e.nodeType;
            if (r) {
              if (1 === r || 9 === r || 11 === r) {
                if ("string" == typeof e.textContent) return e.textContent;
                for (e = e.firstChild; e; e = e.nextSibling) n += S(e);
              } else if (3 === r || 4 === r) return e.nodeValue;
            } else for (; (t = e[i++]); ) n += S(t);
            return n;
          }),
        (x = t.selectors =
          {
            cacheLength: 50,
            createPseudo: i,
            match: he,
            attrHandle: {},
            find: {},
            relative: {
              ">": { dir: "parentNode", first: !0 },
              " ": { dir: "parentNode" },
              "+": { dir: "previousSibling", first: !0 },
              "~": { dir: "previousSibling" },
            },
            preFilter: {
              ATTR: function (e) {
                return (
                  (e[1] = e[1].replace(ke, we)),
                  (e[3] = (e[3] || e[4] || e[5] || "").replace(ke, we)),
                  "~=" === e[2] && (e[3] = " " + e[3] + " "),
                  e.slice(0, 4)
                );
              },
              CHILD: function (e) {
                return (
                  (e[1] = e[1].toLowerCase()),
                  "nth" === e[1].slice(0, 3)
                    ? (e[3] || t.error(e[0]),
                      (e[4] = +(e[4]
                        ? e[5] + (e[6] || 1)
                        : 2 * ("even" === e[3] || "odd" === e[3]))),
                      (e[5] = +(e[7] + e[8] || "odd" === e[3])))
                    : e[3] && t.error(e[0]),
                  e
                );
              },
              PSEUDO: function (e) {
                var t,
                  n = !e[6] && e[2];
                return he.CHILD.test(e[0])
                  ? null
                  : (e[3]
                      ? (e[2] = e[4] || e[5] || "")
                      : n &&
                        pe.test(n) &&
                        (t = C(n, !0)) &&
                        (t = n.indexOf(")", n.length - t) - n.length) &&
                        ((e[0] = e[0].slice(0, t)), (e[2] = n.slice(0, t))),
                    e.slice(0, 3));
              },
            },
            filter: {
              TAG: function (e) {
                var t = e.replace(ke, we).toLowerCase();
                return "*" === e
                  ? function () {
                      return !0;
                    }
                  : function (e) {
                      return e.nodeName && e.nodeName.toLowerCase() === t;
                    };
              },
              CLASS: function (e) {
                var t = z[e + " "];
                return (
                  t ||
                  ((t = new RegExp("(^|" + ne + ")" + e + "(" + ne + "|$)")) &&
                    z(e, function (e) {
                      return t.test(
                        ("string" == typeof e.className && e.className) ||
                          ("undefined" != typeof e.getAttribute &&
                            e.getAttribute("class")) ||
                          ""
                      );
                    }))
                );
              },
              ATTR: function (e, n, i) {
                return function (r) {
                  var o = t.attr(r, e);
                  return null == o
                    ? "!=" === n
                    : !n ||
                        ((o += ""),
                        "=" === n
                          ? o === i
                          : "!=" === n
                          ? o !== i
                          : "^=" === n
                          ? i && 0 === o.indexOf(i)
                          : "*=" === n
                          ? i && o.indexOf(i) > -1
                          : "$=" === n
                          ? i && o.slice(-i.length) === i
                          : "~=" === n
                          ? (" " + o.replace(se, " ") + " ").indexOf(i) > -1
                          : "|=" === n &&
                            (o === i || o.slice(0, i.length + 1) === i + "-"));
                };
              },
              CHILD: function (e, t, n, i, r) {
                var o = "nth" !== e.slice(0, 3),
                  s = "last" !== e.slice(-4),
                  a = "of-type" === t;
                return 1 === i && 0 === r
                  ? function (e) {
                      return !!e.parentNode;
                    }
                  : function (t, n, l) {
                      var c,
                        u,
                        p,
                        d,
                        h,
                        f,
                        v = o !== s ? "nextSibling" : "previousSibling",
                        g = t.parentNode,
                        m = a && t.nodeName.toLowerCase(),
                        y = !l && !a,
                        b = !1;
                      if (g) {
                        if (o) {
                          for (; v; ) {
                            for (d = t; (d = d[v]); )
                              if (
                                a
                                  ? d.nodeName.toLowerCase() === m
                                  : 1 === d.nodeType
                              )
                                return !1;
                            f = v = "only" === e && !f && "nextSibling";
                          }
                          return !0;
                        }
                        if (((f = [s ? g.firstChild : g.lastChild]), s && y)) {
                          for (
                            d = g,
                              p = d[R] || (d[R] = {}),
                              u = p[d.uniqueID] || (p[d.uniqueID] = {}),
                              c = u[e] || [],
                              h = c[0] === B && c[1],
                              b = h && c[2],
                              d = h && g.childNodes[h];
                            (d = (++h && d && d[v]) || (b = h = 0) || f.pop());

                          )
                            if (1 === d.nodeType && ++b && d === t) {
                              u[e] = [B, h, b];
                              break;
                            }
                        } else if (
                          (y &&
                            ((d = t),
                            (p = d[R] || (d[R] = {})),
                            (u = p[d.uniqueID] || (p[d.uniqueID] = {})),
                            (c = u[e] || []),
                            (h = c[0] === B && c[1]),
                            (b = h)),
                          b === !1)
                        )
                          for (
                            ;
                            (d =
                              (++h && d && d[v]) || (b = h = 0) || f.pop()) &&
                            ((a
                              ? d.nodeName.toLowerCase() !== m
                              : 1 !== d.nodeType) ||
                              !++b ||
                              (y &&
                                ((p = d[R] || (d[R] = {})),
                                (u = p[d.uniqueID] || (p[d.uniqueID] = {})),
                                (u[e] = [B, b])),
                              d !== t));

                          );
                        return (b -= r), b === i || (b % i === 0 && b / i >= 0);
                      }
                    };
              },
              PSEUDO: function (e, n) {
                var r,
                  o =
                    x.pseudos[e] ||
                    x.setFilters[e.toLowerCase()] ||
                    t.error("unsupported pseudo: " + e);
                return o[R]
                  ? o(n)
                  : o.length > 1
                  ? ((r = [e, e, "", n]),
                    x.setFilters.hasOwnProperty(e.toLowerCase())
                      ? i(function (e, t) {
                          for (var i, r = o(e, n), s = r.length; s--; )
                            (i = ee(e, r[s])), (e[i] = !(t[i] = r[s]));
                        })
                      : function (e) {
                          return o(e, 0, r);
                        })
                  : o;
              },
            },
            pseudos: {
              not: i(function (e) {
                var t = [],
                  n = [],
                  r = E(e.replace(ae, "$1"));
                return r[R]
                  ? i(function (e, t, n, i) {
                      for (var o, s = r(e, null, i, []), a = e.length; a--; )
                        (o = s[a]) && (e[a] = !(t[a] = o));
                    })
                  : function (e, i, o) {
                      return (
                        (t[0] = e), r(t, null, o, n), (t[0] = null), !n.pop()
                      );
                    };
              }),
              has: i(function (e) {
                return function (n) {
                  return t(e, n).length > 0;
                };
              }),
              contains: i(function (e) {
                return (
                  (e = e.replace(ke, we)),
                  function (t) {
                    return (
                      (t.textContent || t.innerText || S(t)).indexOf(e) > -1
                    );
                  }
                );
              }),
              lang: i(function (e) {
                return (
                  de.test(e || "") || t.error("unsupported lang: " + e),
                  (e = e.replace(ke, we).toLowerCase()),
                  function (t) {
                    var n;
                    do
                      if (
                        (n = D
                          ? t.lang
                          : t.getAttribute("xml:lang") ||
                            t.getAttribute("lang"))
                      )
                        return (
                          (n = n.toLowerCase()),
                          n === e || 0 === n.indexOf(e + "-")
                        );
                    while ((t = t.parentNode) && 1 === t.nodeType);
                    return !1;
                  }
                );
              }),
              target: function (t) {
                var n = e.location && e.location.hash;
                return n && n.slice(1) === t.id;
              },
              root: function (e) {
                return e === O;
              },
              focus: function (e) {
                return (
                  e === L.activeElement &&
                  (!L.hasFocus || L.hasFocus()) &&
                  !!(e.type || e.href || ~e.tabIndex)
                );
              },
              enabled: function (e) {
                return e.disabled === !1;
              },
              disabled: function (e) {
                return e.disabled === !0;
              },
              checked: function (e) {
                var t = e.nodeName.toLowerCase();
                return (
                  ("input" === t && !!e.checked) ||
                  ("option" === t && !!e.selected)
                );
              },
              selected: function (e) {
                return (
                  e.parentNode && e.parentNode.selectedIndex, e.selected === !0
                );
              },
              empty: function (e) {
                for (e = e.firstChild; e; e = e.nextSibling)
                  if (e.nodeType < 6) return !1;
                return !0;
              },
              parent: function (e) {
                return !x.pseudos.empty(e);
              },
              header: function (e) {
                return ve.test(e.nodeName);
              },
              input: function (e) {
                return fe.test(e.nodeName);
              },
              button: function (e) {
                var t = e.nodeName.toLowerCase();
                return ("input" === t && "button" === e.type) || "button" === t;
              },
              text: function (e) {
                var t;
                return (
                  "input" === e.nodeName.toLowerCase() &&
                  "text" === e.type &&
                  (null == (t = e.getAttribute("type")) ||
                    "text" === t.toLowerCase())
                );
              },
              first: c(function () {
                return [0];
              }),
              last: c(function (e, t) {
                return [t - 1];
              }),
              eq: c(function (e, t, n) {
                return [0 > n ? n + t : n];
              }),
              even: c(function (e, t) {
                for (var n = 0; t > n; n += 2) e.push(n);
                return e;
              }),
              odd: c(function (e, t) {
                for (var n = 1; t > n; n += 2) e.push(n);
                return e;
              }),
              lt: c(function (e, t, n) {
                for (var i = 0 > n ? n + t : n; --i >= 0; ) e.push(i);
                return e;
              }),
              gt: c(function (e, t, n) {
                for (var i = 0 > n ? n + t : n; ++i < t; ) e.push(i);
                return e;
              }),
            },
          }),
        (x.pseudos.nth = x.pseudos.eq);
      for (k in { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 })
        x.pseudos[k] = a(k);
      for (k in { submit: !0, reset: !0 }) x.pseudos[k] = l(k);
      return (
        (p.prototype = x.filters = x.pseudos),
        (x.setFilters = new p()),
        (C = t.tokenize =
          function (e, n) {
            var i,
              r,
              o,
              s,
              a,
              l,
              c,
              u = W[e + " "];
            if (u) return n ? 0 : u.slice(0);
            for (a = e, l = [], c = x.preFilter; a; ) {
              (i && !(r = le.exec(a))) ||
                (r && (a = a.slice(r[0].length) || a), l.push((o = []))),
                (i = !1),
                (r = ce.exec(a)) &&
                  ((i = r.shift()),
                  o.push({ value: i, type: r[0].replace(ae, " ") }),
                  (a = a.slice(i.length)));
              for (s in x.filter)
                !(r = he[s].exec(a)) ||
                  (c[s] && !(r = c[s](r))) ||
                  ((i = r.shift()),
                  o.push({ value: i, type: s, matches: r }),
                  (a = a.slice(i.length)));
              if (!i) break;
            }
            return n ? a.length : a ? t.error(e) : W(e, l).slice(0);
          }),
        (E = t.compile =
          function (e, t) {
            var n,
              i = [],
              r = [],
              o = U[e + " "];
            if (!o) {
              for (t || (t = C(e)), n = t.length; n--; )
                (o = y(t[n])), o[R] ? i.push(o) : r.push(o);
              (o = U(e, b(r, i))), (o.selector = e);
            }
            return o;
          }),
        (P = t.select =
          function (e, t, n, i) {
            var r,
              o,
              s,
              a,
              l,
              c = "function" == typeof e && e,
              p = !i && C((e = c.selector || e));
            if (((n = n || []), 1 === p.length)) {
              if (
                ((o = p[0] = p[0].slice(0)),
                o.length > 2 &&
                  "ID" === (s = o[0]).type &&
                  w.getById &&
                  9 === t.nodeType &&
                  D &&
                  x.relative[o[1].type])
              ) {
                if (
                  ((t = (x.find.ID(s.matches[0].replace(ke, we), t) || [])[0]),
                  !t)
                )
                  return n;
                c && (t = t.parentNode), (e = e.slice(o.shift().value.length));
              }
              for (
                r = he.needsContext.test(e) ? 0 : o.length;
                r-- && ((s = o[r]), !x.relative[(a = s.type)]);

              )
                if (
                  (l = x.find[a]) &&
                  (i = l(
                    s.matches[0].replace(ke, we),
                    (ye.test(o[0].type) && u(t.parentNode)) || t
                  ))
                ) {
                  if ((o.splice(r, 1), (e = i.length && d(o)), !e))
                    return Q.apply(n, i), n;
                  break;
                }
            }
            return (
              (c || E(e, p))(
                i,
                t,
                !D,
                n,
                !t || (ye.test(e) && u(t.parentNode)) || t
              ),
              n
            );
          }),
        (w.sortStable = R.split("").sort(V).join("") === R),
        (w.detectDuplicates = !!A),
        N(),
        (w.sortDetached = r(function (e) {
          return 1 & e.compareDocumentPosition(L.createElement("div"));
        })),
        r(function (e) {
          return (
            (e.innerHTML = "<a href='#'></a>"),
            "#" === e.firstChild.getAttribute("href")
          );
        }) ||
          o("type|href|height|width", function (e, t, n) {
            return n
              ? void 0
              : e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2);
          }),
        (w.attributes &&
          r(function (e) {
            return (
              (e.innerHTML = "<input/>"),
              e.firstChild.setAttribute("value", ""),
              "" === e.firstChild.getAttribute("value")
            );
          })) ||
          o("value", function (e, t, n) {
            return n || "input" !== e.nodeName.toLowerCase()
              ? void 0
              : e.defaultValue;
          }),
        r(function (e) {
          return null == e.getAttribute("disabled");
        }) ||
          o(te, function (e, t, n) {
            var i;
            return n
              ? void 0
              : e[t] === !0
              ? t.toLowerCase()
              : (i = e.getAttributeNode(t)) && i.specified
              ? i.value
              : null;
          }),
        t
      );
    })(e);
    (oe.find = ue),
      (oe.expr = ue.selectors),
      (oe.expr[":"] = oe.expr.pseudos),
      (oe.uniqueSort = oe.unique = ue.uniqueSort),
      (oe.text = ue.getText),
      (oe.isXMLDoc = ue.isXML),
      (oe.contains = ue.contains);
    var pe = function (e, t, n) {
        for (var i = [], r = void 0 !== n; (e = e[t]) && 9 !== e.nodeType; )
          if (1 === e.nodeType) {
            if (r && oe(e).is(n)) break;
            i.push(e);
          }
        return i;
      },
      de = function (e, t) {
        for (var n = []; e; e = e.nextSibling)
          1 === e.nodeType && e !== t && n.push(e);
        return n;
      },
      he = oe.expr.match.needsContext,
      fe = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/,
      ve = /^.[^:#\[\.,]*$/;
    (oe.filter = function (e, t, n) {
      var i = t[0];
      return (
        n && (e = ":not(" + e + ")"),
        1 === t.length && 1 === i.nodeType
          ? oe.find.matchesSelector(i, e)
            ? [i]
            : []
          : oe.find.matches(
              e,
              oe.grep(t, function (e) {
                return 1 === e.nodeType;
              })
            )
      );
    }),
      oe.fn.extend({
        find: function (e) {
          var t,
            n = this.length,
            i = [],
            r = this;
          if ("string" != typeof e)
            return this.pushStack(
              oe(e).filter(function () {
                for (t = 0; n > t; t++) if (oe.contains(r[t], this)) return !0;
              })
            );
          for (t = 0; n > t; t++) oe.find(e, r[t], i);
          return (
            (i = this.pushStack(n > 1 ? oe.unique(i) : i)),
            (i.selector = this.selector ? this.selector + " " + e : e),
            i
          );
        },
        filter: function (e) {
          return this.pushStack(i(this, e || [], !1));
        },
        not: function (e) {
          return this.pushStack(i(this, e || [], !0));
        },
        is: function (e) {
          return !!i(
            this,
            "string" == typeof e && he.test(e) ? oe(e) : e || [],
            !1
          ).length;
        },
      });
    var ge,
      me = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,
      ye = (oe.fn.init = function (e, t, n) {
        var i, r;
        if (!e) return this;
        if (((n = n || ge), "string" == typeof e)) {
          if (
            ((i =
              "<" === e[0] && ">" === e[e.length - 1] && e.length >= 3
                ? [null, e, null]
                : me.exec(e)),
            !i || (!i[1] && t))
          )
            return !t || t.jquery
              ? (t || n).find(e)
              : this.constructor(t).find(e);
          if (i[1]) {
            if (
              ((t = t instanceof oe ? t[0] : t),
              oe.merge(
                this,
                oe.parseHTML(
                  i[1],
                  t && t.nodeType ? t.ownerDocument || t : Y,
                  !0
                )
              ),
              fe.test(i[1]) && oe.isPlainObject(t))
            )
              for (i in t)
                oe.isFunction(this[i]) ? this[i](t[i]) : this.attr(i, t[i]);
            return this;
          }
          return (
            (r = Y.getElementById(i[2])),
            r && r.parentNode && ((this.length = 1), (this[0] = r)),
            (this.context = Y),
            (this.selector = e),
            this
          );
        }
        return e.nodeType
          ? ((this.context = this[0] = e), (this.length = 1), this)
          : oe.isFunction(e)
          ? void 0 !== n.ready
            ? n.ready(e)
            : e(oe)
          : (void 0 !== e.selector &&
              ((this.selector = e.selector), (this.context = e.context)),
            oe.makeArray(e, this));
      });
    (ye.prototype = oe.fn), (ge = oe(Y));
    var be = /^(?:parents|prev(?:Until|All))/,
      ke = { children: !0, contents: !0, next: !0, prev: !0 };
    oe.fn.extend({
      has: function (e) {
        var t = oe(e, this),
          n = t.length;
        return this.filter(function () {
          for (var e = 0; n > e; e++) if (oe.contains(this, t[e])) return !0;
        });
      },
      closest: function (e, t) {
        for (
          var n,
            i = 0,
            r = this.length,
            o = [],
            s =
              he.test(e) || "string" != typeof e ? oe(e, t || this.context) : 0;
          r > i;
          i++
        )
          for (n = this[i]; n && n !== t; n = n.parentNode)
            if (
              n.nodeType < 11 &&
              (s
                ? s.index(n) > -1
                : 1 === n.nodeType && oe.find.matchesSelector(n, e))
            ) {
              o.push(n);
              break;
            }
        return this.pushStack(o.length > 1 ? oe.uniqueSort(o) : o);
      },
      index: function (e) {
        return e
          ? "string" == typeof e
            ? Z.call(oe(e), this[0])
            : Z.call(this, e.jquery ? e[0] : e)
          : this[0] && this[0].parentNode
          ? this.first().prevAll().length
          : -1;
      },
      add: function (e, t) {
        return this.pushStack(oe.uniqueSort(oe.merge(this.get(), oe(e, t))));
      },
      addBack: function (e) {
        return this.add(
          null == e ? this.prevObject : this.prevObject.filter(e)
        );
      },
    }),
      oe.each(
        {
          parent: function (e) {
            var t = e.parentNode;
            return t && 11 !== t.nodeType ? t : null;
          },
          parents: function (e) {
            return pe(e, "parentNode");
          },
          parentsUntil: function (e, t, n) {
            return pe(e, "parentNode", n);
          },
          next: function (e) {
            return r(e, "nextSibling");
          },
          prev: function (e) {
            return r(e, "previousSibling");
          },
          nextAll: function (e) {
            return pe(e, "nextSibling");
          },
          prevAll: function (e) {
            return pe(e, "previousSibling");
          },
          nextUntil: function (e, t, n) {
            return pe(e, "nextSibling", n);
          },
          prevUntil: function (e, t, n) {
            return pe(e, "previousSibling", n);
          },
          siblings: function (e) {
            return de((e.parentNode || {}).firstChild, e);
          },
          children: function (e) {
            return de(e.firstChild);
          },
          contents: function (e) {
            return e.contentDocument || oe.merge([], e.childNodes);
          },
        },
        function (e, t) {
          oe.fn[e] = function (n, i) {
            var r = oe.map(this, t, n);
            return (
              "Until" !== e.slice(-5) && (i = n),
              i && "string" == typeof i && (r = oe.filter(i, r)),
              this.length > 1 &&
                (ke[e] || oe.uniqueSort(r), be.test(e) && r.reverse()),
              this.pushStack(r)
            );
          };
        }
      );
    var we = /\S+/g;
    (oe.Callbacks = function (e) {
      e = "string" == typeof e ? o(e) : oe.extend({}, e);
      var t,
        n,
        i,
        r,
        s = [],
        a = [],
        l = -1,
        c = function () {
          for (r = e.once, i = t = !0; a.length; l = -1)
            for (n = a.shift(); ++l < s.length; )
              s[l].apply(n[0], n[1]) === !1 &&
                e.stopOnFalse &&
                ((l = s.length), (n = !1));
          e.memory || (n = !1), (t = !1), r && (s = n ? [] : "");
        },
        u = {
          add: function () {
            return (
              s &&
                (n && !t && ((l = s.length - 1), a.push(n)),
                (function t(n) {
                  oe.each(n, function (n, i) {
                    oe.isFunction(i)
                      ? (e.unique && u.has(i)) || s.push(i)
                      : i && i.length && "string" !== oe.type(i) && t(i);
                  });
                })(arguments),
                n && !t && c()),
              this
            );
          },
          remove: function () {
            return (
              oe.each(arguments, function (e, t) {
                for (var n; (n = oe.inArray(t, s, n)) > -1; )
                  s.splice(n, 1), l >= n && l--;
              }),
              this
            );
          },
          has: function (e) {
            return e ? oe.inArray(e, s) > -1 : s.length > 0;
          },
          empty: function () {
            return s && (s = []), this;
          },
          disable: function () {
            return (r = a = []), (s = n = ""), this;
          },
          disabled: function () {
            return !s;
          },
          lock: function () {
            return (r = a = []), n || (s = n = ""), this;
          },
          locked: function () {
            return !!r;
          },
          fireWith: function (e, n) {
            return (
              r ||
                ((n = n || []),
                (n = [e, n.slice ? n.slice() : n]),
                a.push(n),
                t || c()),
              this
            );
          },
          fire: function () {
            return u.fireWith(this, arguments), this;
          },
          fired: function () {
            return !!i;
          },
        };
      return u;
    }),
      oe.extend({
        Deferred: function (e) {
          var t = [
              ["resolve", "done", oe.Callbacks("once memory"), "resolved"],
              ["reject", "fail", oe.Callbacks("once memory"), "rejected"],
              ["notify", "progress", oe.Callbacks("memory")],
            ],
            n = "pending",
            i = {
              state: function () {
                return n;
              },
              always: function () {
                return r.done(arguments).fail(arguments), this;
              },
              then: function () {
                var e = arguments;
                return oe
                  .Deferred(function (n) {
                    oe.each(t, function (t, o) {
                      var s = oe.isFunction(e[t]) && e[t];
                      r[o[1]](function () {
                        var e = s && s.apply(this, arguments);
                        e && oe.isFunction(e.promise)
                          ? e
                              .promise()
                              .progress(n.notify)
                              .done(n.resolve)
                              .fail(n.reject)
                          : n[o[0] + "With"](
                              this === i ? n.promise() : this,
                              s ? [e] : arguments
                            );
                      });
                    }),
                      (e = null);
                  })
                  .promise();
              },
              promise: function (e) {
                return null != e ? oe.extend(e, i) : i;
              },
            },
            r = {};
          return (
            (i.pipe = i.then),
            oe.each(t, function (e, o) {
              var s = o[2],
                a = o[3];
              (i[o[1]] = s.add),
                a &&
                  s.add(
                    function () {
                      n = a;
                    },
                    t[1 ^ e][2].disable,
                    t[2][2].lock
                  ),
                (r[o[0]] = function () {
                  return (
                    r[o[0] + "With"](this === r ? i : this, arguments), this
                  );
                }),
                (r[o[0] + "With"] = s.fireWith);
            }),
            i.promise(r),
            e && e.call(r, r),
            r
          );
        },
        when: function (e) {
          var t,
            n,
            i,
            r = 0,
            o = G.call(arguments),
            s = o.length,
            a = 1 !== s || (e && oe.isFunction(e.promise)) ? s : 0,
            l = 1 === a ? e : oe.Deferred(),
            c = function (e, n, i) {
              return function (r) {
                (n[e] = this),
                  (i[e] = arguments.length > 1 ? G.call(arguments) : r),
                  i === t ? l.notifyWith(n, i) : --a || l.resolveWith(n, i);
              };
            };
          if (s > 1)
            for (
              t = new Array(s), n = new Array(s), i = new Array(s);
              s > r;
              r++
            )
              o[r] && oe.isFunction(o[r].promise)
                ? o[r]
                    .promise()
                    .progress(c(r, n, t))
                    .done(c(r, i, o))
                    .fail(l.reject)
                : --a;
          return a || l.resolveWith(i, o), l.promise();
        },
      });
    var xe;
    (oe.fn.ready = function (e) {
      return oe.ready.promise().done(e), this;
    }),
      oe.extend({
        isReady: !1,
        readyWait: 1,
        holdReady: function (e) {
          e ? oe.readyWait++ : oe.ready(!0);
        },
        ready: function (e) {
          (e === !0 ? --oe.readyWait : oe.isReady) ||
            ((oe.isReady = !0),
            (e !== !0 && --oe.readyWait > 0) ||
              (xe.resolveWith(Y, [oe]),
              oe.fn.triggerHandler &&
                (oe(Y).triggerHandler("ready"), oe(Y).off("ready"))));
        },
      }),
      (oe.ready.promise = function (t) {
        return (
          xe ||
            ((xe = oe.Deferred()),
            "complete" === Y.readyState ||
            ("loading" !== Y.readyState && !Y.documentElement.doScroll)
              ? e.setTimeout(oe.ready)
              : (Y.addEventListener("DOMContentLoaded", s),
                e.addEventListener("load", s))),
          xe.promise(t)
        );
      }),
      oe.ready.promise();
    var Se = function (e, t, n, i, r, o, s) {
        var a = 0,
          l = e.length,
          c = null == n;
        if ("object" === oe.type(n)) {
          r = !0;
          for (a in n) Se(e, t, a, n[a], !0, o, s);
        } else if (
          void 0 !== i &&
          ((r = !0),
          oe.isFunction(i) || (s = !0),
          c &&
            (s
              ? (t.call(e, i), (t = null))
              : ((c = t),
                (t = function (e, t, n) {
                  return c.call(oe(e), n);
                }))),
          t)
        )
          for (; l > a; a++) t(e[a], n, s ? i : i.call(e[a], a, t(e[a], n)));
        return r ? e : c ? t.call(e) : l ? t(e[0], n) : o;
      },
      Te = function (e) {
        return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType;
      };
    (a.uid = 1),
      (a.prototype = {
        register: function (e, t) {
          var n = t || {};
          return (
            e.nodeType
              ? (e[this.expando] = n)
              : Object.defineProperty(e, this.expando, {
                  value: n,
                  writable: !0,
                  configurable: !0,
                }),
            e[this.expando]
          );
        },
        cache: function (e) {
          if (!Te(e)) return {};
          var t = e[this.expando];
          return (
            t ||
              ((t = {}),
              Te(e) &&
                (e.nodeType
                  ? (e[this.expando] = t)
                  : Object.defineProperty(e, this.expando, {
                      value: t,
                      configurable: !0,
                    }))),
            t
          );
        },
        set: function (e, t, n) {
          var i,
            r = this.cache(e);
          if ("string" == typeof t) r[t] = n;
          else for (i in t) r[i] = t[i];
          return r;
        },
        get: function (e, t) {
          return void 0 === t
            ? this.cache(e)
            : e[this.expando] && e[this.expando][t];
        },
        access: function (e, t, n) {
          var i;
          return void 0 === t || (t && "string" == typeof t && void 0 === n)
            ? ((i = this.get(e, t)),
              void 0 !== i ? i : this.get(e, oe.camelCase(t)))
            : (this.set(e, t, n), void 0 !== n ? n : t);
        },
        remove: function (e, t) {
          var n,
            i,
            r,
            o = e[this.expando];
          if (void 0 !== o) {
            if (void 0 === t) this.register(e);
            else {
              oe.isArray(t)
                ? (i = t.concat(t.map(oe.camelCase)))
                : ((r = oe.camelCase(t)),
                  t in o
                    ? (i = [t, r])
                    : ((i = r), (i = i in o ? [i] : i.match(we) || []))),
                (n = i.length);
              for (; n--; ) delete o[i[n]];
            }
            (void 0 === t || oe.isEmptyObject(o)) &&
              (e.nodeType
                ? (e[this.expando] = void 0)
                : delete e[this.expando]);
          }
        },
        hasData: function (e) {
          var t = e[this.expando];
          return void 0 !== t && !oe.isEmptyObject(t);
        },
      });
    var Ce = new a(),
      Ee = new a(),
      Pe = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
      $e = /[A-Z]/g;
    oe.extend({
      hasData: function (e) {
        return Ee.hasData(e) || Ce.hasData(e);
      },
      data: function (e, t, n) {
        return Ee.access(e, t, n);
      },
      removeData: function (e, t) {
        Ee.remove(e, t);
      },
      _data: function (e, t, n) {
        return Ce.access(e, t, n);
      },
      _removeData: function (e, t) {
        Ce.remove(e, t);
      },
    }),
      oe.fn.extend({
        data: function (e, t) {
          var n,
            i,
            r,
            o = this[0],
            s = o && o.attributes;
          if (void 0 === e) {
            if (
              this.length &&
              ((r = Ee.get(o)), 1 === o.nodeType && !Ce.get(o, "hasDataAttrs"))
            ) {
              for (n = s.length; n--; )
                s[n] &&
                  ((i = s[n].name),
                  0 === i.indexOf("data-") &&
                    ((i = oe.camelCase(i.slice(5))), l(o, i, r[i])));
              Ce.set(o, "hasDataAttrs", !0);
            }
            return r;
          }
          return "object" == typeof e
            ? this.each(function () {
                Ee.set(this, e);
              })
            : Se(
                this,
                function (t) {
                  var n, i;
                  if (o && void 0 === t) {
                    if (
                      ((n =
                        Ee.get(o, e) ||
                        Ee.get(o, e.replace($e, "-$&").toLowerCase())),
                      void 0 !== n)
                    )
                      return n;
                    if (
                      ((i = oe.camelCase(e)), (n = Ee.get(o, i)), void 0 !== n)
                    )
                      return n;
                    if (((n = l(o, i, void 0)), void 0 !== n)) return n;
                  } else
                    (i = oe.camelCase(e)),
                      this.each(function () {
                        var n = Ee.get(this, i);
                        Ee.set(this, i, t),
                          e.indexOf("-") > -1 &&
                            void 0 !== n &&
                            Ee.set(this, e, t);
                      });
                },
                null,
                t,
                arguments.length > 1,
                null,
                !0
              );
        },
        removeData: function (e) {
          return this.each(function () {
            Ee.remove(this, e);
          });
        },
      }),
      oe.extend({
        queue: function (e, t, n) {
          var i;
          return e
            ? ((t = (t || "fx") + "queue"),
              (i = Ce.get(e, t)),
              n &&
                (!i || oe.isArray(n)
                  ? (i = Ce.access(e, t, oe.makeArray(n)))
                  : i.push(n)),
              i || [])
            : void 0;
        },
        dequeue: function (e, t) {
          t = t || "fx";
          var n = oe.queue(e, t),
            i = n.length,
            r = n.shift(),
            o = oe._queueHooks(e, t),
            s = function () {
              oe.dequeue(e, t);
            };
          "inprogress" === r && ((r = n.shift()), i--),
            r &&
              ("fx" === t && n.unshift("inprogress"),
              delete o.stop,
              r.call(e, s, o)),
            !i && o && o.empty.fire();
        },
        _queueHooks: function (e, t) {
          var n = t + "queueHooks";
          return (
            Ce.get(e, n) ||
            Ce.access(e, n, {
              empty: oe.Callbacks("once memory").add(function () {
                Ce.remove(e, [t + "queue", n]);
              }),
            })
          );
        },
      }),
      oe.fn.extend({
        queue: function (e, t) {
          var n = 2;
          return (
            "string" != typeof e && ((t = e), (e = "fx"), n--),
            arguments.length < n
              ? oe.queue(this[0], e)
              : void 0 === t
              ? this
              : this.each(function () {
                  var n = oe.queue(this, e, t);
                  oe._queueHooks(this, e),
                    "fx" === e && "inprogress" !== n[0] && oe.dequeue(this, e);
                })
          );
        },
        dequeue: function (e) {
          return this.each(function () {
            oe.dequeue(this, e);
          });
        },
        clearQueue: function (e) {
          return this.queue(e || "fx", []);
        },
        promise: function (e, t) {
          var n,
            i = 1,
            r = oe.Deferred(),
            o = this,
            s = this.length,
            a = function () {
              --i || r.resolveWith(o, [o]);
            };
          for (
            "string" != typeof e && ((t = e), (e = void 0)), e = e || "fx";
            s--;

          )
            (n = Ce.get(o[s], e + "queueHooks")),
              n && n.empty && (i++, n.empty.add(a));
          return a(), r.promise(t);
        },
      });
    var _e = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
      Ae = new RegExp("^(?:([+-])=|)(" + _e + ")([a-z%]*)$", "i"),
      Ne = ["Top", "Right", "Bottom", "Left"],
      Le = function (e, t) {
        return (
          (e = t || e),
          "none" === oe.css(e, "display") || !oe.contains(e.ownerDocument, e)
        );
      },
      Oe = /^(?:checkbox|radio)$/i,
      De = /<([\w:-]+)/,
      je = /^$|\/(?:java|ecma)script/i,
      He = {
        option: [1, "<select multiple='multiple'>", "</select>"],
        thead: [1, "<table>", "</table>"],
        col: [2, "<table><colgroup>", "</colgroup></table>"],
        tr: [2, "<table><tbody>", "</tbody></table>"],
        td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
        _default: [0, "", ""],
      };
    (He.optgroup = He.option),
      (He.tbody = He.tfoot = He.colgroup = He.caption = He.thead),
      (He.th = He.td);
    var Ie = /<|&#?\w+;/;
    !(function () {
      var e = Y.createDocumentFragment(),
        t = e.appendChild(Y.createElement("div")),
        n = Y.createElement("input");
      n.setAttribute("type", "radio"),
        n.setAttribute("checked", "checked"),
        n.setAttribute("name", "t"),
        t.appendChild(n),
        (ie.checkClone = t.cloneNode(!0).cloneNode(!0).lastChild.checked),
        (t.innerHTML = "<textarea>x</textarea>"),
        (ie.noCloneChecked = !!t.cloneNode(!0).lastChild.defaultValue);
    })();
    var Me = /^key/,
      Re = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
      qe = /^([^.]*)(?:\.(.+)|)/;
    (oe.event = {
      global: {},
      add: function (e, t, n, i, r) {
        var o,
          s,
          a,
          l,
          c,
          u,
          p,
          d,
          h,
          f,
          v,
          g = Ce.get(e);
        if (g)
          for (
            n.handler && ((o = n), (n = o.handler), (r = o.selector)),
              n.guid || (n.guid = oe.guid++),
              (l = g.events) || (l = g.events = {}),
              (s = g.handle) ||
                (s = g.handle =
                  function (t) {
                    return "undefined" != typeof oe &&
                      oe.event.triggered !== t.type
                      ? oe.event.dispatch.apply(e, arguments)
                      : void 0;
                  }),
              t = (t || "").match(we) || [""],
              c = t.length;
            c--;

          )
            (a = qe.exec(t[c]) || []),
              (h = v = a[1]),
              (f = (a[2] || "").split(".").sort()),
              h &&
                ((p = oe.event.special[h] || {}),
                (h = (r ? p.delegateType : p.bindType) || h),
                (p = oe.event.special[h] || {}),
                (u = oe.extend(
                  {
                    type: h,
                    origType: v,
                    data: i,
                    handler: n,
                    guid: n.guid,
                    selector: r,
                    needsContext: r && oe.expr.match.needsContext.test(r),
                    namespace: f.join("."),
                  },
                  o
                )),
                (d = l[h]) ||
                  ((d = l[h] = []),
                  (d.delegateCount = 0),
                  (p.setup && p.setup.call(e, i, f, s) !== !1) ||
                    (e.addEventListener && e.addEventListener(h, s))),
                p.add &&
                  (p.add.call(e, u),
                  u.handler.guid || (u.handler.guid = n.guid)),
                r ? d.splice(d.delegateCount++, 0, u) : d.push(u),
                (oe.event.global[h] = !0));
      },
      remove: function (e, t, n, i, r) {
        var o,
          s,
          a,
          l,
          c,
          u,
          p,
          d,
          h,
          f,
          v,
          g = Ce.hasData(e) && Ce.get(e);
        if (g && (l = g.events)) {
          for (t = (t || "").match(we) || [""], c = t.length; c--; )
            if (
              ((a = qe.exec(t[c]) || []),
              (h = v = a[1]),
              (f = (a[2] || "").split(".").sort()),
              h)
            ) {
              for (
                p = oe.event.special[h] || {},
                  h = (i ? p.delegateType : p.bindType) || h,
                  d = l[h] || [],
                  a =
                    a[2] &&
                    new RegExp("(^|\\.)" + f.join("\\.(?:.*\\.|)") + "(\\.|$)"),
                  s = o = d.length;
                o--;

              )
                (u = d[o]),
                  (!r && v !== u.origType) ||
                    (n && n.guid !== u.guid) ||
                    (a && !a.test(u.namespace)) ||
                    (i && i !== u.selector && ("**" !== i || !u.selector)) ||
                    (d.splice(o, 1),
                    u.selector && d.delegateCount--,
                    p.remove && p.remove.call(e, u));
              s &&
                !d.length &&
                ((p.teardown && p.teardown.call(e, f, g.handle) !== !1) ||
                  oe.removeEvent(e, h, g.handle),
                delete l[h]);
            } else for (h in l) oe.event.remove(e, h + t[c], n, i, !0);
          oe.isEmptyObject(l) && Ce.remove(e, "handle events");
        }
      },
      dispatch: function (e) {
        e = oe.event.fix(e);
        var t,
          n,
          i,
          r,
          o,
          s = [],
          a = G.call(arguments),
          l = (Ce.get(this, "events") || {})[e.type] || [],
          c = oe.event.special[e.type] || {};
        if (
          ((a[0] = e),
          (e.delegateTarget = this),
          !c.preDispatch || c.preDispatch.call(this, e) !== !1)
        ) {
          for (
            s = oe.event.handlers.call(this, e, l), t = 0;
            (r = s[t++]) && !e.isPropagationStopped();

          )
            for (
              e.currentTarget = r.elem, n = 0;
              (o = r.handlers[n++]) && !e.isImmediatePropagationStopped();

            )
              (e.rnamespace && !e.rnamespace.test(o.namespace)) ||
                ((e.handleObj = o),
                (e.data = o.data),
                (i = (
                  (oe.event.special[o.origType] || {}).handle || o.handler
                ).apply(r.elem, a)),
                void 0 !== i &&
                  (e.result = i) === !1 &&
                  (e.preventDefault(), e.stopPropagation()));
          return c.postDispatch && c.postDispatch.call(this, e), e.result;
        }
      },
      handlers: function (e, t) {
        var n,
          i,
          r,
          o,
          s = [],
          a = t.delegateCount,
          l = e.target;
        if (
          a &&
          l.nodeType &&
          ("click" !== e.type || isNaN(e.button) || e.button < 1)
        )
          for (; l !== this; l = l.parentNode || this)
            if (1 === l.nodeType && (l.disabled !== !0 || "click" !== e.type)) {
              for (i = [], n = 0; a > n; n++)
                (o = t[n]),
                  (r = o.selector + " "),
                  void 0 === i[r] &&
                    (i[r] = o.needsContext
                      ? oe(r, this).index(l) > -1
                      : oe.find(r, this, null, [l]).length),
                  i[r] && i.push(o);
              i.length && s.push({ elem: l, handlers: i });
            }
        return a < t.length && s.push({ elem: this, handlers: t.slice(a) }), s;
      },
      props:
        "altKey bubbles cancelable ctrlKey currentTarget detail eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(
          " "
        ),
      fixHooks: {},
      keyHooks: {
        props: "char charCode key keyCode".split(" "),
        filter: function (e, t) {
          return (
            null == e.which &&
              (e.which = null != t.charCode ? t.charCode : t.keyCode),
            e
          );
        },
      },
      mouseHooks: {
        props:
          "button buttons clientX clientY offsetX offsetY pageX pageY screenX screenY toElement".split(
            " "
          ),
        filter: function (e, t) {
          var n,
            i,
            r,
            o = t.button;
          return (
            null == e.pageX &&
              null != t.clientX &&
              ((n = e.target.ownerDocument || Y),
              (i = n.documentElement),
              (r = n.body),
              (e.pageX =
                t.clientX +
                ((i && i.scrollLeft) || (r && r.scrollLeft) || 0) -
                ((i && i.clientLeft) || (r && r.clientLeft) || 0)),
              (e.pageY =
                t.clientY +
                ((i && i.scrollTop) || (r && r.scrollTop) || 0) -
                ((i && i.clientTop) || (r && r.clientTop) || 0))),
            e.which ||
              void 0 === o ||
              (e.which = 1 & o ? 1 : 2 & o ? 3 : 4 & o ? 2 : 0),
            e
          );
        },
      },
      fix: function (e) {
        if (e[oe.expando]) return e;
        var t,
          n,
          i,
          r = e.type,
          o = e,
          s = this.fixHooks[r];
        for (
          s ||
            (this.fixHooks[r] = s =
              Re.test(r) ? this.mouseHooks : Me.test(r) ? this.keyHooks : {}),
            i = s.props ? this.props.concat(s.props) : this.props,
            e = new oe.Event(o),
            t = i.length;
          t--;

        )
          (n = i[t]), (e[n] = o[n]);
        return (
          e.target || (e.target = Y),
          3 === e.target.nodeType && (e.target = e.target.parentNode),
          s.filter ? s.filter(e, o) : e
        );
      },
      special: {
        load: { noBubble: !0 },
        focus: {
          trigger: function () {
            return this !== v() && this.focus ? (this.focus(), !1) : void 0;
          },
          delegateType: "focusin",
        },
        blur: {
          trigger: function () {
            return this === v() && this.blur ? (this.blur(), !1) : void 0;
          },
          delegateType: "focusout",
        },
        click: {
          trigger: function () {
            return "checkbox" === this.type &&
              this.click &&
              oe.nodeName(this, "input")
              ? (this.click(), !1)
              : void 0;
          },
          _default: function (e) {
            return oe.nodeName(e.target, "a");
          },
        },
        beforeunload: {
          postDispatch: function (e) {
            void 0 !== e.result &&
              e.originalEvent &&
              (e.originalEvent.returnValue = e.result);
          },
        },
      },
    }),
      (oe.removeEvent = function (e, t, n) {
        e.removeEventListener && e.removeEventListener(t, n);
      }),
      (oe.Event = function (e, t) {
        return this instanceof oe.Event
          ? (e && e.type
              ? ((this.originalEvent = e),
                (this.type = e.type),
                (this.isDefaultPrevented =
                  e.defaultPrevented ||
                  (void 0 === e.defaultPrevented && e.returnValue === !1)
                    ? h
                    : f))
              : (this.type = e),
            t && oe.extend(this, t),
            (this.timeStamp = (e && e.timeStamp) || oe.now()),
            void (this[oe.expando] = !0))
          : new oe.Event(e, t);
      }),
      (oe.Event.prototype = {
        constructor: oe.Event,
        isDefaultPrevented: f,
        isPropagationStopped: f,
        isImmediatePropagationStopped: f,
        preventDefault: function () {
          var e = this.originalEvent;
          (this.isDefaultPrevented = h), e && e.preventDefault();
        },
        stopPropagation: function () {
          var e = this.originalEvent;
          (this.isPropagationStopped = h), e && e.stopPropagation();
        },
        stopImmediatePropagation: function () {
          var e = this.originalEvent;
          (this.isImmediatePropagationStopped = h),
            e && e.stopImmediatePropagation(),
            this.stopPropagation();
        },
      }),
      oe.each(
        {
          mouseenter: "mouseover",
          mouseleave: "mouseout",
          pointerenter: "pointerover",
          pointerleave: "pointerout",
        },
        function (e, t) {
          oe.event.special[e] = {
            delegateType: t,
            bindType: t,
            handle: function (e) {
              var n,
                i = this,
                r = e.relatedTarget,
                o = e.handleObj;
              return (
                (r && (r === i || oe.contains(i, r))) ||
                  ((e.type = o.origType),
                  (n = o.handler.apply(this, arguments)),
                  (e.type = t)),
                n
              );
            },
          };
        }
      ),
      oe.fn.extend({
        on: function (e, t, n, i) {
          return g(this, e, t, n, i);
        },
        one: function (e, t, n, i) {
          return g(this, e, t, n, i, 1);
        },
        off: function (e, t, n) {
          var i, r;
          if (e && e.preventDefault && e.handleObj)
            return (
              (i = e.handleObj),
              oe(e.delegateTarget).off(
                i.namespace ? i.origType + "." + i.namespace : i.origType,
                i.selector,
                i.handler
              ),
              this
            );
          if ("object" == typeof e) {
            for (r in e) this.off(r, t, e[r]);
            return this;
          }
          return (
            (t !== !1 && "function" != typeof t) || ((n = t), (t = void 0)),
            n === !1 && (n = f),
            this.each(function () {
              oe.event.remove(this, e, n, t);
            })
          );
        },
      });
    var Be =
        /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi,
      Fe = /<script|<style|<link/i,
      ze = /checked\s*(?:[^=]|=\s*.checked.)/i,
      We = /^true\/(.*)/,
      Ue = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
    oe.extend({
      htmlPrefilter: function (e) {
        return e.replace(Be, "<$1></$2>");
      },
      clone: function (e, t, n) {
        var i,
          r,
          o,
          s,
          a = e.cloneNode(!0),
          l = oe.contains(e.ownerDocument, e);
        if (
          !(
            ie.noCloneChecked ||
            (1 !== e.nodeType && 11 !== e.nodeType) ||
            oe.isXMLDoc(e)
          )
        )
          for (s = u(a), o = u(e), i = 0, r = o.length; r > i; i++)
            w(o[i], s[i]);
        if (t)
          if (n)
            for (o = o || u(e), s = s || u(a), i = 0, r = o.length; r > i; i++)
              k(o[i], s[i]);
          else k(e, a);
        return (
          (s = u(a, "script")), s.length > 0 && p(s, !l && u(e, "script")), a
        );
      },
      cleanData: function (e) {
        for (
          var t, n, i, r = oe.event.special, o = 0;
          void 0 !== (n = e[o]);
          o++
        )
          if (Te(n)) {
            if ((t = n[Ce.expando])) {
              if (t.events)
                for (i in t.events)
                  r[i] ? oe.event.remove(n, i) : oe.removeEvent(n, i, t.handle);
              n[Ce.expando] = void 0;
            }
            n[Ee.expando] && (n[Ee.expando] = void 0);
          }
      },
    }),
      oe.fn.extend({
        domManip: x,
        detach: function (e) {
          return S(this, e, !0);
        },
        remove: function (e) {
          return S(this, e);
        },
        text: function (e) {
          return Se(
            this,
            function (e) {
              return void 0 === e
                ? oe.text(this)
                : this.empty().each(function () {
                    (1 !== this.nodeType &&
                      11 !== this.nodeType &&
                      9 !== this.nodeType) ||
                      (this.textContent = e);
                  });
            },
            null,
            e,
            arguments.length
          );
        },
        append: function () {
          return x(this, arguments, function (e) {
            if (
              1 === this.nodeType ||
              11 === this.nodeType ||
              9 === this.nodeType
            ) {
              var t = m(this, e);
              t.appendChild(e);
            }
          });
        },
        prepend: function () {
          return x(this, arguments, function (e) {
            if (
              1 === this.nodeType ||
              11 === this.nodeType ||
              9 === this.nodeType
            ) {
              var t = m(this, e);
              t.insertBefore(e, t.firstChild);
            }
          });
        },
        before: function () {
          return x(this, arguments, function (e) {
            this.parentNode && this.parentNode.insertBefore(e, this);
          });
        },
        after: function () {
          return x(this, arguments, function (e) {
            this.parentNode &&
              this.parentNode.insertBefore(e, this.nextSibling);
          });
        },
        empty: function () {
          for (var e, t = 0; null != (e = this[t]); t++)
            1 === e.nodeType && (oe.cleanData(u(e, !1)), (e.textContent = ""));
          return this;
        },
        clone: function (e, t) {
          return (
            (e = null != e && e),
            (t = null == t ? e : t),
            this.map(function () {
              return oe.clone(this, e, t);
            })
          );
        },
        html: function (e) {
          return Se(
            this,
            function (e) {
              var t = this[0] || {},
                n = 0,
                i = this.length;
              if (void 0 === e && 1 === t.nodeType) return t.innerHTML;
              if (
                "string" == typeof e &&
                !Fe.test(e) &&
                !He[(De.exec(e) || ["", ""])[1].toLowerCase()]
              ) {
                e = oe.htmlPrefilter(e);
                try {
                  for (; i > n; n++)
                    (t = this[n] || {}),
                      1 === t.nodeType &&
                        (oe.cleanData(u(t, !1)), (t.innerHTML = e));
                  t = 0;
                } catch (e) {}
              }
              t && this.empty().append(e);
            },
            null,
            e,
            arguments.length
          );
        },
        replaceWith: function () {
          var e = [];
          return x(
            this,
            arguments,
            function (t) {
              var n = this.parentNode;
              oe.inArray(this, e) < 0 &&
                (oe.cleanData(u(this)), n && n.replaceChild(t, this));
            },
            e
          );
        },
      }),
      oe.each(
        {
          appendTo: "append",
          prependTo: "prepend",
          insertBefore: "before",
          insertAfter: "after",
          replaceAll: "replaceWith",
        },
        function (e, t) {
          oe.fn[e] = function (e) {
            for (var n, i = [], r = oe(e), o = r.length - 1, s = 0; o >= s; s++)
              (n = s === o ? this : this.clone(!0)),
                oe(r[s])[t](n),
                Q.apply(i, n.get());
            return this.pushStack(i);
          };
        }
      );
    var Ve,
      Xe = { HTML: "block", BODY: "block" },
      Ke = /^margin/,
      Ye = new RegExp("^(" + _e + ")(?!px)[a-z%]+$", "i"),
      Ge = function (t) {
        var n = t.ownerDocument.defaultView;
        return (n && n.opener) || (n = e), n.getComputedStyle(t);
      },
      Je = function (e, t, n, i) {
        var r,
          o,
          s = {};
        for (o in t) (s[o] = e.style[o]), (e.style[o] = t[o]);
        r = n.apply(e, i || []);
        for (o in t) e.style[o] = s[o];
        return r;
      },
      Qe = Y.documentElement;
    !(function () {
      function t() {
        (a.style.cssText =
          "-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;position:relative;display:block;margin:auto;border:1px;padding:1px;top:1%;width:50%"),
          (a.innerHTML = ""),
          Qe.appendChild(s);
        var t = e.getComputedStyle(a);
        (n = "1%" !== t.top),
          (o = "2px" === t.marginLeft),
          (i = "4px" === t.width),
          (a.style.marginRight = "50%"),
          (r = "4px" === t.marginRight),
          Qe.removeChild(s);
      }
      var n,
        i,
        r,
        o,
        s = Y.createElement("div"),
        a = Y.createElement("div");
      a.style &&
        ((a.style.backgroundClip = "content-box"),
        (a.cloneNode(!0).style.backgroundClip = ""),
        (ie.clearCloneStyle = "content-box" === a.style.backgroundClip),
        (s.style.cssText =
          "border:0;width:8px;height:0;top:0;left:-9999px;padding:0;margin-top:1px;position:absolute"),
        s.appendChild(a),
        oe.extend(ie, {
          pixelPosition: function () {
            return t(), n;
          },
          boxSizingReliable: function () {
            return null == i && t(), i;
          },
          pixelMarginRight: function () {
            return null == i && t(), r;
          },
          reliableMarginLeft: function () {
            return null == i && t(), o;
          },
          reliableMarginRight: function () {
            var t,
              n = a.appendChild(Y.createElement("div"));
            return (
              (n.style.cssText = a.style.cssText =
                "-webkit-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:0"),
              (n.style.marginRight = n.style.width = "0"),
              (a.style.width = "1px"),
              Qe.appendChild(s),
              (t = !parseFloat(e.getComputedStyle(n).marginRight)),
              Qe.removeChild(s),
              a.removeChild(n),
              t
            );
          },
        }));
    })();
    var Ze = /^(none|table(?!-c[ea]).+)/,
      et = { position: "absolute", visibility: "hidden", display: "block" },
      tt = { letterSpacing: "0", fontWeight: "400" },
      nt = ["Webkit", "O", "Moz", "ms"],
      it = Y.createElement("div").style;
    oe.extend({
      cssHooks: {
        opacity: {
          get: function (e, t) {
            if (t) {
              var n = E(e, "opacity");
              return "" === n ? "1" : n;
            }
          },
        },
      },
      cssNumber: {
        animationIterationCount: !0,
        columnCount: !0,
        fillOpacity: !0,
        flexGrow: !0,
        flexShrink: !0,
        fontWeight: !0,
        lineHeight: !0,
        opacity: !0,
        order: !0,
        orphans: !0,
        widows: !0,
        zIndex: !0,
        zoom: !0,
      },
      cssProps: { float: "cssFloat" },
      style: function (e, t, n, i) {
        if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
          var r,
            o,
            s,
            a = oe.camelCase(t),
            l = e.style;
          return (
            (t = oe.cssProps[a] || (oe.cssProps[a] = $(a) || a)),
            (s = oe.cssHooks[t] || oe.cssHooks[a]),
            void 0 === n
              ? s && "get" in s && void 0 !== (r = s.get(e, !1, i))
                ? r
                : l[t]
              : ((o = typeof n),
                "string" === o &&
                  (r = Ae.exec(n)) &&
                  r[1] &&
                  ((n = c(e, t, r)), (o = "number")),
                void (
                  null != n &&
                  n === n &&
                  ("number" === o &&
                    (n += (r && r[3]) || (oe.cssNumber[a] ? "" : "px")),
                  ie.clearCloneStyle ||
                    "" !== n ||
                    0 !== t.indexOf("background") ||
                    (l[t] = "inherit"),
                  (s && "set" in s && void 0 === (n = s.set(e, n, i))) ||
                    (l[t] = n))
                ))
          );
        }
      },
      css: function (e, t, n, i) {
        var r,
          o,
          s,
          a = oe.camelCase(t);
        return (
          (t = oe.cssProps[a] || (oe.cssProps[a] = $(a) || a)),
          (s = oe.cssHooks[t] || oe.cssHooks[a]),
          s && "get" in s && (r = s.get(e, !0, n)),
          void 0 === r && (r = E(e, t, i)),
          "normal" === r && t in tt && (r = tt[t]),
          "" === n || n
            ? ((o = parseFloat(r)), n === !0 || isFinite(o) ? o || 0 : r)
            : r
        );
      },
    }),
      oe.each(["height", "width"], function (e, t) {
        oe.cssHooks[t] = {
          get: function (e, n, i) {
            return n
              ? Ze.test(oe.css(e, "display")) && 0 === e.offsetWidth
                ? Je(e, et, function () {
                    return N(e, t, i);
                  })
                : N(e, t, i)
              : void 0;
          },
          set: function (e, n, i) {
            var r,
              o = i && Ge(e),
              s =
                i &&
                A(e, t, i, "border-box" === oe.css(e, "boxSizing", !1, o), o);
            return (
              s &&
                (r = Ae.exec(n)) &&
                "px" !== (r[3] || "px") &&
                ((e.style[t] = n), (n = oe.css(e, t))),
              _(e, n, s)
            );
          },
        };
      }),
      (oe.cssHooks.marginLeft = P(ie.reliableMarginLeft, function (e, t) {
        return t
          ? (parseFloat(E(e, "marginLeft")) ||
              e.getBoundingClientRect().left -
                Je(e, { marginLeft: 0 }, function () {
                  return e.getBoundingClientRect().left;
                })) + "px"
          : void 0;
      })),
      (oe.cssHooks.marginRight = P(ie.reliableMarginRight, function (e, t) {
        return t
          ? Je(e, { display: "inline-block" }, E, [e, "marginRight"])
          : void 0;
      })),
      oe.each({ margin: "", padding: "", border: "Width" }, function (e, t) {
        (oe.cssHooks[e + t] = {
          expand: function (n) {
            for (
              var i = 0, r = {}, o = "string" == typeof n ? n.split(" ") : [n];
              4 > i;
              i++
            )
              r[e + Ne[i] + t] = o[i] || o[i - 2] || o[0];
            return r;
          },
        }),
          Ke.test(e) || (oe.cssHooks[e + t].set = _);
      }),
      oe.fn.extend({
        css: function (e, t) {
          return Se(
            this,
            function (e, t, n) {
              var i,
                r,
                o = {},
                s = 0;
              if (oe.isArray(t)) {
                for (i = Ge(e), r = t.length; r > s; s++)
                  o[t[s]] = oe.css(e, t[s], !1, i);
                return o;
              }
              return void 0 !== n ? oe.style(e, t, n) : oe.css(e, t);
            },
            e,
            t,
            arguments.length > 1
          );
        },
        show: function () {
          return L(this, !0);
        },
        hide: function () {
          return L(this);
        },
        toggle: function (e) {
          return "boolean" == typeof e
            ? e
              ? this.show()
              : this.hide()
            : this.each(function () {
                Le(this) ? oe(this).show() : oe(this).hide();
              });
        },
      }),
      (oe.Tween = O),
      (O.prototype = {
        constructor: O,
        init: function (e, t, n, i, r, o) {
          (this.elem = e),
            (this.prop = n),
            (this.easing = r || oe.easing._default),
            (this.options = t),
            (this.start = this.now = this.cur()),
            (this.end = i),
            (this.unit = o || (oe.cssNumber[n] ? "" : "px"));
        },
        cur: function () {
          var e = O.propHooks[this.prop];
          return e && e.get ? e.get(this) : O.propHooks._default.get(this);
        },
        run: function (e) {
          var t,
            n = O.propHooks[this.prop];
          return (
            this.options.duration
              ? (this.pos = t =
                  oe.easing[this.easing](
                    e,
                    this.options.duration * e,
                    0,
                    1,
                    this.options.duration
                  ))
              : (this.pos = t = e),
            (this.now = (this.end - this.start) * t + this.start),
            this.options.step &&
              this.options.step.call(this.elem, this.now, this),
            n && n.set ? n.set(this) : O.propHooks._default.set(this),
            this
          );
        },
      }),
      (O.prototype.init.prototype = O.prototype),
      (O.propHooks = {
        _default: {
          get: function (e) {
            var t;
            return 1 !== e.elem.nodeType ||
              (null != e.elem[e.prop] && null == e.elem.style[e.prop])
              ? e.elem[e.prop]
              : ((t = oe.css(e.elem, e.prop, "")), t && "auto" !== t ? t : 0);
          },
          set: function (e) {
            oe.fx.step[e.prop]
              ? oe.fx.step[e.prop](e)
              : 1 !== e.elem.nodeType ||
                (null == e.elem.style[oe.cssProps[e.prop]] &&
                  !oe.cssHooks[e.prop])
              ? (e.elem[e.prop] = e.now)
              : oe.style(e.elem, e.prop, e.now + e.unit);
          },
        },
      }),
      (O.propHooks.scrollTop = O.propHooks.scrollLeft =
        {
          set: function (e) {
            e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now);
          },
        }),
      (oe.easing = {
        linear: function (e) {
          return e;
        },
        swing: function (e) {
          return 0.5 - Math.cos(e * Math.PI) / 2;
        },
        _default: "swing",
      }),
      (oe.fx = O.prototype.init),
      (oe.fx.step = {});
    var rt,
      ot,
      st = /^(?:toggle|show|hide)$/,
      at = /queueHooks$/;
    (oe.Animation = oe.extend(R, {
      tweeners: {
        "*": [
          function (e, t) {
            var n = this.createTween(e, t);
            return c(n.elem, e, Ae.exec(t), n), n;
          },
        ],
      },
      tweener: function (e, t) {
        oe.isFunction(e) ? ((t = e), (e = ["*"])) : (e = e.match(we));
        for (var n, i = 0, r = e.length; r > i; i++)
          (n = e[i]),
            (R.tweeners[n] = R.tweeners[n] || []),
            R.tweeners[n].unshift(t);
      },
      prefilters: [I],
      prefilter: function (e, t) {
        t ? R.prefilters.unshift(e) : R.prefilters.push(e);
      },
    })),
      (oe.speed = function (e, t, n) {
        var i =
          e && "object" == typeof e
            ? oe.extend({}, e)
            : {
                complete: n || (!n && t) || (oe.isFunction(e) && e),
                duration: e,
                easing: (n && t) || (t && !oe.isFunction(t) && t),
              };
        return (
          (i.duration = oe.fx.off
            ? 0
            : "number" == typeof i.duration
            ? i.duration
            : i.duration in oe.fx.speeds
            ? oe.fx.speeds[i.duration]
            : oe.fx.speeds._default),
          (null != i.queue && i.queue !== !0) || (i.queue = "fx"),
          (i.old = i.complete),
          (i.complete = function () {
            oe.isFunction(i.old) && i.old.call(this),
              i.queue && oe.dequeue(this, i.queue);
          }),
          i
        );
      }),
      oe.fn.extend({
        fadeTo: function (e, t, n, i) {
          return this.filter(Le)
            .css("opacity", 0)
            .show()
            .end()
            .animate({ opacity: t }, e, n, i);
        },
        animate: function (e, t, n, i) {
          var r = oe.isEmptyObject(e),
            o = oe.speed(t, n, i),
            s = function () {
              var t = R(this, oe.extend({}, e), o);
              (r || Ce.get(this, "finish")) && t.stop(!0);
            };
          return (
            (s.finish = s),
            r || o.queue === !1 ? this.each(s) : this.queue(o.queue, s)
          );
        },
        stop: function (e, t, n) {
          var i = function (e) {
            var t = e.stop;
            delete e.stop, t(n);
          };
          return (
            "string" != typeof e && ((n = t), (t = e), (e = void 0)),
            t && e !== !1 && this.queue(e || "fx", []),
            this.each(function () {
              var t = !0,
                r = null != e && e + "queueHooks",
                o = oe.timers,
                s = Ce.get(this);
              if (r) s[r] && s[r].stop && i(s[r]);
              else for (r in s) s[r] && s[r].stop && at.test(r) && i(s[r]);
              for (r = o.length; r--; )
                o[r].elem !== this ||
                  (null != e && o[r].queue !== e) ||
                  (o[r].anim.stop(n), (t = !1), o.splice(r, 1));
              (!t && n) || oe.dequeue(this, e);
            })
          );
        },
        finish: function (e) {
          return (
            e !== !1 && (e = e || "fx"),
            this.each(function () {
              var t,
                n = Ce.get(this),
                i = n[e + "queue"],
                r = n[e + "queueHooks"],
                o = oe.timers,
                s = i ? i.length : 0;
              for (
                n.finish = !0,
                  oe.queue(this, e, []),
                  r && r.stop && r.stop.call(this, !0),
                  t = o.length;
                t--;

              )
                o[t].elem === this &&
                  o[t].queue === e &&
                  (o[t].anim.stop(!0), o.splice(t, 1));
              for (t = 0; s > t; t++)
                i[t] && i[t].finish && i[t].finish.call(this);
              delete n.finish;
            })
          );
        },
      }),
      oe.each(["toggle", "show", "hide"], function (e, t) {
        var n = oe.fn[t];
        oe.fn[t] = function (e, i, r) {
          return null == e || "boolean" == typeof e
            ? n.apply(this, arguments)
            : this.animate(j(t, !0), e, i, r);
        };
      }),
      oe.each(
        {
          slideDown: j("show"),
          slideUp: j("hide"),
          slideToggle: j("toggle"),
          fadeIn: { opacity: "show" },
          fadeOut: { opacity: "hide" },
          fadeToggle: { opacity: "toggle" },
        },
        function (e, t) {
          oe.fn[e] = function (e, n, i) {
            return this.animate(t, e, n, i);
          };
        }
      ),
      (oe.timers = []),
      (oe.fx.tick = function () {
        var e,
          t = 0,
          n = oe.timers;
        for (rt = oe.now(); t < n.length; t++)
          (e = n[t]), e() || n[t] !== e || n.splice(t--, 1);
        n.length || oe.fx.stop(), (rt = void 0);
      }),
      (oe.fx.timer = function (e) {
        oe.timers.push(e), e() ? oe.fx.start() : oe.timers.pop();
      }),
      (oe.fx.interval = 13),
      (oe.fx.start = function () {
        ot || (ot = e.setInterval(oe.fx.tick, oe.fx.interval));
      }),
      (oe.fx.stop = function () {
        e.clearInterval(ot), (ot = null);
      }),
      (oe.fx.speeds = { slow: 600, fast: 200, _default: 400 }),
      (oe.fn.delay = function (t, n) {
        return (
          (t = oe.fx ? oe.fx.speeds[t] || t : t),
          (n = n || "fx"),
          this.queue(n, function (n, i) {
            var r = e.setTimeout(n, t);
            i.stop = function () {
              e.clearTimeout(r);
            };
          })
        );
      }),
      (function () {
        var e = Y.createElement("input"),
          t = Y.createElement("select"),
          n = t.appendChild(Y.createElement("option"));
        (e.type = "checkbox"),
          (ie.checkOn = "" !== e.value),
          (ie.optSelected = n.selected),
          (t.disabled = !0),
          (ie.optDisabled = !n.disabled),
          (e = Y.createElement("input")),
          (e.value = "t"),
          (e.type = "radio"),
          (ie.radioValue = "t" === e.value);
      })();
    var lt,
      ct = oe.expr.attrHandle;
    oe.fn.extend({
      attr: function (e, t) {
        return Se(this, oe.attr, e, t, arguments.length > 1);
      },
      removeAttr: function (e) {
        return this.each(function () {
          oe.removeAttr(this, e);
        });
      },
    }),
      oe.extend({
        attr: function (e, t, n) {
          var i,
            r,
            o = e.nodeType;
          if (3 !== o && 8 !== o && 2 !== o)
            return "undefined" == typeof e.getAttribute
              ? oe.prop(e, t, n)
              : ((1 === o && oe.isXMLDoc(e)) ||
                  ((t = t.toLowerCase()),
                  (r =
                    oe.attrHooks[t] ||
                    (oe.expr.match.bool.test(t) ? lt : void 0))),
                void 0 !== n
                  ? null === n
                    ? void oe.removeAttr(e, t)
                    : r && "set" in r && void 0 !== (i = r.set(e, n, t))
                    ? i
                    : (e.setAttribute(t, n + ""), n)
                  : r && "get" in r && null !== (i = r.get(e, t))
                  ? i
                  : ((i = oe.find.attr(e, t)), null == i ? void 0 : i));
        },
        attrHooks: {
          type: {
            set: function (e, t) {
              if (!ie.radioValue && "radio" === t && oe.nodeName(e, "input")) {
                var n = e.value;
                return e.setAttribute("type", t), n && (e.value = n), t;
              }
            },
          },
        },
        removeAttr: function (e, t) {
          var n,
            i,
            r = 0,
            o = t && t.match(we);
          if (o && 1 === e.nodeType)
            for (; (n = o[r++]); )
              (i = oe.propFix[n] || n),
                oe.expr.match.bool.test(n) && (e[i] = !1),
                e.removeAttribute(n);
        },
      }),
      (lt = {
        set: function (e, t, n) {
          return t === !1 ? oe.removeAttr(e, n) : e.setAttribute(n, n), n;
        },
      }),
      oe.each(oe.expr.match.bool.source.match(/\w+/g), function (e, t) {
        var n = ct[t] || oe.find.attr;
        ct[t] = function (e, t, i) {
          var r, o;
          return (
            i ||
              ((o = ct[t]),
              (ct[t] = r),
              (r = null != n(e, t, i) ? t.toLowerCase() : null),
              (ct[t] = o)),
            r
          );
        };
      });
    var ut = /^(?:input|select|textarea|button)$/i,
      pt = /^(?:a|area)$/i;
    oe.fn.extend({
      prop: function (e, t) {
        return Se(this, oe.prop, e, t, arguments.length > 1);
      },
      removeProp: function (e) {
        return this.each(function () {
          delete this[oe.propFix[e] || e];
        });
      },
    }),
      oe.extend({
        prop: function (e, t, n) {
          var i,
            r,
            o = e.nodeType;
          if (3 !== o && 8 !== o && 2 !== o)
            return (
              (1 === o && oe.isXMLDoc(e)) ||
                ((t = oe.propFix[t] || t), (r = oe.propHooks[t])),
              void 0 !== n
                ? r && "set" in r && void 0 !== (i = r.set(e, n, t))
                  ? i
                  : (e[t] = n)
                : r && "get" in r && null !== (i = r.get(e, t))
                ? i
                : e[t]
            );
        },
        propHooks: {
          tabIndex: {
            get: function (e) {
              var t = oe.find.attr(e, "tabindex");
              return t
                ? parseInt(t, 10)
                : ut.test(e.nodeName) || (pt.test(e.nodeName) && e.href)
                ? 0
                : -1;
            },
          },
        },
        propFix: { for: "htmlFor", class: "className" },
      }),
      ie.optSelected ||
        (oe.propHooks.selected = {
          get: function (e) {
            var t = e.parentNode;
            return t && t.parentNode && t.parentNode.selectedIndex, null;
          },
          set: function (e) {
            var t = e.parentNode;
            t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex);
          },
        }),
      oe.each(
        [
          "tabIndex",
          "readOnly",
          "maxLength",
          "cellSpacing",
          "cellPadding",
          "rowSpan",
          "colSpan",
          "useMap",
          "frameBorder",
          "contentEditable",
        ],
        function () {
          oe.propFix[this.toLowerCase()] = this;
        }
      );
    var dt = /[\t\r\n\f]/g;
    oe.fn.extend({
      addClass: function (e) {
        var t,
          n,
          i,
          r,
          o,
          s,
          a,
          l = 0;
        if (oe.isFunction(e))
          return this.each(function (t) {
            oe(this).addClass(e.call(this, t, q(this)));
          });
        if ("string" == typeof e && e)
          for (t = e.match(we) || []; (n = this[l++]); )
            if (
              ((r = q(n)),
              (i = 1 === n.nodeType && (" " + r + " ").replace(dt, " ")))
            ) {
              for (s = 0; (o = t[s++]); )
                i.indexOf(" " + o + " ") < 0 && (i += o + " ");
              (a = oe.trim(i)), r !== a && n.setAttribute("class", a);
            }
        return this;
      },
      removeClass: function (e) {
        var t,
          n,
          i,
          r,
          o,
          s,
          a,
          l = 0;
        if (oe.isFunction(e))
          return this.each(function (t) {
            oe(this).removeClass(e.call(this, t, q(this)));
          });
        if (!arguments.length) return this.attr("class", "");
        if ("string" == typeof e && e)
          for (t = e.match(we) || []; (n = this[l++]); )
            if (
              ((r = q(n)),
              (i = 1 === n.nodeType && (" " + r + " ").replace(dt, " ")))
            ) {
              for (s = 0; (o = t[s++]); )
                for (; i.indexOf(" " + o + " ") > -1; )
                  i = i.replace(" " + o + " ", " ");
              (a = oe.trim(i)), r !== a && n.setAttribute("class", a);
            }
        return this;
      },
      toggleClass: function (e, t) {
        var n = typeof e;
        return "boolean" == typeof t && "string" === n
          ? t
            ? this.addClass(e)
            : this.removeClass(e)
          : oe.isFunction(e)
          ? this.each(function (n) {
              oe(this).toggleClass(e.call(this, n, q(this), t), t);
            })
          : this.each(function () {
              var t, i, r, o;
              if ("string" === n)
                for (i = 0, r = oe(this), o = e.match(we) || []; (t = o[i++]); )
                  r.hasClass(t) ? r.removeClass(t) : r.addClass(t);
              else
                (void 0 !== e && "boolean" !== n) ||
                  ((t = q(this)),
                  t && Ce.set(this, "__className__", t),
                  this.setAttribute &&
                    this.setAttribute(
                      "class",
                      t || e === !1 ? "" : Ce.get(this, "__className__") || ""
                    ));
            });
      },
      hasClass: function (e) {
        var t,
          n,
          i = 0;
        for (t = " " + e + " "; (n = this[i++]); )
          if (
            1 === n.nodeType &&
            (" " + q(n) + " ").replace(dt, " ").indexOf(t) > -1
          )
            return !0;
        return !1;
      },
    });
    var ht = /\r/g,
      ft = /[\x20\t\r\n\f]+/g;
    oe.fn.extend({
      val: function (e) {
        var t,
          n,
          i,
          r = this[0];
        return arguments.length
          ? ((i = oe.isFunction(e)),
            this.each(function (n) {
              var r;
              1 === this.nodeType &&
                ((r = i ? e.call(this, n, oe(this).val()) : e),
                null == r
                  ? (r = "")
                  : "number" == typeof r
                  ? (r += "")
                  : oe.isArray(r) &&
                    (r = oe.map(r, function (e) {
                      return null == e ? "" : e + "";
                    })),
                (t =
                  oe.valHooks[this.type] ||
                  oe.valHooks[this.nodeName.toLowerCase()]),
                (t && "set" in t && void 0 !== t.set(this, r, "value")) ||
                  (this.value = r));
            }))
          : r
          ? ((t = oe.valHooks[r.type] || oe.valHooks[r.nodeName.toLowerCase()]),
            t && "get" in t && void 0 !== (n = t.get(r, "value"))
              ? n
              : ((n = r.value),
                "string" == typeof n ? n.replace(ht, "") : null == n ? "" : n))
          : void 0;
      },
    }),
      oe.extend({
        valHooks: {
          option: {
            get: function (e) {
              var t = oe.find.attr(e, "value");
              return null != t ? t : oe.trim(oe.text(e)).replace(ft, " ");
            },
          },
          select: {
            get: function (e) {
              for (
                var t,
                  n,
                  i = e.options,
                  r = e.selectedIndex,
                  o = "select-one" === e.type || 0 > r,
                  s = o ? null : [],
                  a = o ? r + 1 : i.length,
                  l = 0 > r ? a : o ? r : 0;
                a > l;
                l++
              )
                if (
                  ((n = i[l]),
                  (n.selected || l === r) &&
                    (ie.optDisabled
                      ? !n.disabled
                      : null === n.getAttribute("disabled")) &&
                    (!n.parentNode.disabled ||
                      !oe.nodeName(n.parentNode, "optgroup")))
                ) {
                  if (((t = oe(n).val()), o)) return t;
                  s.push(t);
                }
              return s;
            },
            set: function (e, t) {
              for (
                var n, i, r = e.options, o = oe.makeArray(t), s = r.length;
                s--;

              )
                (i = r[s]),
                  (i.selected =
                    oe.inArray(oe.valHooks.option.get(i), o) > -1) && (n = !0);
              return n || (e.selectedIndex = -1), o;
            },
          },
        },
      }),
      oe.each(["radio", "checkbox"], function () {
        (oe.valHooks[this] = {
          set: function (e, t) {
            return oe.isArray(t)
              ? (e.checked = oe.inArray(oe(e).val(), t) > -1)
              : void 0;
          },
        }),
          ie.checkOn ||
            (oe.valHooks[this].get = function (e) {
              return null === e.getAttribute("value") ? "on" : e.value;
            });
      });
    var vt = /^(?:focusinfocus|focusoutblur)$/;
    oe.extend(oe.event, {
      trigger: function (t, n, i, r) {
        var o,
          s,
          a,
          l,
          c,
          u,
          p,
          d = [i || Y],
          h = ne.call(t, "type") ? t.type : t,
          f = ne.call(t, "namespace") ? t.namespace.split(".") : [];
        if (
          ((s = a = i = i || Y),
          3 !== i.nodeType &&
            8 !== i.nodeType &&
            !vt.test(h + oe.event.triggered) &&
            (h.indexOf(".") > -1 &&
              ((f = h.split(".")), (h = f.shift()), f.sort()),
            (c = h.indexOf(":") < 0 && "on" + h),
            (t = t[oe.expando]
              ? t
              : new oe.Event(h, "object" == typeof t && t)),
            (t.isTrigger = r ? 2 : 3),
            (t.namespace = f.join(".")),
            (t.rnamespace = t.namespace
              ? new RegExp("(^|\\.)" + f.join("\\.(?:.*\\.|)") + "(\\.|$)")
              : null),
            (t.result = void 0),
            t.target || (t.target = i),
            (n = null == n ? [t] : oe.makeArray(n, [t])),
            (p = oe.event.special[h] || {}),
            r || !p.trigger || p.trigger.apply(i, n) !== !1))
        ) {
          if (!r && !p.noBubble && !oe.isWindow(i)) {
            for (
              l = p.delegateType || h, vt.test(l + h) || (s = s.parentNode);
              s;
              s = s.parentNode
            )
              d.push(s), (a = s);
            a === (i.ownerDocument || Y) &&
              d.push(a.defaultView || a.parentWindow || e);
          }
          for (o = 0; (s = d[o++]) && !t.isPropagationStopped(); )
            (t.type = o > 1 ? l : p.bindType || h),
              (u = (Ce.get(s, "events") || {})[t.type] && Ce.get(s, "handle")),
              u && u.apply(s, n),
              (u = c && s[c]),
              u &&
                u.apply &&
                Te(s) &&
                ((t.result = u.apply(s, n)),
                t.result === !1 && t.preventDefault());
          return (
            (t.type = h),
            r ||
              t.isDefaultPrevented() ||
              (p._default && p._default.apply(d.pop(), n) !== !1) ||
              !Te(i) ||
              (c &&
                oe.isFunction(i[h]) &&
                !oe.isWindow(i) &&
                ((a = i[c]),
                a && (i[c] = null),
                (oe.event.triggered = h),
                i[h](),
                (oe.event.triggered = void 0),
                a && (i[c] = a))),
            t.result
          );
        }
      },
      simulate: function (e, t, n) {
        var i = oe.extend(new oe.Event(), n, { type: e, isSimulated: !0 });
        oe.event.trigger(i, null, t),
          i.isDefaultPrevented() && n.preventDefault();
      },
    }),
      oe.fn.extend({
        trigger: function (e, t) {
          return this.each(function () {
            oe.event.trigger(e, t, this);
          });
        },
        triggerHandler: function (e, t) {
          var n = this[0];
          return n ? oe.event.trigger(e, t, n, !0) : void 0;
        },
      }),
      oe.each(
        "blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(
          " "
        ),
        function (e, t) {
          oe.fn[t] = function (e, n) {
            return arguments.length > 0
              ? this.on(t, null, e, n)
              : this.trigger(t);
          };
        }
      ),
      oe.fn.extend({
        hover: function (e, t) {
          return this.mouseenter(e).mouseleave(t || e);
        },
      }),
      (ie.focusin = "onfocusin" in e),
      ie.focusin ||
        oe.each({ focus: "focusin", blur: "focusout" }, function (e, t) {
          var n = function (e) {
            oe.event.simulate(t, e.target, oe.event.fix(e));
          };
          oe.event.special[t] = {
            setup: function () {
              var i = this.ownerDocument || this,
                r = Ce.access(i, t);
              r || i.addEventListener(e, n, !0), Ce.access(i, t, (r || 0) + 1);
            },
            teardown: function () {
              var i = this.ownerDocument || this,
                r = Ce.access(i, t) - 1;
              r
                ? Ce.access(i, t, r)
                : (i.removeEventListener(e, n, !0), Ce.remove(i, t));
            },
          };
        });
    var gt = e.location,
      mt = oe.now(),
      yt = /\?/;
    (oe.parseJSON = function (e) {
      return JSON.parse(e + "");
    }),
      (oe.parseXML = function (t) {
        var n;
        if (!t || "string" != typeof t) return null;
        try {
          n = new e.DOMParser().parseFromString(t, "text/xml");
        } catch (e) {
          n = void 0;
        }
        return (
          (n && !n.getElementsByTagName("parsererror").length) ||
            oe.error("Invalid XML: " + t),
          n
        );
      });
    var bt = /#.*$/,
      kt = /([?&])_=[^&]*/,
      wt = /^(.*?):[ \t]*([^\r\n]*)$/gm,
      xt = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
      St = /^(?:GET|HEAD)$/,
      Tt = /^\/\//,
      Ct = {},
      Et = {},
      Pt = "*/".concat("*"),
      $t = Y.createElement("a");
    ($t.href = gt.href),
      oe.extend({
        active: 0,
        lastModified: {},
        etag: {},
        ajaxSettings: {
          url: gt.href,
          type: "GET",
          isLocal: xt.test(gt.protocol),
          global: !0,
          processData: !0,
          async: !0,
          contentType: "application/x-www-form-urlencoded; charset=UTF-8",
          accepts: {
            "*": Pt,
            text: "text/plain",
            html: "text/html",
            xml: "application/xml, text/xml",
            json: "application/json, text/javascript",
          },
          contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ },
          responseFields: {
            xml: "responseXML",
            text: "responseText",
            json: "responseJSON",
          },
          converters: {
            "* text": String,
            "text html": !0,
            "text json": oe.parseJSON,
            "text xml": oe.parseXML,
          },
          flatOptions: { url: !0, context: !0 },
        },
        ajaxSetup: function (e, t) {
          return t ? z(z(e, oe.ajaxSettings), t) : z(oe.ajaxSettings, e);
        },
        ajaxPrefilter: B(Ct),
        ajaxTransport: B(Et),
        ajax: function (t, n) {
          function i(t, n, i, a) {
            var c,
              p,
              y,
              b,
              w,
              S = n;
            2 !== k &&
              ((k = 2),
              l && e.clearTimeout(l),
              (r = void 0),
              (s = a || ""),
              (x.readyState = t > 0 ? 4 : 0),
              (c = (t >= 200 && 300 > t) || 304 === t),
              i && (b = W(d, x, i)),
              (b = U(d, b, x, c)),
              c
                ? (d.ifModified &&
                    ((w = x.getResponseHeader("Last-Modified")),
                    w && (oe.lastModified[o] = w),
                    (w = x.getResponseHeader("etag")),
                    w && (oe.etag[o] = w)),
                  204 === t || "HEAD" === d.type
                    ? (S = "nocontent")
                    : 304 === t
                    ? (S = "notmodified")
                    : ((S = b.state), (p = b.data), (y = b.error), (c = !y)))
                : ((y = S), (!t && S) || ((S = "error"), 0 > t && (t = 0))),
              (x.status = t),
              (x.statusText = (n || S) + ""),
              c ? v.resolveWith(h, [p, S, x]) : v.rejectWith(h, [x, S, y]),
              x.statusCode(m),
              (m = void 0),
              u &&
                f.trigger(c ? "ajaxSuccess" : "ajaxError", [x, d, c ? p : y]),
              g.fireWith(h, [x, S]),
              u &&
                (f.trigger("ajaxComplete", [x, d]),
                --oe.active || oe.event.trigger("ajaxStop")));
          }
          "object" == typeof t && ((n = t), (t = void 0)), (n = n || {});
          var r,
            o,
            s,
            a,
            l,
            c,
            u,
            p,
            d = oe.ajaxSetup({}, n),
            h = d.context || d,
            f = d.context && (h.nodeType || h.jquery) ? oe(h) : oe.event,
            v = oe.Deferred(),
            g = oe.Callbacks("once memory"),
            m = d.statusCode || {},
            y = {},
            b = {},
            k = 0,
            w = "canceled",
            x = {
              readyState: 0,
              getResponseHeader: function (e) {
                var t;
                if (2 === k) {
                  if (!a)
                    for (a = {}; (t = wt.exec(s)); )
                      a[t[1].toLowerCase()] = t[2];
                  t = a[e.toLowerCase()];
                }
                return null == t ? null : t;
              },
              getAllResponseHeaders: function () {
                return 2 === k ? s : null;
              },
              setRequestHeader: function (e, t) {
                var n = e.toLowerCase();
                return k || ((e = b[n] = b[n] || e), (y[e] = t)), this;
              },
              overrideMimeType: function (e) {
                return k || (d.mimeType = e), this;
              },
              statusCode: function (e) {
                var t;
                if (e)
                  if (2 > k) for (t in e) m[t] = [m[t], e[t]];
                  else x.always(e[x.status]);
                return this;
              },
              abort: function (e) {
                var t = e || w;
                return r && r.abort(t), i(0, t), this;
              },
            };
          if (
            ((v.promise(x).complete = g.add),
            (x.success = x.done),
            (x.error = x.fail),
            (d.url = ((t || d.url || gt.href) + "")
              .replace(bt, "")
              .replace(Tt, gt.protocol + "//")),
            (d.type = n.method || n.type || d.method || d.type),
            (d.dataTypes = oe
              .trim(d.dataType || "*")
              .toLowerCase()
              .match(we) || [""]),
            null == d.crossDomain)
          ) {
            c = Y.createElement("a");
            try {
              (c.href = d.url),
                (c.href = c.href),
                (d.crossDomain =
                  $t.protocol + "//" + $t.host != c.protocol + "//" + c.host);
            } catch (e) {
              d.crossDomain = !0;
            }
          }
          if (
            (d.data &&
              d.processData &&
              "string" != typeof d.data &&
              (d.data = oe.param(d.data, d.traditional)),
            F(Ct, d, n, x),
            2 === k)
          )
            return x;
          (u = oe.event && d.global),
            u && 0 === oe.active++ && oe.event.trigger("ajaxStart"),
            (d.type = d.type.toUpperCase()),
            (d.hasContent = !St.test(d.type)),
            (o = d.url),
            d.hasContent ||
              (d.data &&
                ((o = d.url += (yt.test(o) ? "&" : "?") + d.data),
                delete d.data),
              d.cache === !1 &&
                (d.url = kt.test(o)
                  ? o.replace(kt, "$1_=" + mt++)
                  : o + (yt.test(o) ? "&" : "?") + "_=" + mt++)),
            d.ifModified &&
              (oe.lastModified[o] &&
                x.setRequestHeader("If-Modified-Since", oe.lastModified[o]),
              oe.etag[o] && x.setRequestHeader("If-None-Match", oe.etag[o])),
            ((d.data && d.hasContent && d.contentType !== !1) ||
              n.contentType) &&
              x.setRequestHeader("Content-Type", d.contentType),
            x.setRequestHeader(
              "Accept",
              d.dataTypes[0] && d.accepts[d.dataTypes[0]]
                ? d.accepts[d.dataTypes[0]] +
                    ("*" !== d.dataTypes[0] ? ", " + Pt + "; q=0.01" : "")
                : d.accepts["*"]
            );
          for (p in d.headers) x.setRequestHeader(p, d.headers[p]);
          if (d.beforeSend && (d.beforeSend.call(h, x, d) === !1 || 2 === k))
            return x.abort();
          w = "abort";
          for (p in { success: 1, error: 1, complete: 1 }) x[p](d[p]);
          if ((r = F(Et, d, n, x))) {
            if (
              ((x.readyState = 1), u && f.trigger("ajaxSend", [x, d]), 2 === k)
            )
              return x;
            d.async &&
              d.timeout > 0 &&
              (l = e.setTimeout(function () {
                x.abort("timeout");
              }, d.timeout));
            try {
              (k = 1), r.send(y, i);
            } catch (e) {
              if (!(2 > k)) throw e;
              i(-1, e);
            }
          } else i(-1, "No Transport");
          return x;
        },
        getJSON: function (e, t, n) {
          return oe.get(e, t, n, "json");
        },
        getScript: function (e, t) {
          return oe.get(e, void 0, t, "script");
        },
      }),
      oe.each(["get", "post"], function (e, t) {
        oe[t] = function (e, n, i, r) {
          return (
            oe.isFunction(n) && ((r = r || i), (i = n), (n = void 0)),
            oe.ajax(
              oe.extend(
                { url: e, type: t, dataType: r, data: n, success: i },
                oe.isPlainObject(e) && e
              )
            )
          );
        };
      }),
      (oe._evalUrl = function (e) {
        return oe.ajax({
          url: e,
          type: "GET",
          dataType: "script",
          async: !1,
          global: !1,
          throws: !0,
        });
      }),
      oe.fn.extend({
        wrapAll: function (e) {
          var t;
          return oe.isFunction(e)
            ? this.each(function (t) {
                oe(this).wrapAll(e.call(this, t));
              })
            : (this[0] &&
                ((t = oe(e, this[0].ownerDocument).eq(0).clone(!0)),
                this[0].parentNode && t.insertBefore(this[0]),
                t
                  .map(function () {
                    for (var e = this; e.firstElementChild; )
                      e = e.firstElementChild;
                    return e;
                  })
                  .append(this)),
              this);
        },
        wrapInner: function (e) {
          return oe.isFunction(e)
            ? this.each(function (t) {
                oe(this).wrapInner(e.call(this, t));
              })
            : this.each(function () {
                var t = oe(this),
                  n = t.contents();
                n.length ? n.wrapAll(e) : t.append(e);
              });
        },
        wrap: function (e) {
          var t = oe.isFunction(e);
          return this.each(function (n) {
            oe(this).wrapAll(t ? e.call(this, n) : e);
          });
        },
        unwrap: function () {
          return this.parent()
            .each(function () {
              oe.nodeName(this, "body") ||
                oe(this).replaceWith(this.childNodes);
            })
            .end();
        },
      }),
      (oe.expr.filters.hidden = function (e) {
        return !oe.expr.filters.visible(e);
      }),
      (oe.expr.filters.visible = function (e) {
        return (
          e.offsetWidth > 0 ||
          e.offsetHeight > 0 ||
          e.getClientRects().length > 0
        );
      });
    var _t = /%20/g,
      At = /\[\]$/,
      Nt = /\r?\n/g,
      Lt = /^(?:submit|button|image|reset|file)$/i,
      Ot = /^(?:input|select|textarea|keygen)/i;
    (oe.param = function (e, t) {
      var n,
        i = [],
        r = function (e, t) {
          (t = oe.isFunction(t) ? t() : null == t ? "" : t),
            (i[i.length] = encodeURIComponent(e) + "=" + encodeURIComponent(t));
        };
      if (
        (void 0 === t && (t = oe.ajaxSettings && oe.ajaxSettings.traditional),
        oe.isArray(e) || (e.jquery && !oe.isPlainObject(e)))
      )
        oe.each(e, function () {
          r(this.name, this.value);
        });
      else for (n in e) V(n, e[n], t, r);
      return i.join("&").replace(_t, "+");
    }),
      oe.fn.extend({
        serialize: function () {
          return oe.param(this.serializeArray());
        },
        serializeArray: function () {
          return this.map(function () {
            var e = oe.prop(this, "elements");
            return e ? oe.makeArray(e) : this;
          })
            .filter(function () {
              var e = this.type;
              return (
                this.name &&
                !oe(this).is(":disabled") &&
                Ot.test(this.nodeName) &&
                !Lt.test(e) &&
                (this.checked || !Oe.test(e))
              );
            })
            .map(function (e, t) {
              var n = oe(this).val();
              return null == n
                ? null
                : oe.isArray(n)
                ? oe.map(n, function (e) {
                    return { name: t.name, value: e.replace(Nt, "\r\n") };
                  })
                : { name: t.name, value: n.replace(Nt, "\r\n") };
            })
            .get();
        },
      }),
      (oe.ajaxSettings.xhr = function () {
        try {
          return new e.XMLHttpRequest();
        } catch (e) {}
      });
    var Dt = { 0: 200, 1223: 204 },
      jt = oe.ajaxSettings.xhr();
    (ie.cors = !!jt && "withCredentials" in jt),
      (ie.ajax = jt = !!jt),
      oe.ajaxTransport(function (t) {
        var n, i;
        return ie.cors || (jt && !t.crossDomain)
          ? {
              send: function (r, o) {
                var s,
                  a = t.xhr();
                if (
                  (a.open(t.type, t.url, t.async, t.username, t.password),
                  t.xhrFields)
                )
                  for (s in t.xhrFields) a[s] = t.xhrFields[s];
                t.mimeType &&
                  a.overrideMimeType &&
                  a.overrideMimeType(t.mimeType),
                  t.crossDomain ||
                    r["X-Requested-With"] ||
                    (r["X-Requested-With"] = "XMLHttpRequest");
                for (s in r) a.setRequestHeader(s, r[s]);
                (n = function (e) {
                  return function () {
                    n &&
                      ((n =
                        i =
                        a.onload =
                        a.onerror =
                        a.onabort =
                        a.onreadystatechange =
                          null),
                      "abort" === e
                        ? a.abort()
                        : "error" === e
                        ? "number" != typeof a.status
                          ? o(0, "error")
                          : o(a.status, a.statusText)
                        : o(
                            Dt[a.status] || a.status,
                            a.statusText,
                            "text" !== (a.responseType || "text") ||
                              "string" != typeof a.responseText
                              ? { binary: a.response }
                              : { text: a.responseText },
                            a.getAllResponseHeaders()
                          ));
                  };
                }),
                  (a.onload = n()),
                  (i = a.onerror = n("error")),
                  void 0 !== a.onabort
                    ? (a.onabort = i)
                    : (a.onreadystatechange = function () {
                        4 === a.readyState &&
                          e.setTimeout(function () {
                            n && i();
                          });
                      }),
                  (n = n("abort"));
                try {
                  a.send((t.hasContent && t.data) || null);
                } catch (e) {
                  if (n) throw e;
                }
              },
              abort: function () {
                n && n();
              },
            }
          : void 0;
      }),
      oe.ajaxSetup({
        accepts: {
          script:
            "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript",
        },
        contents: { script: /\b(?:java|ecma)script\b/ },
        converters: {
          "text script": function (e) {
            return oe.globalEval(e), e;
          },
        },
      }),
      oe.ajaxPrefilter("script", function (e) {
        void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = "GET");
      }),
      oe.ajaxTransport("script", function (e) {
        if (e.crossDomain) {
          var t, n;
          return {
            send: function (i, r) {
              (t = oe("<script>")
                .prop({ charset: e.scriptCharset, src: e.url })
                .on(
                  "load error",
                  (n = function (e) {
                    t.remove(),
                      (n = null),
                      e && r("error" === e.type ? 404 : 200, e.type);
                  })
                )),
                Y.head.appendChild(t[0]);
            },
            abort: function () {
              n && n();
            },
          };
        }
      });
    var Ht = [],
      It = /(=)\?(?=&|$)|\?\?/;
    oe.ajaxSetup({
      jsonp: "callback",
      jsonpCallback: function () {
        var e = Ht.pop() || oe.expando + "_" + mt++;
        return (this[e] = !0), e;
      },
    }),
      oe.ajaxPrefilter("json jsonp", function (t, n, i) {
        var r,
          o,
          s,
          a =
            t.jsonp !== !1 &&
            (It.test(t.url)
              ? "url"
              : "string" == typeof t.data &&
                0 ===
                  (t.contentType || "").indexOf(
                    "application/x-www-form-urlencoded"
                  ) &&
                It.test(t.data) &&
                "data");
        return a || "jsonp" === t.dataTypes[0]
          ? ((r = t.jsonpCallback =
              oe.isFunction(t.jsonpCallback)
                ? t.jsonpCallback()
                : t.jsonpCallback),
            a
              ? (t[a] = t[a].replace(It, "$1" + r))
              : t.jsonp !== !1 &&
                (t.url += (yt.test(t.url) ? "&" : "?") + t.jsonp + "=" + r),
            (t.converters["script json"] = function () {
              return s || oe.error(r + " was not called"), s[0];
            }),
            (t.dataTypes[0] = "json"),
            (o = e[r]),
            (e[r] = function () {
              s = arguments;
            }),
            i.always(function () {
              void 0 === o ? oe(e).removeProp(r) : (e[r] = o),
                t[r] && ((t.jsonpCallback = n.jsonpCallback), Ht.push(r)),
                s && oe.isFunction(o) && o(s[0]),
                (s = o = void 0);
            }),
            "script")
          : void 0;
      }),
      (oe.parseHTML = function (e, t, n) {
        if (!e || "string" != typeof e) return null;
        "boolean" == typeof t && ((n = t), (t = !1)), (t = t || Y);
        var i = fe.exec(e),
          r = !n && [];
        return i
          ? [t.createElement(i[1])]
          : ((i = d([e], t, r)),
            r && r.length && oe(r).remove(),
            oe.merge([], i.childNodes));
      });
    var Mt = oe.fn.load;
    (oe.fn.load = function (e, t, n) {
      if ("string" != typeof e && Mt) return Mt.apply(this, arguments);
      var i,
        r,
        o,
        s = this,
        a = e.indexOf(" ");
      return (
        a > -1 && ((i = oe.trim(e.slice(a))), (e = e.slice(0, a))),
        oe.isFunction(t)
          ? ((n = t), (t = void 0))
          : t && "object" == typeof t && (r = "POST"),
        s.length > 0 &&
          oe
            .ajax({ url: e, type: r || "GET", dataType: "html", data: t })
            .done(function (e) {
              (o = arguments),
                s.html(i ? oe("<div>").append(oe.parseHTML(e)).find(i) : e);
            })
            .always(
              n &&
                function (e, t) {
                  s.each(function () {
                    n.apply(this, o || [e.responseText, t, e]);
                  });
                }
            ),
        this
      );
    }),
      oe.each(
        [
          "ajaxStart",
          "ajaxStop",
          "ajaxComplete",
          "ajaxError",
          "ajaxSuccess",
          "ajaxSend",
        ],
        function (e, t) {
          oe.fn[t] = function (e) {
            return this.on(t, e);
          };
        }
      ),
      (oe.expr.filters.animated = function (e) {
        return oe.grep(oe.timers, function (t) {
          return e === t.elem;
        }).length;
      }),
      (oe.offset = {
        setOffset: function (e, t, n) {
          var i,
            r,
            o,
            s,
            a,
            l,
            c,
            u = oe.css(e, "position"),
            p = oe(e),
            d = {};
          "static" === u && (e.style.position = "relative"),
            (a = p.offset()),
            (o = oe.css(e, "top")),
            (l = oe.css(e, "left")),
            (c =
              ("absolute" === u || "fixed" === u) &&
              (o + l).indexOf("auto") > -1),
            c
              ? ((i = p.position()), (s = i.top), (r = i.left))
              : ((s = parseFloat(o) || 0), (r = parseFloat(l) || 0)),
            oe.isFunction(t) && (t = t.call(e, n, oe.extend({}, a))),
            null != t.top && (d.top = t.top - a.top + s),
            null != t.left && (d.left = t.left - a.left + r),
            "using" in t ? t.using.call(e, d) : p.css(d);
        },
      }),
      oe.fn.extend({
        offset: function (e) {
          if (arguments.length)
            return void 0 === e
              ? this
              : this.each(function (t) {
                  oe.offset.setOffset(this, e, t);
                });
          var t,
            n,
            i = this[0],
            r = { top: 0, left: 0 },
            o = i && i.ownerDocument;
          return o
            ? ((t = o.documentElement),
              oe.contains(t, i)
                ? ((r = i.getBoundingClientRect()),
                  (n = X(o)),
                  {
                    top: r.top + n.pageYOffset - t.clientTop,
                    left: r.left + n.pageXOffset - t.clientLeft,
                  })
                : r)
            : void 0;
        },
        position: function () {
          if (this[0]) {
            var e,
              t,
              n = this[0],
              i = { top: 0, left: 0 };
            return (
              "fixed" === oe.css(n, "position")
                ? (t = n.getBoundingClientRect())
                : ((e = this.offsetParent()),
                  (t = this.offset()),
                  oe.nodeName(e[0], "html") || (i = e.offset()),
                  (i.top += oe.css(e[0], "borderTopWidth", !0)),
                  (i.left += oe.css(e[0], "borderLeftWidth", !0))),
              {
                top: t.top - i.top - oe.css(n, "marginTop", !0),
                left: t.left - i.left - oe.css(n, "marginLeft", !0),
              }
            );
          }
        },
        offsetParent: function () {
          return this.map(function () {
            for (
              var e = this.offsetParent;
              e && "static" === oe.css(e, "position");

            )
              e = e.offsetParent;
            return e || Qe;
          });
        },
      }),
      oe.each(
        { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" },
        function (e, t) {
          var n = "pageYOffset" === t;
          oe.fn[e] = function (i) {
            return Se(
              this,
              function (e, i, r) {
                var o = X(e);
                return void 0 === r
                  ? o
                    ? o[t]
                    : e[i]
                  : void (o
                      ? o.scrollTo(n ? o.pageXOffset : r, n ? r : o.pageYOffset)
                      : (e[i] = r));
              },
              e,
              i,
              arguments.length
            );
          };
        }
      ),
      oe.each(["top", "left"], function (e, t) {
        oe.cssHooks[t] = P(ie.pixelPosition, function (e, n) {
          return n
            ? ((n = E(e, t)), Ye.test(n) ? oe(e).position()[t] + "px" : n)
            : void 0;
        });
      }),
      oe.each({ Height: "height", Width: "width" }, function (e, t) {
        oe.each(
          { padding: "inner" + e, content: t, "": "outer" + e },
          function (n, i) {
            oe.fn[i] = function (i, r) {
              var o = arguments.length && (n || "boolean" != typeof i),
                s = n || (i === !0 || r === !0 ? "margin" : "border");
              return Se(
                this,
                function (t, n, i) {
                  var r;
                  return oe.isWindow(t)
                    ? t.document.documentElement["client" + e]
                    : 9 === t.nodeType
                    ? ((r = t.documentElement),
                      Math.max(
                        t.body["scroll" + e],
                        r["scroll" + e],
                        t.body["offset" + e],
                        r["offset" + e],
                        r["client" + e]
                      ))
                    : void 0 === i
                    ? oe.css(t, n, s)
                    : oe.style(t, n, i, s);
                },
                t,
                o ? i : void 0,
                o,
                null
              );
            };
          }
        );
      }),
      oe.fn.extend({
        bind: function (e, t, n) {
          return this.on(e, null, t, n);
        },
        unbind: function (e, t) {
          return this.off(e, null, t);
        },
        delegate: function (e, t, n, i) {
          return this.on(t, e, n, i);
        },
        undelegate: function (e, t, n) {
          return 1 === arguments.length
            ? this.off(e, "**")
            : this.off(t, e || "**", n);
        },
        size: function () {
          return this.length;
        },
      }),
      (oe.fn.andSelf = oe.fn.addBack),
      "function" == typeof define &&
        define.amd &&
        define("jquery", [], function () {
          return oe;
        });
    var Rt = e.jQuery,
      qt = e.$;
    return (
      (oe.noConflict = function (t) {
        return (
          e.$ === oe && (e.$ = qt), t && e.jQuery === oe && (e.jQuery = Rt), oe
        );
      }),
      t || (e.jQuery = e.$ = oe),
      oe
    );
  })
  /*!
   * modernizr.min.js
   */,
  /*! modernizr 3.3.1 (Custom Build) | MIT *
   * https://modernizr.com/download/?-csstransforms-csstransforms3d-csstransitions-svg-domprefixes-prefixes-setclasses-testallprops-testprop-teststyles !*/
  !(function (e, t, n) {
    function i(e, t) {
      return typeof e === t;
    }
    function r() {
      var e, t, n, r, o, s, a;
      for (var l in b)
        if (b.hasOwnProperty(l)) {
          if (
            ((e = []),
            (t = b[l]),
            t.name &&
              (e.push(t.name.toLowerCase()),
              t.options && t.options.aliases && t.options.aliases.length))
          )
            for (n = 0; n < t.options.aliases.length; n++)
              e.push(t.options.aliases[n].toLowerCase());
          for (
            r = i(t.fn, "function") ? t.fn() : t.fn, o = 0;
            o < e.length;
            o++
          )
            (s = e[o]),
              (a = s.split(".")),
              1 === a.length
                ? (w[a[0]] = r)
                : (!w[a[0]] ||
                    w[a[0]] instanceof Boolean ||
                    (w[a[0]] = new Boolean(w[a[0]])),
                  (w[a[0]][a[1]] = r)),
              y.push((r ? "" : "no-") + a.join("-"));
        }
    }
    function o(e) {
      var t = S.className,
        n = w._config.classPrefix || "";
      if ((T && (t = t.baseVal), w._config.enableJSClass)) {
        var i = new RegExp("(^|\\s)" + n + "no-js(\\s|$)");
        t = t.replace(i, "$1" + n + "js$2");
      }
      w._config.enableClasses &&
        ((t += " " + n + e.join(" " + n)),
        T ? (S.className.baseVal = t) : (S.className = t));
    }
    function s(e, t) {
      return !!~("" + e).indexOf(t);
    }
    function a() {
      return "function" != typeof t.createElement
        ? t.createElement(arguments[0])
        : T
        ? t.createElementNS.call(t, "http://www.w3.org/2000/svg", arguments[0])
        : t.createElement.apply(t, arguments);
    }
    function l(e) {
      return e
        .replace(/([a-z])-([a-z])/g, function (e, t, n) {
          return t + n.toUpperCase();
        })
        .replace(/^-/, "");
    }
    function c() {
      var e = t.body;
      return e || ((e = a(T ? "svg" : "body")), (e.fake = !0)), e;
    }
    function u(e, n, i, r) {
      var o,
        s,
        l,
        u,
        p = "modernizr",
        d = a("div"),
        h = c();
      if (parseInt(i, 10))
        for (; i--; )
          (l = a("div")), (l.id = r ? r[i] : p + (i + 1)), d.appendChild(l);
      return (
        (o = a("style")),
        (o.type = "text/css"),
        (o.id = "s" + p),
        (h.fake ? h : d).appendChild(o),
        h.appendChild(d),
        o.styleSheet
          ? (o.styleSheet.cssText = e)
          : o.appendChild(t.createTextNode(e)),
        (d.id = p),
        h.fake &&
          ((h.style.background = ""),
          (h.style.overflow = "hidden"),
          (u = S.style.overflow),
          (S.style.overflow = "hidden"),
          S.appendChild(h)),
        (s = n(d, e)),
        h.fake
          ? (h.parentNode.removeChild(h),
            (S.style.overflow = u),
            S.offsetHeight)
          : d.parentNode.removeChild(d),
        !!s
      );
    }
    function p(e) {
      return e
        .replace(/([A-Z])/g, function (e, t) {
          return "-" + t.toLowerCase();
        })
        .replace(/^ms-/, "-ms-");
    }
    function d(t, i) {
      var r = t.length;
      if ("CSS" in e && "supports" in e.CSS) {
        for (; r--; ) if (e.CSS.supports(p(t[r]), i)) return !0;
        return !1;
      }
      if ("CSSSupportsRule" in e) {
        for (var o = []; r--; ) o.push("(" + p(t[r]) + ":" + i + ")");
        return (
          (o = o.join(" or ")),
          u(
            "@supports (" + o + ") { #modernizr { position: absolute; } }",
            function (e) {
              return "absolute" == getComputedStyle(e, null).position;
            }
          )
        );
      }
      return n;
    }
    function h(e, t, r, o) {
      function c() {
        p && (delete L.style, delete L.modElem);
      }
      if (((o = !i(o, "undefined") && o), !i(r, "undefined"))) {
        var u = d(e, r);
        if (!i(u, "undefined")) return u;
      }
      for (
        var p, h, f, v, g, m = ["modernizr", "tspan", "samp"];
        !L.style && m.length;

      )
        (p = !0), (L.modElem = a(m.shift())), (L.style = L.modElem.style);
      for (f = e.length, h = 0; f > h; h++)
        if (
          ((v = e[h]),
          (g = L.style[v]),
          s(v, "-") && (v = l(v)),
          L.style[v] !== n)
        ) {
          if (o || i(r, "undefined")) return c(), "pfx" != t || v;
          try {
            L.style[v] = r;
          } catch (e) {}
          if (L.style[v] != g) return c(), "pfx" != t || v;
        }
      return c(), !1;
    }
    function f(e, t) {
      return function () {
        return e.apply(t, arguments);
      };
    }
    function v(e, t, n) {
      var r;
      for (var o in e)
        if (e[o] in t)
          return n === !1
            ? e[o]
            : ((r = t[e[o]]), i(r, "function") ? f(r, n || t) : r);
      return !1;
    }
    function g(e, t, n, r, o) {
      var s = e.charAt(0).toUpperCase() + e.slice(1),
        a = (e + " " + _.join(s + " ") + s).split(" ");
      return i(t, "string") || i(t, "undefined")
        ? h(a, t, r, o)
        : ((a = (e + " " + E.join(s + " ") + s).split(" ")), v(a, t, n));
    }
    function m(e, t, i) {
      return g(e, n, n, t, i);
    }
    var y = [],
      b = [],
      k = {
        _version: "3.3.1",
        _config: {
          classPrefix: "",
          enableClasses: !0,
          enableJSClass: !0,
          usePrefixes: !0,
        },
        _q: [],
        on: function (e, t) {
          var n = this;
          setTimeout(function () {
            t(n[e]);
          }, 0);
        },
        addTest: function (e, t, n) {
          b.push({ name: e, fn: t, options: n });
        },
        addAsyncTest: function (e) {
          b.push({ name: null, fn: e });
        },
      },
      w = function () {};
    (w.prototype = k),
      (w = new w()),
      w.addTest(
        "svg",
        !!t.createElementNS &&
          !!t.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGRect
      );
    var x = k._config.usePrefixes
      ? " -webkit- -moz- -o- -ms- ".split(" ")
      : ["", ""];
    k._prefixes = x;
    var S = t.documentElement,
      T = "svg" === S.nodeName.toLowerCase(),
      C = "Moz O ms Webkit",
      E = k._config.usePrefixes ? C.toLowerCase().split(" ") : [];
    k._domPrefixes = E;
    var P = "CSS" in e && "supports" in e.CSS,
      $ = "supportsCSS" in e;
    w.addTest("supports", P || $);
    var _ = k._config.usePrefixes ? C.split(" ") : [];
    k._cssomPrefixes = _;
    var A = (k.testStyles = u),
      N = { elem: a("modernizr") };
    w._q.push(function () {
      delete N.elem;
    });
    var L = { style: N.elem.style };
    w._q.unshift(function () {
      delete L.style;
    }),
      (k.testProp = function (e, t, i) {
        return h([e], n, t, i);
      }),
      (k.testAllProps = g),
      (k.testAllProps = m),
      w.addTest("csstransforms", function () {
        return (
          -1 === navigator.userAgent.indexOf("Android 2.") &&
          m("transform", "scale(1)", !0)
        );
      }),
      w.addTest("csstransforms3d", function () {
        var e = !!m("perspective", "1px", !0),
          t = w._config.usePrefixes;
        if (e && (!t || "webkitPerspective" in S.style)) {
          var n,
            i = "#modernizr{width:0;height:0}";
          w.supports
            ? (n = "@supports (perspective: 1px)")
            : ((n = "@media (transform-3d)"),
              t && (n += ",(-webkit-transform-3d)")),
            (n +=
              "{#modernizr{width:7px;height:18px;margin:0;padding:0;border:0}}"),
            A(i + n, function (t) {
              e = 7 === t.offsetWidth && 18 === t.offsetHeight;
            });
        }
        return e;
      }),
      w.addTest("csstransitions", m("transition", "all", !0)),
      r(),
      o(y),
      delete k.addTest,
      delete k.addAsyncTest;
    for (var O = 0; O < w._q.length; O++) w._q[O]();
    e.Modernizr = w;
  })(window, document)
  /*!
   * prepare-transition.min.js
   */,
  /* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
  (function (e) {
    e.fn.prepareTransition = function () {
      return this.each(function () {
        var t = e(this);
        t.one(
          "TransitionEnd webkitTransitionEnd transitionend oTransitionEnd",
          function () {
            t.removeClass("is-transitioning");
          }
        );
        var n = [
            "transition-duration",
            "-moz-transition-duration",
            "-webkit-transition-duration",
            "-o-transition-duration",
          ],
          i = 0;
        e.each(n, function (e, n) {
          i = parseFloat(t.css(n)) || i;
        }),
          0 != i && (t.addClass("is-transitioning"), t[0].offsetWidth);
      });
    };
  })(jQuery)
  /*!
   * slick.min.js
   */,
  !(function (e) {
    "use strict";
    "function" == typeof define && define.amd
      ? define(["jquery"], e)
      : "undefined" != typeof exports
      ? (module.exports = e(require("jquery")))
      : e(jQuery);
  })(function (e) {
    "use strict";
    var t = window.Slick || {};
    (t = (function () {
      function t(t, i) {
        var r,
          o = this;
        (o.defaults = {
          accessibility: !0,
          adaptiveHeight: !1,
          appendArrows: e(t),
          appendDots: e(t),
          arrows: !0,
          asNavFor: null,
          prevArrow:
            '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button">Previous</button>',
          nextArrow:
            '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button">Next</button>',
          autoplay: !1,
          autoplaySpeed: 3e3,
          centerMode: !1,
          centerPadding: "50px",
          cssEase: "ease",
          customPaging: function (t, n) {
            return e(
              '<button type="button" data-role="none" role="button" tabindex="0" />'
            ).text(n + 1);
          },
          dots: !1,
          dotsClass: "slick-dots",
          draggable: !0,
          easing: "linear",
          edgeFriction: 0.35,
          fade: !1,
          focusOnSelect: !1,
          infinite: !0,
          initialSlide: 0,
          lazyLoad: "ondemand",
          mobileFirst: !1,
          pauseOnHover: !0,
          pauseOnFocus: !0,
          pauseOnDotsHover: !1,
          respondTo: "window",
          responsive: null,
          rows: 1,
          rtl: !1,
          slide: "",
          slidesPerRow: 1,
          slidesToShow: 1,
          slidesToScroll: 1,
          speed: 500,
          swipe: !0,
          swipeToSlide: !1,
          touchMove: !0,
          touchThreshold: 5,
          useCSS: !0,
          useTransform: !0,
          variableWidth: !1,
          vertical: !1,
          verticalSwiping: !1,
          waitForAnimate: !0,
          zIndex: 1e3,
        }),
          (o.initials = {
            animating: !1,
            dragging: !1,
            autoPlayTimer: null,
            currentDirection: 0,
            currentLeft: null,
            currentSlide: 0,
            direction: 1,
            $dots: null,
            listWidth: null,
            listHeight: null,
            loadIndex: 0,
            $nextArrow: null,
            $prevArrow: null,
            slideCount: null,
            slideWidth: null,
            $slideTrack: null,
            $slides: null,
            sliding: !1,
            slideOffset: 0,
            swipeLeft: null,
            $list: null,
            touchObject: {},
            transformsEnabled: !1,
            unslicked: !1,
          }),
          e.extend(o, o.initials),
          (o.activeBreakpoint = null),
          (o.animType = null),
          (o.animProp = null),
          (o.breakpoints = []),
          (o.breakpointSettings = []),
          (o.cssTransitions = !1),
          (o.focussed = !1),
          (o.interrupted = !1),
          (o.hidden = "hidden"),
          (o.paused = !0),
          (o.positionProp = null),
          (o.respondTo = null),
          (o.rowCount = 1),
          (o.shouldClick = !0),
          (o.$slider = e(t)),
          (o.$slidesCache = null),
          (o.transformType = null),
          (o.transitionType = null),
          (o.visibilityChange = "visibilitychange"),
          (o.windowWidth = 0),
          (o.windowTimer = null),
          (r = e(t).data("slick") || {}),
          (o.options = e.extend({}, o.defaults, i, r)),
          (o.currentSlide = o.options.initialSlide),
          (o.originalSettings = o.options),
          "undefined" != typeof document.mozHidden
            ? ((o.hidden = "mozHidden"),
              (o.visibilityChange = "mozvisibilitychange"))
            : "undefined" != typeof document.webkitHidden &&
              ((o.hidden = "webkitHidden"),
              (o.visibilityChange = "webkitvisibilitychange")),
          (o.autoPlay = e.proxy(o.autoPlay, o)),
          (o.autoPlayClear = e.proxy(o.autoPlayClear, o)),
          (o.autoPlayIterator = e.proxy(o.autoPlayIterator, o)),
          (o.changeSlide = e.proxy(o.changeSlide, o)),
          (o.clickHandler = e.proxy(o.clickHandler, o)),
          (o.selectHandler = e.proxy(o.selectHandler, o)),
          (o.setPosition = e.proxy(o.setPosition, o)),
          (o.swipeHandler = e.proxy(o.swipeHandler, o)),
          (o.dragHandler = e.proxy(o.dragHandler, o)),
          (o.keyHandler = e.proxy(o.keyHandler, o)),
          (o.instanceUid = n++),
          (o.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/),
          o.registerBreakpoints(),
          o.init(!0);
      }
      var n = 0;
      return t;
    })()),
      (t.prototype.activateADA = function () {
        var e = this;
        e.$slideTrack
          .find(".slick-active")
          .attr({ "aria-hidden": "false" })
          .find("a, input, button, select")
          .attr({ tabindex: "0" });
      }),
      (t.prototype.addSlide = t.prototype.slickAdd =
        function (t, n, i) {
          var r = this;
          if ("boolean" == typeof n) (i = n), (n = null);
          else if (0 > n || n >= r.slideCount) return !1;
          r.unload(),
            "number" == typeof n
              ? 0 === n && 0 === r.$slides.length
                ? e(t).appendTo(r.$slideTrack)
                : i
                ? e(t).insertBefore(r.$slides.eq(n))
                : e(t).insertAfter(r.$slides.eq(n))
              : i === !0
              ? e(t).prependTo(r.$slideTrack)
              : e(t).appendTo(r.$slideTrack),
            (r.$slides = r.$slideTrack.children(this.options.slide)),
            r.$slideTrack.children(this.options.slide).detach(),
            r.$slideTrack.append(r.$slides),
            r.$slides.each(function (t, n) {
              e(n).attr("data-slick-index", t);
            }),
            (r.$slidesCache = r.$slides),
            r.reinit();
        }),
      (t.prototype.animateHeight = function () {
        var e = this;
        if (
          1 === e.options.slidesToShow &&
          e.options.adaptiveHeight === !0 &&
          e.options.vertical === !1
        ) {
          var t = e.$slides.eq(e.currentSlide).outerHeight(!0);
          e.$list.animate({ height: t }, e.options.speed);
        }
      }),
      (t.prototype.animateSlide = function (t, n) {
        var i = {},
          r = this;
        r.animateHeight(),
          r.options.rtl === !0 && r.options.vertical === !1 && (t = -t),
          r.transformsEnabled === !1
            ? r.options.vertical === !1
              ? r.$slideTrack.animate(
                  { left: t },
                  r.options.speed,
                  r.options.easing,
                  n
                )
              : r.$slideTrack.animate(
                  { top: t },
                  r.options.speed,
                  r.options.easing,
                  n
                )
            : r.cssTransitions === !1
            ? (r.options.rtl === !0 && (r.currentLeft = -r.currentLeft),
              e({ animStart: r.currentLeft }).animate(
                { animStart: t },
                {
                  duration: r.options.speed,
                  easing: r.options.easing,
                  step: function (e) {
                    (e = Math.ceil(e)),
                      r.options.vertical === !1
                        ? ((i[r.animType] = "translate(" + e + "px, 0px)"),
                          r.$slideTrack.css(i))
                        : ((i[r.animType] = "translate(0px," + e + "px)"),
                          r.$slideTrack.css(i));
                  },
                  complete: function () {
                    n && n.call();
                  },
                }
              ))
            : (r.applyTransition(),
              (t = Math.ceil(t)),
              r.options.vertical === !1
                ? (i[r.animType] = "translate3d(" + t + "px, 0px, 0px)")
                : (i[r.animType] = "translate3d(0px," + t + "px, 0px)"),
              r.$slideTrack.css(i),
              n &&
                setTimeout(function () {
                  r.disableTransition(), n.call();
                }, r.options.speed));
      }),
      (t.prototype.getNavTarget = function () {
        var t = this,
          n = t.options.asNavFor;
        return n && null !== n && (n = e(n).not(t.$slider)), n;
      }),
      (t.prototype.asNavFor = function (t) {
        var n = this,
          i = n.getNavTarget();
        null !== i &&
          "object" == typeof i &&
          i.each(function () {
            var n = e(this).slick("getSlick");
            n.unslicked || n.slideHandler(t, !0);
          });
      }),
      (t.prototype.applyTransition = function (e) {
        var t = this,
          n = {};
        t.options.fade === !1
          ? (n[t.transitionType] =
              t.transformType +
              " " +
              t.options.speed +
              "ms " +
              t.options.cssEase)
          : (n[t.transitionType] =
              "opacity " + t.options.speed + "ms " + t.options.cssEase),
          t.options.fade === !1 ? t.$slideTrack.css(n) : t.$slides.eq(e).css(n);
      }),
      (t.prototype.autoPlay = function () {
        var e = this;
        e.autoPlayClear(),
          e.slideCount > e.options.slidesToShow &&
            (e.autoPlayTimer = setInterval(
              e.autoPlayIterator,
              e.options.autoplaySpeed
            ));
      }),
      (t.prototype.autoPlayClear = function () {
        var e = this;
        e.autoPlayTimer && clearInterval(e.autoPlayTimer);
      }),
      (t.prototype.autoPlayIterator = function () {
        var e = this,
          t = e.currentSlide + e.options.slidesToScroll;
        e.paused ||
          e.interrupted ||
          e.focussed ||
          (e.options.infinite === !1 &&
            (1 === e.direction && e.currentSlide + 1 === e.slideCount - 1
              ? (e.direction = 0)
              : 0 === e.direction &&
                ((t = e.currentSlide - e.options.slidesToScroll),
                e.currentSlide - 1 === 0 && (e.direction = 1))),
          e.slideHandler(t));
      }),
      (t.prototype.buildArrows = function () {
        var t = this;
        t.options.arrows === !0 &&
          ((t.$prevArrow = e(t.options.prevArrow).addClass("slick-arrow")),
          (t.$nextArrow = e(t.options.nextArrow).addClass("slick-arrow")),
          t.slideCount > t.options.slidesToShow
            ? (t.$prevArrow
                .removeClass("slick-hidden")
                .removeAttr("aria-hidden tabindex"),
              t.$nextArrow
                .removeClass("slick-hidden")
                .removeAttr("aria-hidden tabindex"),
              t.htmlExpr.test(t.options.prevArrow) &&
                t.$prevArrow.prependTo(t.options.appendArrows),
              t.htmlExpr.test(t.options.nextArrow) &&
                t.$nextArrow.appendTo(t.options.appendArrows),
              t.options.infinite !== !0 &&
                t.$prevArrow
                  .addClass("slick-disabled")
                  .attr("aria-disabled", "true"))
            : t.$prevArrow
                .add(t.$nextArrow)
                .addClass("slick-hidden")
                .attr({ "aria-disabled": "true", tabindex: "-1" }));
      }),
      (t.prototype.buildDots = function () {
        var t,
          n,
          i = this;
        if (i.options.dots === !0 && i.slideCount > i.options.slidesToShow) {
          for (
            i.$slider.addClass("slick-dotted"),
              n = e("<ul />").addClass(i.options.dotsClass),
              t = 0;
            t <= i.getDotCount();
            t += 1
          )
            n.append(
              e("<li />").append(i.options.customPaging.call(this, i, t))
            );
          (i.$dots = n.appendTo(i.options.appendDots)),
            i.$dots
              .find("li")
              .first()
              .addClass("slick-active")
              .attr("aria-hidden", "false");
        }
      }),
      (t.prototype.buildOut = function () {
        var t = this;
        (t.$slides = t.$slider
          .children(t.options.slide + ":not(.slick-cloned)")
          .addClass("slick-slide")),
          (t.slideCount = t.$slides.length),
          t.$slides.each(function (t, n) {
            e(n)
              .attr("data-slick-index", t)
              .data("originalStyling", e(n).attr("style") || "");
          }),
          t.$slider.addClass("slick-slider"),
          (t.$slideTrack =
            0 === t.slideCount
              ? e('<div class="slick-track"/>').appendTo(t.$slider)
              : t.$slides.wrapAll('<div class="slick-track"/>').parent()),
          (t.$list = t.$slideTrack
            .wrap('<div aria-live="polite" class="slick-list"/>')
            .parent()),
          t.$slideTrack.css("opacity", 0),
          (t.options.centerMode === !0 || t.options.swipeToSlide === !0) &&
            (t.options.slidesToScroll = 1),
          e("img[data-lazy]", t.$slider).not("[src]").addClass("slick-loading"),
          t.setupInfinite(),
          t.buildArrows(),
          t.buildDots(),
          t.updateDots(),
          t.setSlideClasses(
            "number" == typeof t.currentSlide ? t.currentSlide : 0
          ),
          t.options.draggable === !0 && t.$list.addClass("draggable");
      }),
      (t.prototype.buildRows = function () {
        var e,
          t,
          n,
          i,
          r,
          o,
          s,
          a = this;
        if (
          ((i = document.createDocumentFragment()),
          (o = a.$slider.children()),
          a.options.rows > 1)
        ) {
          for (
            s = a.options.slidesPerRow * a.options.rows,
              r = Math.ceil(o.length / s),
              e = 0;
            r > e;
            e++
          ) {
            var l = document.createElement("div");
            for (t = 0; t < a.options.rows; t++) {
              var c = document.createElement("div");
              for (n = 0; n < a.options.slidesPerRow; n++) {
                var u = e * s + (t * a.options.slidesPerRow + n);
                o.get(u) && c.appendChild(o.get(u));
              }
              l.appendChild(c);
            }
            i.appendChild(l);
          }
          a.$slider.empty().append(i),
            a.$slider
              .children()
              .children()
              .children()
              .css({
                width: 100 / a.options.slidesPerRow + "%",
                display: "inline-block",
              });
        }
      }),
      (t.prototype.checkResponsive = function (t, n) {
        var i,
          r,
          o,
          s = this,
          a = !1,
          l = s.$slider.width(),
          c = window.innerWidth || e(window).width();
        if (
          ("window" === s.respondTo
            ? (o = c)
            : "slider" === s.respondTo
            ? (o = l)
            : "min" === s.respondTo && (o = Math.min(c, l)),
          s.options.responsive &&
            s.options.responsive.length &&
            null !== s.options.responsive)
        ) {
          r = null;
          for (i in s.breakpoints)
            s.breakpoints.hasOwnProperty(i) &&
              (s.originalSettings.mobileFirst === !1
                ? o < s.breakpoints[i] && (r = s.breakpoints[i])
                : o > s.breakpoints[i] && (r = s.breakpoints[i]));
          null !== r
            ? null !== s.activeBreakpoint
              ? (r !== s.activeBreakpoint || n) &&
                ((s.activeBreakpoint = r),
                "unslick" === s.breakpointSettings[r]
                  ? s.unslick(r)
                  : ((s.options = e.extend(
                      {},
                      s.originalSettings,
                      s.breakpointSettings[r]
                    )),
                    t === !0 && (s.currentSlide = s.options.initialSlide),
                    s.refresh(t)),
                (a = r))
              : ((s.activeBreakpoint = r),
                "unslick" === s.breakpointSettings[r]
                  ? s.unslick(r)
                  : ((s.options = e.extend(
                      {},
                      s.originalSettings,
                      s.breakpointSettings[r]
                    )),
                    t === !0 && (s.currentSlide = s.options.initialSlide),
                    s.refresh(t)),
                (a = r))
            : null !== s.activeBreakpoint &&
              ((s.activeBreakpoint = null),
              (s.options = s.originalSettings),
              t === !0 && (s.currentSlide = s.options.initialSlide),
              s.refresh(t),
              (a = r)),
            t || a === !1 || s.$slider.trigger("breakpoint", [s, a]);
        }
      }),
      (t.prototype.changeSlide = function (t, n) {
        var i,
          r,
          o,
          s = this,
          a = e(t.currentTarget);
        switch (
          (a.is("a") && t.preventDefault(),
          a.is("li") || (a = a.closest("li")),
          (o = s.slideCount % s.options.slidesToScroll !== 0),
          (i = o
            ? 0
            : (s.slideCount - s.currentSlide) % s.options.slidesToScroll),
          t.data.message)
        ) {
          case "previous":
            (r =
              0 === i ? s.options.slidesToScroll : s.options.slidesToShow - i),
              s.slideCount > s.options.slidesToShow &&
                s.slideHandler(s.currentSlide - r, !1, n);
            break;
          case "next":
            (r = 0 === i ? s.options.slidesToScroll : i),
              s.slideCount > s.options.slidesToShow &&
                s.slideHandler(s.currentSlide + r, !1, n);
            break;
          case "index":
            var l =
              0 === t.data.index
                ? 0
                : t.data.index || a.index() * s.options.slidesToScroll;
            s.slideHandler(s.checkNavigable(l), !1, n),
              a.children().trigger("focus");
            break;
          default:
            return;
        }
      }),
      (t.prototype.checkNavigable = function (e) {
        var t,
          n,
          i = this;
        if (((t = i.getNavigableIndexes()), (n = 0), e > t[t.length - 1]))
          e = t[t.length - 1];
        else
          for (var r in t) {
            if (e < t[r]) {
              e = n;
              break;
            }
            n = t[r];
          }
        return e;
      }),
      (t.prototype.cleanUpEvents = function () {
        var t = this;
        t.options.dots &&
          null !== t.$dots &&
          e("li", t.$dots)
            .off("click.slick", t.changeSlide)
            .off("mouseenter.slick", e.proxy(t.interrupt, t, !0))
            .off("mouseleave.slick", e.proxy(t.interrupt, t, !1)),
          t.$slider.off("focus.slick blur.slick"),
          t.options.arrows === !0 &&
            t.slideCount > t.options.slidesToShow &&
            (t.$prevArrow && t.$prevArrow.off("click.slick", t.changeSlide),
            t.$nextArrow && t.$nextArrow.off("click.slick", t.changeSlide)),
          t.$list.off("touchstart.slick mousedown.slick", t.swipeHandler),
          t.$list.off("touchmove.slick mousemove.slick", t.swipeHandler),
          t.$list.off("touchend.slick mouseup.slick", t.swipeHandler),
          t.$list.off("touchcancel.slick mouseleave.slick", t.swipeHandler),
          t.$list.off("click.slick", t.clickHandler),
          e(document).off(t.visibilityChange, t.visibility),
          t.cleanUpSlideEvents(),
          t.options.accessibility === !0 &&
            t.$list.off("keydown.slick", t.keyHandler),
          t.options.focusOnSelect === !0 &&
            e(t.$slideTrack).children().off("click.slick", t.selectHandler),
          e(window).off(
            "orientationchange.slick.slick-" + t.instanceUid,
            t.orientationChange
          ),
          e(window).off("resize.slick.slick-" + t.instanceUid, t.resize),
          e("[draggable!=true]", t.$slideTrack).off(
            "dragstart",
            t.preventDefault
          ),
          e(window).off("load.slick.slick-" + t.instanceUid, t.setPosition),
          e(document).off("ready.slick.slick-" + t.instanceUid, t.setPosition);
      }),
      (t.prototype.cleanUpSlideEvents = function () {
        var t = this;
        t.$list.off("mouseenter.slick", e.proxy(t.interrupt, t, !0)),
          t.$list.off("mouseleave.slick", e.proxy(t.interrupt, t, !1));
      }),
      (t.prototype.cleanUpRows = function () {
        var e,
          t = this;
        t.options.rows > 1 &&
          ((e = t.$slides.children().children()),
          e.removeAttr("style"),
          t.$slider.empty().append(e));
      }),
      (t.prototype.clickHandler = function (e) {
        var t = this;
        t.shouldClick === !1 &&
          (e.stopImmediatePropagation(),
          e.stopPropagation(),
          e.preventDefault());
      }),
      (t.prototype.destroy = function (t) {
        var n = this;
        n.autoPlayClear(),
          (n.touchObject = {}),
          n.cleanUpEvents(),
          e(".slick-cloned", n.$slider).detach(),
          n.$dots && n.$dots.remove(),
          n.$prevArrow &&
            n.$prevArrow.length &&
            (n.$prevArrow
              .removeClass("slick-disabled slick-arrow slick-hidden")
              .removeAttr("aria-hidden aria-disabled tabindex")
              .css("display", ""),
            n.htmlExpr.test(n.options.prevArrow) && n.$prevArrow.remove()),
          n.$nextArrow &&
            n.$nextArrow.length &&
            (n.$nextArrow
              .removeClass("slick-disabled slick-arrow slick-hidden")
              .removeAttr("aria-hidden aria-disabled tabindex")
              .css("display", ""),
            n.htmlExpr.test(n.options.nextArrow) && n.$nextArrow.remove()),
          n.$slides &&
            (n.$slides
              .removeClass(
                "slick-slide slick-active slick-center slick-visible slick-current"
              )
              .removeAttr("aria-hidden")
              .removeAttr("data-slick-index")
              .each(function () {
                e(this).attr("style", e(this).data("originalStyling"));
              }),
            n.$slideTrack.children(this.options.slide).detach(),
            n.$slideTrack.detach(),
            n.$list.detach(),
            n.$slider.append(n.$slides)),
          n.cleanUpRows(),
          n.$slider.removeClass("slick-slider"),
          n.$slider.removeClass("slick-initialized"),
          n.$slider.removeClass("slick-dotted"),
          (n.unslicked = !0),
          t || n.$slider.trigger("destroy", [n]);
      }),
      (t.prototype.disableTransition = function (e) {
        var t = this,
          n = {};
        (n[t.transitionType] = ""),
          t.options.fade === !1 ? t.$slideTrack.css(n) : t.$slides.eq(e).css(n);
      }),
      (t.prototype.fadeSlide = function (e, t) {
        var n = this;
        n.cssTransitions === !1
          ? (n.$slides.eq(e).css({ zIndex: n.options.zIndex }),
            n.$slides
              .eq(e)
              .animate({ opacity: 1 }, n.options.speed, n.options.easing, t))
          : (n.applyTransition(e),
            n.$slides.eq(e).css({ opacity: 1, zIndex: n.options.zIndex }),
            t &&
              setTimeout(function () {
                n.disableTransition(e), t.call();
              }, n.options.speed));
      }),
      (t.prototype.fadeSlideOut = function (e) {
        var t = this;
        t.cssTransitions === !1
          ? t.$slides
              .eq(e)
              .animate(
                { opacity: 0, zIndex: t.options.zIndex - 2 },
                t.options.speed,
                t.options.easing
              )
          : (t.applyTransition(e),
            t.$slides.eq(e).css({ opacity: 0, zIndex: t.options.zIndex - 2 }));
      }),
      (t.prototype.filterSlides = t.prototype.slickFilter =
        function (e) {
          var t = this;
          null !== e &&
            ((t.$slidesCache = t.$slides),
            t.unload(),
            t.$slideTrack.children(this.options.slide).detach(),
            t.$slidesCache.filter(e).appendTo(t.$slideTrack),
            t.reinit());
        }),
      (t.prototype.focusHandler = function () {
        var t = this;
        t.$slider
          .off("focus.slick blur.slick")
          .on("focus.slick blur.slick", "*:not(.slick-arrow)", function (n) {
            n.stopImmediatePropagation();
            var i = e(this);
            setTimeout(function () {
              t.options.pauseOnFocus &&
                ((t.focussed = i.is(":focus")), t.autoPlay());
            }, 0);
          });
      }),
      (t.prototype.getCurrent = t.prototype.slickCurrentSlide =
        function () {
          var e = this;
          return e.currentSlide;
        }),
      (t.prototype.getDotCount = function () {
        var e = this,
          t = 0,
          n = 0,
          i = 0;
        if (e.options.infinite === !0)
          for (; t < e.slideCount; )
            ++i,
              (t = n + e.options.slidesToScroll),
              (n +=
                e.options.slidesToScroll <= e.options.slidesToShow
                  ? e.options.slidesToScroll
                  : e.options.slidesToShow);
        else if (e.options.centerMode === !0) i = e.slideCount;
        else if (e.options.asNavFor)
          for (; t < e.slideCount; )
            ++i,
              (t = n + e.options.slidesToScroll),
              (n +=
                e.options.slidesToScroll <= e.options.slidesToShow
                  ? e.options.slidesToScroll
                  : e.options.slidesToShow);
        else
          i =
            1 +
            Math.ceil(
              (e.slideCount - e.options.slidesToShow) / e.options.slidesToScroll
            );
        return i - 1;
      }),
      (t.prototype.getLeft = function (e) {
        var t,
          n,
          i,
          r = this,
          o = 0;
        return (
          (r.slideOffset = 0),
          (n = r.$slides.first().outerHeight(!0)),
          r.options.infinite === !0
            ? (r.slideCount > r.options.slidesToShow &&
                ((r.slideOffset = r.slideWidth * r.options.slidesToShow * -1),
                (o = n * r.options.slidesToShow * -1)),
              r.slideCount % r.options.slidesToScroll !== 0 &&
                e + r.options.slidesToScroll > r.slideCount &&
                r.slideCount > r.options.slidesToShow &&
                (e > r.slideCount
                  ? ((r.slideOffset =
                      (r.options.slidesToShow - (e - r.slideCount)) *
                      r.slideWidth *
                      -1),
                    (o =
                      (r.options.slidesToShow - (e - r.slideCount)) * n * -1))
                  : ((r.slideOffset =
                      (r.slideCount % r.options.slidesToScroll) *
                      r.slideWidth *
                      -1),
                    (o = (r.slideCount % r.options.slidesToScroll) * n * -1))))
            : e + r.options.slidesToShow > r.slideCount &&
              ((r.slideOffset =
                (e + r.options.slidesToShow - r.slideCount) * r.slideWidth),
              (o = (e + r.options.slidesToShow - r.slideCount) * n)),
          r.slideCount <= r.options.slidesToShow &&
            ((r.slideOffset = 0), (o = 0)),
          r.options.centerMode === !0 && r.options.infinite === !0
            ? (r.slideOffset +=
                r.slideWidth * Math.floor(r.options.slidesToShow / 2) -
                r.slideWidth)
            : r.options.centerMode === !0 &&
              ((r.slideOffset = 0),
              (r.slideOffset +=
                r.slideWidth * Math.floor(r.options.slidesToShow / 2))),
          (t =
            r.options.vertical === !1
              ? e * r.slideWidth * -1 + r.slideOffset
              : e * n * -1 + o),
          r.options.variableWidth === !0 &&
            ((i =
              r.slideCount <= r.options.slidesToShow ||
              r.options.infinite === !1
                ? r.$slideTrack.children(".slick-slide").eq(e)
                : r.$slideTrack
                    .children(".slick-slide")
                    .eq(e + r.options.slidesToShow)),
            (t =
              r.options.rtl === !0
                ? i[0]
                  ? -1 * (r.$slideTrack.width() - i[0].offsetLeft - i.width())
                  : 0
                : i[0]
                ? -1 * i[0].offsetLeft
                : 0),
            r.options.centerMode === !0 &&
              ((i =
                r.slideCount <= r.options.slidesToShow ||
                r.options.infinite === !1
                  ? r.$slideTrack.children(".slick-slide").eq(e)
                  : r.$slideTrack
                      .children(".slick-slide")
                      .eq(e + r.options.slidesToShow + 1)),
              (t =
                r.options.rtl === !0
                  ? i[0]
                    ? -1 * (r.$slideTrack.width() - i[0].offsetLeft - i.width())
                    : 0
                  : i[0]
                  ? -1 * i[0].offsetLeft
                  : 0),
              (t += (r.$list.width() - i.outerWidth()) / 2))),
          t
        );
      }),
      (t.prototype.getOption = t.prototype.slickGetOption =
        function (e) {
          var t = this;
          return t.options[e];
        }),
      (t.prototype.getNavigableIndexes = function () {
        var e,
          t = this,
          n = 0,
          i = 0,
          r = [];
        for (
          t.options.infinite === !1
            ? (e = t.slideCount)
            : ((n = -1 * t.options.slidesToScroll),
              (i = -1 * t.options.slidesToScroll),
              (e = 2 * t.slideCount));
          e > n;

        )
          r.push(n),
            (n = i + t.options.slidesToScroll),
            (i +=
              t.options.slidesToScroll <= t.options.slidesToShow
                ? t.options.slidesToScroll
                : t.options.slidesToShow);
        return r;
      }),
      (t.prototype.getSlick = function () {
        return this;
      }),
      (t.prototype.getSlideCount = function () {
        var t,
          n,
          i,
          r = this;
        return (
          (i =
            r.options.centerMode === !0
              ? r.slideWidth * Math.floor(r.options.slidesToShow / 2)
              : 0),
          r.options.swipeToSlide === !0
            ? (r.$slideTrack.find(".slick-slide").each(function (t, o) {
                return o.offsetLeft - i + e(o).outerWidth() / 2 >
                  -1 * r.swipeLeft
                  ? ((n = o), !1)
                  : void 0;
              }),
              (t =
                Math.abs(e(n).attr("data-slick-index") - r.currentSlide) || 1))
            : r.options.slidesToScroll
        );
      }),
      (t.prototype.goTo = t.prototype.slickGoTo =
        function (e, t) {
          var n = this;
          n.changeSlide({ data: { message: "index", index: parseInt(e) } }, t);
        }),
      (t.prototype.init = function (t) {
        var n = this;
        e(n.$slider).hasClass("slick-initialized") ||
          (e(n.$slider).addClass("slick-initialized"),
          n.buildRows(),
          n.buildOut(),
          n.setProps(),
          n.startLoad(),
          n.loadSlider(),
          n.initializeEvents(),
          n.updateArrows(),
          n.updateDots(),
          n.checkResponsive(!0),
          n.focusHandler()),
          t && n.$slider.trigger("init", [n]),
          n.options.accessibility === !0 && n.initADA(),
          n.options.autoplay && ((n.paused = !1), n.autoPlay());
      }),
      (t.prototype.initADA = function () {
        var t = this;
        t.$slides
          .add(t.$slideTrack.find(".slick-cloned"))
          .attr({ "aria-hidden": "true", tabindex: "-1" })
          .find("a, input, button, select")
          .attr({ tabindex: "-1" }),
          t.$slideTrack.attr("role", "listbox"),
          t.$slides.not(t.$slideTrack.find(".slick-cloned")).each(function (n) {
            e(this).attr({
              role: "option",
              "aria-describedby": "slick-slide" + t.instanceUid + n,
            });
          }),
          null !== t.$dots &&
            t.$dots
              .attr("role", "tablist")
              .find("li")
              .each(function (n) {
                e(this).attr({
                  role: "presentation",
                  "aria-selected": "false",
                  "aria-controls": "navigation" + t.instanceUid + n,
                  id: "slick-slide" + t.instanceUid + n,
                });
              })
              .first()
              .attr("aria-selected", "true")
              .end()
              .find("button")
              .attr("role", "button")
              .end()
              .closest("div")
              .attr("role", "toolbar"),
          t.activateADA();
      }),
      (t.prototype.initArrowEvents = function () {
        var e = this;
        e.options.arrows === !0 &&
          e.slideCount > e.options.slidesToShow &&
          (e.$prevArrow
            .off("click.slick")
            .on("click.slick", { message: "previous" }, e.changeSlide),
          e.$nextArrow
            .off("click.slick")
            .on("click.slick", { message: "next" }, e.changeSlide));
      }),
      (t.prototype.initDotEvents = function () {
        var t = this;
        t.options.dots === !0 &&
          t.slideCount > t.options.slidesToShow &&
          e("li", t.$dots).on(
            "click.slick",
            { message: "index" },
            t.changeSlide
          ),
          t.options.dots === !0 &&
            t.options.pauseOnDotsHover === !0 &&
            e("li", t.$dots)
              .on("mouseenter.slick", e.proxy(t.interrupt, t, !0))
              .on("mouseleave.slick", e.proxy(t.interrupt, t, !1));
      }),
      (t.prototype.initSlideEvents = function () {
        var t = this;
        t.options.pauseOnHover &&
          (t.$list.on("mouseenter.slick", e.proxy(t.interrupt, t, !0)),
          t.$list.on("mouseleave.slick", e.proxy(t.interrupt, t, !1)));
      }),
      (t.prototype.initializeEvents = function () {
        var t = this;
        t.initArrowEvents(),
          t.initDotEvents(),
          t.initSlideEvents(),
          t.$list.on(
            "touchstart.slick mousedown.slick",
            { action: "start" },
            t.swipeHandler
          ),
          t.$list.on(
            "touchmove.slick mousemove.slick",
            { action: "move" },
            t.swipeHandler
          ),
          t.$list.on(
            "touchend.slick mouseup.slick",
            { action: "end" },
            t.swipeHandler
          ),
          t.$list.on(
            "touchcancel.slick mouseleave.slick",
            { action: "end" },
            t.swipeHandler
          ),
          t.$list.on("click.slick", t.clickHandler),
          e(document).on(t.visibilityChange, e.proxy(t.visibility, t)),
          t.options.accessibility === !0 &&
            t.$list.on("keydown.slick", t.keyHandler),
          t.options.focusOnSelect === !0 &&
            e(t.$slideTrack).children().on("click.slick", t.selectHandler),
          e(window).on(
            "orientationchange.slick.slick-" + t.instanceUid,
            e.proxy(t.orientationChange, t)
          ),
          e(window).on(
            "resize.slick.slick-" + t.instanceUid,
            e.proxy(t.resize, t)
          ),
          e("[draggable!=true]", t.$slideTrack).on(
            "dragstart",
            t.preventDefault
          ),
          e(window).on("load.slick.slick-" + t.instanceUid, t.setPosition),
          e(document).on("ready.slick.slick-" + t.instanceUid, t.setPosition);
      }),
      (t.prototype.initUI = function () {
        var e = this;
        e.options.arrows === !0 &&
          e.slideCount > e.options.slidesToShow &&
          (e.$prevArrow.show(), e.$nextArrow.show()),
          e.options.dots === !0 &&
            e.slideCount > e.options.slidesToShow &&
            e.$dots.show();
      }),
      (t.prototype.keyHandler = function (e) {
        var t = this;
        e.target.tagName.match("TEXTAREA|INPUT|SELECT") ||
          (37 === e.keyCode && t.options.accessibility === !0
            ? t.changeSlide({
                data: { message: t.options.rtl === !0 ? "next" : "previous" },
              })
            : 39 === e.keyCode &&
              t.options.accessibility === !0 &&
              t.changeSlide({
                data: { message: t.options.rtl === !0 ? "previous" : "next" },
              }));
      }),
      (t.prototype.lazyLoad = function () {
        function t(t) {
          e("img[data-lazy]", t).each(function () {
            var t = e(this),
              n = e(this).attr("data-lazy"),
              i = document.createElement("img");
            (i.onload = function () {
              t.animate({ opacity: 0 }, 100, function () {
                t.attr("src", n).animate({ opacity: 1 }, 200, function () {
                  t.removeAttr("data-lazy").removeClass("slick-loading");
                }),
                  s.$slider.trigger("lazyLoaded", [s, t, n]);
              });
            }),
              (i.onerror = function () {
                t
                  .removeAttr("data-lazy")
                  .removeClass("slick-loading")
                  .addClass("slick-lazyload-error"),
                  s.$slider.trigger("lazyLoadError", [s, t, n]);
              }),
              (i.src = n);
          });
        }
        var n,
          i,
          r,
          o,
          s = this;
        s.options.centerMode === !0
          ? s.options.infinite === !0
            ? ((r = s.currentSlide + (s.options.slidesToShow / 2 + 1)),
              (o = r + s.options.slidesToShow + 2))
            : ((r = Math.max(
                0,
                s.currentSlide - (s.options.slidesToShow / 2 + 1)
              )),
              (o = 2 + (s.options.slidesToShow / 2 + 1) + s.currentSlide))
          : ((r = s.options.infinite
              ? s.options.slidesToShow + s.currentSlide
              : s.currentSlide),
            (o = Math.ceil(r + s.options.slidesToShow)),
            s.options.fade === !0 && (r > 0 && r--, o <= s.slideCount && o++)),
          (n = s.$slider.find(".slick-slide").slice(r, o)),
          t(n),
          s.slideCount <= s.options.slidesToShow
            ? ((i = s.$slider.find(".slick-slide")), t(i))
            : s.currentSlide >= s.slideCount - s.options.slidesToShow
            ? ((i = s.$slider
                .find(".slick-cloned")
                .slice(0, s.options.slidesToShow)),
              t(i))
            : 0 === s.currentSlide &&
              ((i = s.$slider
                .find(".slick-cloned")
                .slice(-1 * s.options.slidesToShow)),
              t(i));
      }),
      (t.prototype.loadSlider = function () {
        var e = this;
        e.setPosition(),
          e.$slideTrack.css({ opacity: 1 }),
          e.$slider.removeClass("slick-loading"),
          e.initUI(),
          "progressive" === e.options.lazyLoad && e.progressiveLazyLoad();
      }),
      (t.prototype.next = t.prototype.slickNext =
        function () {
          var e = this;
          e.changeSlide({ data: { message: "next" } });
        }),
      (t.prototype.orientationChange = function () {
        var e = this;
        e.checkResponsive(), e.setPosition();
      }),
      (t.prototype.pause = t.prototype.slickPause =
        function () {
          var e = this;
          e.autoPlayClear(), (e.paused = !0);
        }),
      (t.prototype.play = t.prototype.slickPlay =
        function () {
          var e = this;
          e.autoPlay(),
            (e.options.autoplay = !0),
            (e.paused = !1),
            (e.focussed = !1),
            (e.interrupted = !1);
        }),
      (t.prototype.postSlide = function (e) {
        var t = this;
        t.unslicked ||
          (t.$slider.trigger("afterChange", [t, e]),
          (t.animating = !1),
          t.setPosition(),
          (t.swipeLeft = null),
          t.options.autoplay && t.autoPlay(),
          t.options.accessibility === !0 && t.initADA());
      }),
      (t.prototype.prev = t.prototype.slickPrev =
        function () {
          var e = this;
          e.changeSlide({ data: { message: "previous" } });
        }),
      (t.prototype.preventDefault = function (e) {
        e.preventDefault();
      }),
      (t.prototype.progressiveLazyLoad = function (t) {
        t = t || 1;
        var n,
          i,
          r,
          o = this,
          s = e("img[data-lazy]", o.$slider);
        s.length
          ? ((n = s.first()),
            (i = n.attr("data-lazy")),
            (r = document.createElement("img")),
            (r.onload = function () {
              n
                .attr("src", i)
                .removeAttr("data-lazy")
                .removeClass("slick-loading"),
                o.options.adaptiveHeight === !0 && o.setPosition(),
                o.$slider.trigger("lazyLoaded", [o, n, i]),
                o.progressiveLazyLoad();
            }),
            (r.onerror = function () {
              3 > t
                ? setTimeout(function () {
                    o.progressiveLazyLoad(t + 1);
                  }, 500)
                : (n
                    .removeAttr("data-lazy")
                    .removeClass("slick-loading")
                    .addClass("slick-lazyload-error"),
                  o.$slider.trigger("lazyLoadError", [o, n, i]),
                  o.progressiveLazyLoad());
            }),
            (r.src = i))
          : o.$slider.trigger("allImagesLoaded", [o]);
      }),
      (t.prototype.refresh = function (t) {
        var n,
          i,
          r = this;
        (i = r.slideCount - r.options.slidesToShow),
          !r.options.infinite && r.currentSlide > i && (r.currentSlide = i),
          r.slideCount <= r.options.slidesToShow && (r.currentSlide = 0),
          (n = r.currentSlide),
          r.destroy(!0),
          e.extend(r, r.initials, { currentSlide: n }),
          r.init(),
          t || r.changeSlide({ data: { message: "index", index: n } }, !1);
      }),
      (t.prototype.registerBreakpoints = function () {
        var t,
          n,
          i,
          r = this,
          o = r.options.responsive || null;
        if ("array" === e.type(o) && o.length) {
          r.respondTo = r.options.respondTo || "window";
          for (t in o)
            if (
              ((i = r.breakpoints.length - 1),
              (n = o[t].breakpoint),
              o.hasOwnProperty(t))
            ) {
              for (; i >= 0; )
                r.breakpoints[i] &&
                  r.breakpoints[i] === n &&
                  r.breakpoints.splice(i, 1),
                  i--;
              r.breakpoints.push(n), (r.breakpointSettings[n] = o[t].settings);
            }
          r.breakpoints.sort(function (e, t) {
            return r.options.mobileFirst ? e - t : t - e;
          });
        }
      }),
      (t.prototype.reinit = function () {
        var t = this;
        (t.$slides = t.$slideTrack
          .children(t.options.slide)
          .addClass("slick-slide")),
          (t.slideCount = t.$slides.length),
          t.currentSlide >= t.slideCount &&
            0 !== t.currentSlide &&
            (t.currentSlide = t.currentSlide - t.options.slidesToScroll),
          t.slideCount <= t.options.slidesToShow && (t.currentSlide = 0),
          t.registerBreakpoints(),
          t.setProps(),
          t.setupInfinite(),
          t.buildArrows(),
          t.updateArrows(),
          t.initArrowEvents(),
          t.buildDots(),
          t.updateDots(),
          t.initDotEvents(),
          t.cleanUpSlideEvents(),
          t.initSlideEvents(),
          t.checkResponsive(!1, !0),
          t.options.focusOnSelect === !0 &&
            e(t.$slideTrack).children().on("click.slick", t.selectHandler),
          t.setSlideClasses(
            "number" == typeof t.currentSlide ? t.currentSlide : 0
          ),
          t.setPosition(),
          t.focusHandler(),
          (t.paused = !t.options.autoplay),
          t.autoPlay(),
          t.$slider.trigger("reInit", [t]);
      }),
      (t.prototype.resize = function () {
        var t = this;
        e(window).width() !== t.windowWidth &&
          (clearTimeout(t.windowDelay),
          (t.windowDelay = window.setTimeout(function () {
            (t.windowWidth = e(window).width()),
              t.checkResponsive(),
              t.unslicked || t.setPosition();
          }, 50)));
      }),
      (t.prototype.removeSlide = t.prototype.slickRemove =
        function (e, t, n) {
          var i = this;
          return (
            "boolean" == typeof e
              ? ((t = e), (e = t === !0 ? 0 : i.slideCount - 1))
              : (e = t === !0 ? --e : e),
            !(i.slideCount < 1 || 0 > e || e > i.slideCount - 1) &&
              (i.unload(),
              n === !0
                ? i.$slideTrack.children().remove()
                : i.$slideTrack.children(this.options.slide).eq(e).remove(),
              (i.$slides = i.$slideTrack.children(this.options.slide)),
              i.$slideTrack.children(this.options.slide).detach(),
              i.$slideTrack.append(i.$slides),
              (i.$slidesCache = i.$slides),
              void i.reinit())
          );
        }),
      (t.prototype.setCSS = function (e) {
        var t,
          n,
          i = this,
          r = {};
        i.options.rtl === !0 && (e = -e),
          (t = "left" == i.positionProp ? Math.ceil(e) + "px" : "0px"),
          (n = "top" == i.positionProp ? Math.ceil(e) + "px" : "0px"),
          (r[i.positionProp] = e),
          i.transformsEnabled === !1
            ? i.$slideTrack.css(r)
            : ((r = {}),
              i.cssTransitions === !1
                ? ((r[i.animType] = "translate(" + t + ", " + n + ")"),
                  i.$slideTrack.css(r))
                : ((r[i.animType] = "translate3d(" + t + ", " + n + ", 0px)"),
                  i.$slideTrack.css(r)));
      }),
      (t.prototype.setDimensions = function () {
        var e = this;
        e.options.vertical === !1
          ? e.options.centerMode === !0 &&
            e.$list.css({ padding: "0px " + e.options.centerPadding })
          : (e.$list.height(
              e.$slides.first().outerHeight(!0) * e.options.slidesToShow
            ),
            e.options.centerMode === !0 &&
              e.$list.css({ padding: e.options.centerPadding + " 0px" })),
          (e.listWidth = e.$list.width()),
          (e.listHeight = e.$list.height()),
          e.options.vertical === !1 && e.options.variableWidth === !1
            ? ((e.slideWidth = Math.ceil(e.listWidth / e.options.slidesToShow)),
              e.$slideTrack.width(
                Math.ceil(
                  e.slideWidth * e.$slideTrack.children(".slick-slide").length
                )
              ))
            : e.options.variableWidth === !0
            ? e.$slideTrack.width(5e3 * e.slideCount)
            : ((e.slideWidth = Math.ceil(e.listWidth)),
              e.$slideTrack.height(
                Math.ceil(
                  e.$slides.first().outerHeight(!0) *
                    e.$slideTrack.children(".slick-slide").length
                )
              ));
        var t = e.$slides.first().outerWidth(!0) - e.$slides.first().width();
        e.options.variableWidth === !1 &&
          e.$slideTrack.children(".slick-slide").width(e.slideWidth - t);
      }),
      (t.prototype.setFade = function () {
        var t,
          n = this;
        n.$slides.each(function (i, r) {
          (t = n.slideWidth * i * -1),
            n.options.rtl === !0
              ? e(r).css({
                  position: "relative",
                  right: t,
                  top: 0,
                  zIndex: n.options.zIndex - 2,
                  opacity: 0,
                })
              : e(r).css({
                  position: "relative",
                  left: t,
                  top: 0,
                  zIndex: n.options.zIndex - 2,
                  opacity: 0,
                });
        }),
          n.$slides
            .eq(n.currentSlide)
            .css({ zIndex: n.options.zIndex - 1, opacity: 1 });
      }),
      (t.prototype.setHeight = function () {
        var e = this;
        if (
          1 === e.options.slidesToShow &&
          e.options.adaptiveHeight === !0 &&
          e.options.vertical === !1
        ) {
          var t = e.$slides.eq(e.currentSlide).outerHeight(!0);
          e.$list.css("height", t);
        }
      }),
      (t.prototype.setOption = t.prototype.slickSetOption =
        function () {
          var t,
            n,
            i,
            r,
            o,
            s = this,
            a = !1;
          if (
            ("object" === e.type(arguments[0])
              ? ((i = arguments[0]), (a = arguments[1]), (o = "multiple"))
              : "string" === e.type(arguments[0]) &&
                ((i = arguments[0]),
                (r = arguments[1]),
                (a = arguments[2]),
                "responsive" === arguments[0] &&
                "array" === e.type(arguments[1])
                  ? (o = "responsive")
                  : "undefined" != typeof arguments[1] && (o = "single")),
            "single" === o)
          )
            s.options[i] = r;
          else if ("multiple" === o)
            e.each(i, function (e, t) {
              s.options[e] = t;
            });
          else if ("responsive" === o)
            for (n in r)
              if ("array" !== e.type(s.options.responsive))
                s.options.responsive = [r[n]];
              else {
                for (t = s.options.responsive.length - 1; t >= 0; )
                  s.options.responsive[t].breakpoint === r[n].breakpoint &&
                    s.options.responsive.splice(t, 1),
                    t--;
                s.options.responsive.push(r[n]);
              }
          a && (s.unload(), s.reinit());
        }),
      (t.prototype.setPosition = function () {
        var e = this;
        e.setDimensions(),
          e.setHeight(),
          e.options.fade === !1
            ? e.setCSS(e.getLeft(e.currentSlide))
            : e.setFade(),
          e.$slider.trigger("setPosition", [e]);
      }),
      (t.prototype.setProps = function () {
        var e = this,
          t = document.body.style;
        (e.positionProp = e.options.vertical === !0 ? "top" : "left"),
          "top" === e.positionProp
            ? e.$slider.addClass("slick-vertical")
            : e.$slider.removeClass("slick-vertical"),
          (void 0 !== t.WebkitTransition ||
            void 0 !== t.MozTransition ||
            void 0 !== t.msTransition) &&
            e.options.useCSS === !0 &&
            (e.cssTransitions = !0),
          e.options.fade &&
            ("number" == typeof e.options.zIndex
              ? e.options.zIndex < 3 && (e.options.zIndex = 3)
              : (e.options.zIndex = e.defaults.zIndex)),
          void 0 !== t.OTransform &&
            ((e.animType = "OTransform"),
            (e.transformType = "-o-transform"),
            (e.transitionType = "OTransition"),
            void 0 === t.perspectiveProperty &&
              void 0 === t.webkitPerspective &&
              (e.animType = !1)),
          void 0 !== t.MozTransform &&
            ((e.animType = "MozTransform"),
            (e.transformType = "-moz-transform"),
            (e.transitionType = "MozTransition"),
            void 0 === t.perspectiveProperty &&
              void 0 === t.MozPerspective &&
              (e.animType = !1)),
          void 0 !== t.webkitTransform &&
            ((e.animType = "webkitTransform"),
            (e.transformType = "-webkit-transform"),
            (e.transitionType = "webkitTransition"),
            void 0 === t.perspectiveProperty &&
              void 0 === t.webkitPerspective &&
              (e.animType = !1)),
          void 0 !== t.msTransform &&
            ((e.animType = "msTransform"),
            (e.transformType = "-ms-transform"),
            (e.transitionType = "msTransition"),
            void 0 === t.msTransform && (e.animType = !1)),
          void 0 !== t.transform &&
            e.animType !== !1 &&
            ((e.animType = "transform"),
            (e.transformType = "transform"),
            (e.transitionType = "transition")),
          (e.transformsEnabled =
            e.options.useTransform && null !== e.animType && e.animType !== !1);
      }),
      (t.prototype.setSlideClasses = function (e) {
        var t,
          n,
          i,
          r,
          o = this;
        (n = o.$slider
          .find(".slick-slide")
          .removeClass("slick-active slick-center slick-current")
          .attr("aria-hidden", "true")),
          o.$slides.eq(e).addClass("slick-current"),
          o.options.centerMode === !0
            ? ((t = Math.floor(o.options.slidesToShow / 2)),
              o.options.infinite === !0 &&
                (e >= t && e <= o.slideCount - 1 - t
                  ? o.$slides
                      .slice(e - t, e + t + 1)
                      .addClass("slick-active")
                      .attr("aria-hidden", "false")
                  : ((i = o.options.slidesToShow + e),
                    n
                      .slice(i - t + 1, i + t + 2)
                      .addClass("slick-active")
                      .attr("aria-hidden", "false")),
                0 === e
                  ? n
                      .eq(n.length - 1 - o.options.slidesToShow)
                      .addClass("slick-center")
                  : e === o.slideCount - 1 &&
                    n.eq(o.options.slidesToShow).addClass("slick-center")),
              o.$slides.eq(e).addClass("slick-center"))
            : e >= 0 && e <= o.slideCount - o.options.slidesToShow
            ? o.$slides
                .slice(e, e + o.options.slidesToShow)
                .addClass("slick-active")
                .attr("aria-hidden", "false")
            : n.length <= o.options.slidesToShow
            ? n.addClass("slick-active").attr("aria-hidden", "false")
            : ((r = o.slideCount % o.options.slidesToShow),
              (i = o.options.infinite === !0 ? o.options.slidesToShow + e : e),
              o.options.slidesToShow == o.options.slidesToScroll &&
              o.slideCount - e < o.options.slidesToShow
                ? n
                    .slice(i - (o.options.slidesToShow - r), i + r)
                    .addClass("slick-active")
                    .attr("aria-hidden", "false")
                : n
                    .slice(i, i + o.options.slidesToShow)
                    .addClass("slick-active")
                    .attr("aria-hidden", "false")),
          "ondemand" === o.options.lazyLoad && o.lazyLoad();
      }),
      (t.prototype.setupInfinite = function () {
        var t,
          n,
          i,
          r = this;
        if (
          (r.options.fade === !0 && (r.options.centerMode = !1),
          r.options.infinite === !0 &&
            r.options.fade === !1 &&
            ((n = null), r.slideCount > r.options.slidesToShow))
        ) {
          for (
            i =
              r.options.centerMode === !0
                ? r.options.slidesToShow + 1
                : r.options.slidesToShow,
              t = r.slideCount;
            t > r.slideCount - i;
            t -= 1
          )
            (n = t - 1),
              e(r.$slides[n])
                .clone(!0)
                .attr("id", "")
                .attr("data-slick-index", n - r.slideCount)
                .prependTo(r.$slideTrack)
                .addClass("slick-cloned");
          for (t = 0; i > t; t += 1)
            (n = t),
              e(r.$slides[n])
                .clone(!0)
                .attr("id", "")
                .attr("data-slick-index", n + r.slideCount)
                .appendTo(r.$slideTrack)
                .addClass("slick-cloned");
          r.$slideTrack
            .find(".slick-cloned")
            .find("[id]")
            .each(function () {
              e(this).attr("id", "");
            });
        }
      }),
      (t.prototype.interrupt = function (e) {
        var t = this;
        e || t.autoPlay(), (t.interrupted = e);
      }),
      (t.prototype.selectHandler = function (t) {
        var n = this,
          i = e(t.target).is(".slick-slide")
            ? e(t.target)
            : e(t.target).parents(".slick-slide"),
          r = parseInt(i.attr("data-slick-index"));
        return (
          r || (r = 0),
          n.slideCount <= n.options.slidesToShow
            ? (n.setSlideClasses(r), void n.asNavFor(r))
            : void n.slideHandler(r)
        );
      }),
      (t.prototype.slideHandler = function (e, t, n) {
        var i,
          r,
          o,
          s,
          a,
          l = null,
          c = this;
        return (
          (t = t || !1),
          (c.animating === !0 && c.options.waitForAnimate === !0) ||
          (c.options.fade === !0 && c.currentSlide === e) ||
          c.slideCount <= c.options.slidesToShow
            ? void 0
            : (t === !1 && c.asNavFor(e),
              (i = e),
              (l = c.getLeft(i)),
              (s = c.getLeft(c.currentSlide)),
              (c.currentLeft = null === c.swipeLeft ? s : c.swipeLeft),
              c.options.infinite === !1 &&
              c.options.centerMode === !1 &&
              (0 > e || e > c.getDotCount() * c.options.slidesToScroll)
                ? void (
                    c.options.fade === !1 &&
                    ((i = c.currentSlide),
                    n !== !0
                      ? c.animateSlide(s, function () {
                          c.postSlide(i);
                        })
                      : c.postSlide(i))
                  )
                : c.options.infinite === !1 &&
                  c.options.centerMode === !0 &&
                  (0 > e || e > c.slideCount - c.options.slidesToScroll)
                ? void (
                    c.options.fade === !1 &&
                    ((i = c.currentSlide),
                    n !== !0
                      ? c.animateSlide(s, function () {
                          c.postSlide(i);
                        })
                      : c.postSlide(i))
                  )
                : (c.options.autoplay && clearInterval(c.autoPlayTimer),
                  (r =
                    0 > i
                      ? c.slideCount % c.options.slidesToScroll !== 0
                        ? c.slideCount -
                          (c.slideCount % c.options.slidesToScroll)
                        : c.slideCount + i
                      : i >= c.slideCount
                      ? c.slideCount % c.options.slidesToScroll !== 0
                        ? 0
                        : i - c.slideCount
                      : i),
                  (c.animating = !0),
                  c.$slider.trigger("beforeChange", [c, c.currentSlide, r]),
                  (o = c.currentSlide),
                  (c.currentSlide = r),
                  c.setSlideClasses(c.currentSlide),
                  c.options.asNavFor &&
                    ((a = c.getNavTarget()),
                    (a = a.slick("getSlick")),
                    a.slideCount <= a.options.slidesToShow &&
                      a.setSlideClasses(c.currentSlide)),
                  c.updateDots(),
                  c.updateArrows(),
                  c.options.fade === !0
                    ? (n !== !0
                        ? (c.fadeSlideOut(o),
                          c.fadeSlide(r, function () {
                            c.postSlide(r);
                          }))
                        : c.postSlide(r),
                      void c.animateHeight())
                    : void (n !== !0
                        ? c.animateSlide(l, function () {
                            c.postSlide(r);
                          })
                        : c.postSlide(r))))
        );
      }),
      (t.prototype.startLoad = function () {
        var e = this;
        e.options.arrows === !0 &&
          e.slideCount > e.options.slidesToShow &&
          (e.$prevArrow.hide(), e.$nextArrow.hide()),
          e.options.dots === !0 &&
            e.slideCount > e.options.slidesToShow &&
            e.$dots.hide(),
          e.$slider.addClass("slick-loading");
      }),
      (t.prototype.swipeDirection = function () {
        var e,
          t,
          n,
          i,
          r = this;
        return (
          (e = r.touchObject.startX - r.touchObject.curX),
          (t = r.touchObject.startY - r.touchObject.curY),
          (n = Math.atan2(t, e)),
          (i = Math.round((180 * n) / Math.PI)),
          0 > i && (i = 360 - Math.abs(i)),
          45 >= i && i >= 0
            ? r.options.rtl === !1
              ? "left"
              : "right"
            : 360 >= i && i >= 315
            ? r.options.rtl === !1
              ? "left"
              : "right"
            : i >= 135 && 225 >= i
            ? r.options.rtl === !1
              ? "right"
              : "left"
            : r.options.verticalSwiping === !0
            ? i >= 35 && 135 >= i
              ? "down"
              : "up"
            : "vertical"
        );
      }),
      (t.prototype.swipeEnd = function (e) {
        var t,
          n,
          i = this;
        if (
          ((i.dragging = !1),
          (i.interrupted = !1),
          (i.shouldClick = !(i.touchObject.swipeLength > 10)),
          void 0 === i.touchObject.curX)
        )
          return !1;
        if (
          (i.touchObject.edgeHit === !0 &&
            i.$slider.trigger("edge", [i, i.swipeDirection()]),
          i.touchObject.swipeLength >= i.touchObject.minSwipe)
        ) {
          switch ((n = i.swipeDirection())) {
            case "left":
            case "down":
              (t = i.options.swipeToSlide
                ? i.checkNavigable(i.currentSlide + i.getSlideCount())
                : i.currentSlide + i.getSlideCount()),
                (i.currentDirection = 0);
              break;
            case "right":
            case "up":
              (t = i.options.swipeToSlide
                ? i.checkNavigable(i.currentSlide - i.getSlideCount())
                : i.currentSlide - i.getSlideCount()),
                (i.currentDirection = 1);
          }
          "vertical" != n &&
            (i.slideHandler(t),
            (i.touchObject = {}),
            i.$slider.trigger("swipe", [i, n]));
        } else
          i.touchObject.startX !== i.touchObject.curX &&
            (i.slideHandler(i.currentSlide), (i.touchObject = {}));
      }),
      (t.prototype.swipeHandler = function (e) {
        var t = this;
        if (
          !(
            t.options.swipe === !1 ||
            ("ontouchend" in document && t.options.swipe === !1) ||
            (t.options.draggable === !1 && -1 !== e.type.indexOf("mouse"))
          )
        )
          switch (
            ((t.touchObject.fingerCount =
              e.originalEvent && void 0 !== e.originalEvent.touches
                ? e.originalEvent.touches.length
                : 1),
            (t.touchObject.minSwipe = t.listWidth / t.options.touchThreshold),
            t.options.verticalSwiping === !0 &&
              (t.touchObject.minSwipe =
                t.listHeight / t.options.touchThreshold),
            e.data.action)
          ) {
            case "start":
              t.swipeStart(e);
              break;
            case "move":
              t.swipeMove(e);
              break;
            case "end":
              t.swipeEnd(e);
          }
      }),
      (t.prototype.swipeMove = function (e) {
        var t,
          n,
          i,
          r,
          o,
          s = this;
        return (
          (o = void 0 !== e.originalEvent ? e.originalEvent.touches : null),
          !(!s.dragging || (o && 1 !== o.length)) &&
            ((t = s.getLeft(s.currentSlide)),
            (s.touchObject.curX = void 0 !== o ? o[0].pageX : e.clientX),
            (s.touchObject.curY = void 0 !== o ? o[0].pageY : e.clientY),
            (s.touchObject.swipeLength = Math.round(
              Math.sqrt(Math.pow(s.touchObject.curX - s.touchObject.startX, 2))
            )),
            s.options.verticalSwiping === !0 &&
              (s.touchObject.swipeLength = Math.round(
                Math.sqrt(
                  Math.pow(s.touchObject.curY - s.touchObject.startY, 2)
                )
              )),
            (n = s.swipeDirection()),
            "vertical" !== n
              ? (void 0 !== e.originalEvent &&
                  s.touchObject.swipeLength > 4 &&
                  e.preventDefault(),
                (r =
                  (s.options.rtl === !1 ? 1 : -1) *
                  (s.touchObject.curX > s.touchObject.startX ? 1 : -1)),
                s.options.verticalSwiping === !0 &&
                  (r = s.touchObject.curY > s.touchObject.startY ? 1 : -1),
                (i = s.touchObject.swipeLength),
                (s.touchObject.edgeHit = !1),
                s.options.infinite === !1 &&
                  ((0 === s.currentSlide && "right" === n) ||
                    (s.currentSlide >= s.getDotCount() && "left" === n)) &&
                  ((i = s.touchObject.swipeLength * s.options.edgeFriction),
                  (s.touchObject.edgeHit = !0)),
                s.options.vertical === !1
                  ? (s.swipeLeft = t + i * r)
                  : (s.swipeLeft =
                      t + i * (s.$list.height() / s.listWidth) * r),
                s.options.verticalSwiping === !0 && (s.swipeLeft = t + i * r),
                s.options.fade !== !0 &&
                  s.options.touchMove !== !1 &&
                  (s.animating === !0
                    ? ((s.swipeLeft = null), !1)
                    : void s.setCSS(s.swipeLeft)))
              : void 0)
        );
      }),
      (t.prototype.swipeStart = function (e) {
        var t,
          n = this;
        return (
          (n.interrupted = !0),
          1 !== n.touchObject.fingerCount ||
          n.slideCount <= n.options.slidesToShow
            ? ((n.touchObject = {}), !1)
            : (void 0 !== e.originalEvent &&
                void 0 !== e.originalEvent.touches &&
                (t = e.originalEvent.touches[0]),
              (n.touchObject.startX = n.touchObject.curX =
                void 0 !== t ? t.pageX : e.clientX),
              (n.touchObject.startY = n.touchObject.curY =
                void 0 !== t ? t.pageY : e.clientY),
              void (n.dragging = !0))
        );
      }),
      (t.prototype.unfilterSlides = t.prototype.slickUnfilter =
        function () {
          var e = this;
          null !== e.$slidesCache &&
            (e.unload(),
            e.$slideTrack.children(this.options.slide).detach(),
            e.$slidesCache.appendTo(e.$slideTrack),
            e.reinit());
        }),
      (t.prototype.unload = function () {
        var t = this;
        e(".slick-cloned", t.$slider).remove(),
          t.$dots && t.$dots.remove(),
          t.$prevArrow &&
            t.htmlExpr.test(t.options.prevArrow) &&
            t.$prevArrow.remove(),
          t.$nextArrow &&
            t.htmlExpr.test(t.options.nextArrow) &&
            t.$nextArrow.remove(),
          t.$slides
            .removeClass("slick-slide slick-active slick-visible slick-current")
            .attr("aria-hidden", "true")
            .css("width", "");
      }),
      (t.prototype.unslick = function (e) {
        var t = this;
        t.$slider.trigger("unslick", [t, e]), t.destroy();
      }),
      (t.prototype.updateArrows = function () {
        var e,
          t = this;
        (e = Math.floor(t.options.slidesToShow / 2)),
          t.options.arrows === !0 &&
            t.slideCount > t.options.slidesToShow &&
            !t.options.infinite &&
            (t.$prevArrow
              .removeClass("slick-disabled")
              .attr("aria-disabled", "false"),
            t.$nextArrow
              .removeClass("slick-disabled")
              .attr("aria-disabled", "false"),
            0 === t.currentSlide
              ? (t.$prevArrow
                  .addClass("slick-disabled")
                  .attr("aria-disabled", "true"),
                t.$nextArrow
                  .removeClass("slick-disabled")
                  .attr("aria-disabled", "false"))
              : t.currentSlide >= t.slideCount - t.options.slidesToShow &&
                t.options.centerMode === !1
              ? (t.$nextArrow
                  .addClass("slick-disabled")
                  .attr("aria-disabled", "true"),
                t.$prevArrow
                  .removeClass("slick-disabled")
                  .attr("aria-disabled", "false"))
              : t.currentSlide >= t.slideCount - 1 &&
                t.options.centerMode === !0 &&
                (t.$nextArrow
                  .addClass("slick-disabled")
                  .attr("aria-disabled", "true"),
                t.$prevArrow
                  .removeClass("slick-disabled")
                  .attr("aria-disabled", "false")));
      }),
      (t.prototype.updateDots = function () {
        var e = this;
        null !== e.$dots &&
          (e.$dots
            .find("li")
            .removeClass("slick-active")
            .attr("aria-hidden", "true"),
          e.$dots
            .find("li")
            .eq(Math.floor(e.currentSlide / e.options.slidesToScroll))
            .addClass("slick-active")
            .attr("aria-hidden", "false"));
      }),
      (t.prototype.visibility = function () {
        var e = this;
        e.options.autoplay &&
          (document[e.hidden] ? (e.interrupted = !0) : (e.interrupted = !1));
      }),
      (e.fn.slick = function () {
        var e,
          n,
          i = this,
          r = arguments[0],
          o = Array.prototype.slice.call(arguments, 1),
          s = i.length;
        for (e = 0; s > e; e++)
          if (
            ("object" == typeof r || "undefined" == typeof r
              ? (i[e].slick = new t(i[e], r))
              : (n = i[e].slick[r].apply(i[e].slick, o)),
            "undefined" != typeof n)
          )
            return n;
        return i;
      });
  })
  /*!
   * handlebars.min.js
   */,
  /*!

 handlebars v4.0.3

Copyright (C) 2011-2015 by Yehuda Katz

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

@license
*/
  !(function (e, t) {
    "object" == typeof exports && "object" == typeof module
      ? (module.exports = t())
      : "function" == typeof define && define.amd
      ? define(t)
      : "object" == typeof exports
      ? (exports.Handlebars = t())
      : (e.Handlebars = t());
  })(this, function () {
    return (function (e) {
      function t(i) {
        if (n[i]) return n[i].exports;
        var r = (n[i] = { exports: {}, id: i, loaded: !1 });
        return (
          e[i].call(r.exports, r, r.exports, t), (r.loaded = !0), r.exports
        );
      }
      var n = {};
      return (t.m = e), (t.c = n), (t.p = ""), t(0);
    })([
      function (e, t, n) {
        "use strict";
        function i() {
          var e = m();
          return (
            (e.compile = function (t, n) {
              return u.compile(t, n, e);
            }),
            (e.precompile = function (t, n) {
              return u.precompile(t, n, e);
            }),
            (e.AST = l.default),
            (e.Compiler = u.Compiler),
            (e.JavaScriptCompiler = d.default),
            (e.Parser = c.parser),
            (e.parse = c.parse),
            e
          );
        }
        var r = n(8).default;
        t.__esModule = !0;
        var o = n(1),
          s = r(o),
          a = n(2),
          l = r(a),
          c = n(3),
          u = n(4),
          p = n(5),
          d = r(p),
          h = n(6),
          f = r(h),
          v = n(7),
          g = r(v),
          m = s.default.create,
          y = i();
        (y.create = i),
          g.default(y),
          (y.Visitor = f.default),
          (y.default = y),
          (t.default = y),
          (e.exports = t.default);
      },
      function (e, t, n) {
        "use strict";
        function i() {
          var e = new a.HandlebarsEnvironment();
          return (
            h.extend(e, a),
            (e.SafeString = c.default),
            (e.Exception = p.default),
            (e.Utils = h),
            (e.escapeExpression = h.escapeExpression),
            (e.VM = v),
            (e.template = function (t) {
              return v.template(t, e);
            }),
            e
          );
        }
        var r = n(9).default,
          o = n(8).default;
        t.__esModule = !0;
        var s = n(10),
          a = r(s),
          l = n(11),
          c = o(l),
          u = n(12),
          p = o(u),
          d = n(13),
          h = r(d),
          f = n(14),
          v = r(f),
          g = n(7),
          m = o(g),
          y = i();
        (y.create = i),
          m.default(y),
          (y.default = y),
          (t.default = y),
          (e.exports = t.default);
      },
      function (e, t, n) {
        "use strict";
        t.__esModule = !0;
        var i = {
          helpers: {
            helperExpression: function (e) {
              return (
                "SubExpression" === e.type ||
                (("MustacheStatement" === e.type ||
                  "BlockStatement" === e.type) &&
                  !!((e.params && e.params.length) || e.hash))
              );
            },
            scopedId: function (e) {
              return /^\.|this\b/.test(e.original);
            },
            simpleId: function (e) {
              return 1 === e.parts.length && !i.helpers.scopedId(e) && !e.depth;
            },
          },
        };
        (t.default = i), (e.exports = t.default);
      },
      function (e, t, n) {
        "use strict";
        function i(e, t) {
          if ("Program" === e.type) return e;
          (a.default.yy = h),
            (h.locInfo = function (e) {
              return new h.SourceLocation(t && t.srcName, e);
            });
          var n = new c.default(t);
          return n.accept(a.default.parse(e));
        }
        var r = n(8).default,
          o = n(9).default;
        (t.__esModule = !0), (t.parse = i);
        var s = n(15),
          a = r(s),
          l = n(16),
          c = r(l),
          u = n(17),
          p = o(u),
          d = n(13);
        t.parser = a.default;
        var h = {};
        d.extend(h, p);
      },
      function (e, t, n) {
        "use strict";
        function i() {}
        function r(e, t, n) {
          if (null == e || ("string" != typeof e && "Program" !== e.type))
            throw new u.default(
              "You must pass a string or Handlebars AST to Handlebars.precompile. You passed " +
                e
            );
          (t = t || {}),
            "data" in t || (t.data = !0),
            t.compat && (t.useDepths = !0);
          var i = n.parse(e, t),
            r = new n.Compiler().compile(i, t);
          return new n.JavaScriptCompiler().compile(r, t);
        }
        function o(e, t, n) {
          function i() {
            var i = n.parse(e, t),
              r = new n.Compiler().compile(i, t),
              o = new n.JavaScriptCompiler().compile(r, t, void 0, !0);
            return n.template(o);
          }
          function r(e, t) {
            return o || (o = i()), o.call(this, e, t);
          }
          if (
            (void 0 === t && (t = {}),
            null == e || ("string" != typeof e && "Program" !== e.type))
          )
            throw new u.default(
              "You must pass a string or Handlebars AST to Handlebars.compile. You passed " +
                e
            );
          "data" in t || (t.data = !0), t.compat && (t.useDepths = !0);
          var o = void 0;
          return (
            (r._setup = function (e) {
              return o || (o = i()), o._setup(e);
            }),
            (r._child = function (e, t, n, r) {
              return o || (o = i()), o._child(e, t, n, r);
            }),
            r
          );
        }
        function s(e, t) {
          if (e === t) return !0;
          if (p.isArray(e) && p.isArray(t) && e.length === t.length) {
            for (var n = 0; n < e.length; n++) if (!s(e[n], t[n])) return !1;
            return !0;
          }
        }
        function a(e) {
          if (!e.path.parts) {
            var t = e.path;
            e.path = {
              type: "PathExpression",
              data: !1,
              depth: 0,
              parts: [t.original + ""],
              original: t.original + "",
              loc: t.loc,
            };
          }
        }
        var l = n(8).default;
        (t.__esModule = !0),
          (t.Compiler = i),
          (t.precompile = r),
          (t.compile = o);
        var c = n(12),
          u = l(c),
          p = n(13),
          d = n(2),
          h = l(d),
          f = [].slice;
        i.prototype = {
          compiler: i,
          equals: function (e) {
            var t = this.opcodes.length;
            if (e.opcodes.length !== t) return !1;
            for (var n = 0; t > n; n++) {
              var i = this.opcodes[n],
                r = e.opcodes[n];
              if (i.opcode !== r.opcode || !s(i.args, r.args)) return !1;
            }
            t = this.children.length;
            for (var n = 0; t > n; n++)
              if (!this.children[n].equals(e.children[n])) return !1;
            return !0;
          },
          guid: 0,
          compile: function (e, t) {
            (this.sourceNode = []),
              (this.opcodes = []),
              (this.children = []),
              (this.options = t),
              (this.stringParams = t.stringParams),
              (this.trackIds = t.trackIds),
              (t.blockParams = t.blockParams || []);
            var n = t.knownHelpers;
            if (
              ((t.knownHelpers = {
                helperMissing: !0,
                blockHelperMissing: !0,
                each: !0,
                if: !0,
                unless: !0,
                with: !0,
                log: !0,
                lookup: !0,
              }),
              n)
            )
              for (var i in n) i in n && (t.knownHelpers[i] = n[i]);
            return this.accept(e);
          },
          compileProgram: function (e) {
            var t = new this.compiler(),
              n = t.compile(e, this.options),
              i = this.guid++;
            return (
              (this.usePartial = this.usePartial || n.usePartial),
              (this.children[i] = n),
              (this.useDepths = this.useDepths || n.useDepths),
              i
            );
          },
          accept: function (e) {
            if (!this[e.type])
              throw new u.default("Unknown type: " + e.type, e);
            this.sourceNode.unshift(e);
            var t = this[e.type](e);
            return this.sourceNode.shift(), t;
          },
          Program: function (e) {
            this.options.blockParams.unshift(e.blockParams);
            for (var t = e.body, n = t.length, i = 0; n > i; i++)
              this.accept(t[i]);
            return (
              this.options.blockParams.shift(),
              (this.isSimple = 1 === n),
              (this.blockParams = e.blockParams ? e.blockParams.length : 0),
              this
            );
          },
          BlockStatement: function (e) {
            a(e);
            var t = e.program,
              n = e.inverse;
            (t = t && this.compileProgram(t)),
              (n = n && this.compileProgram(n));
            var i = this.classifySexpr(e);
            "helper" === i
              ? this.helperSexpr(e, t, n)
              : "simple" === i
              ? (this.simpleSexpr(e),
                this.opcode("pushProgram", t),
                this.opcode("pushProgram", n),
                this.opcode("emptyHash"),
                this.opcode("blockValue", e.path.original))
              : (this.ambiguousSexpr(e, t, n),
                this.opcode("pushProgram", t),
                this.opcode("pushProgram", n),
                this.opcode("emptyHash"),
                this.opcode("ambiguousBlockValue")),
              this.opcode("append");
          },
          DecoratorBlock: function (e) {
            var t = e.program && this.compileProgram(e.program),
              n = this.setupFullMustacheParams(e, t, void 0),
              i = e.path;
            (this.useDecorators = !0),
              this.opcode("registerDecorator", n.length, i.original);
          },
          PartialStatement: function (e) {
            this.usePartial = !0;
            var t = e.program;
            t && (t = this.compileProgram(e.program));
            var n = e.params;
            if (n.length > 1)
              throw new u.default(
                "Unsupported number of partial arguments: " + n.length,
                e
              );
            n.length ||
              (this.options.explicitPartialContext
                ? this.opcode("pushLiteral", "undefined")
                : n.push({ type: "PathExpression", parts: [], depth: 0 }));
            var i = e.name.original,
              r = "SubExpression" === e.name.type;
            r && this.accept(e.name),
              this.setupFullMustacheParams(e, t, void 0, !0);
            var o = e.indent || "";
            this.options.preventIndent &&
              o &&
              (this.opcode("appendContent", o), (o = "")),
              this.opcode("invokePartial", r, i, o),
              this.opcode("append");
          },
          PartialBlockStatement: function (e) {
            this.PartialStatement(e);
          },
          MustacheStatement: function (e) {
            this.SubExpression(e),
              e.escaped && !this.options.noEscape
                ? this.opcode("appendEscaped")
                : this.opcode("append");
          },
          Decorator: function (e) {
            this.DecoratorBlock(e);
          },
          ContentStatement: function (e) {
            e.value && this.opcode("appendContent", e.value);
          },
          CommentStatement: function () {},
          SubExpression: function (e) {
            a(e);
            var t = this.classifySexpr(e);
            "simple" === t
              ? this.simpleSexpr(e)
              : "helper" === t
              ? this.helperSexpr(e)
              : this.ambiguousSexpr(e);
          },
          ambiguousSexpr: function (e, t, n) {
            var i = e.path,
              r = i.parts[0],
              o = null != t || null != n;
            this.opcode("getContext", i.depth),
              this.opcode("pushProgram", t),
              this.opcode("pushProgram", n),
              (i.strict = !0),
              this.accept(i),
              this.opcode("invokeAmbiguous", r, o);
          },
          simpleSexpr: function (e) {
            var t = e.path;
            (t.strict = !0),
              this.accept(t),
              this.opcode("resolvePossibleLambda");
          },
          helperSexpr: function (e, t, n) {
            var i = this.setupFullMustacheParams(e, t, n),
              r = e.path,
              o = r.parts[0];
            if (this.options.knownHelpers[o])
              this.opcode("invokeKnownHelper", i.length, o);
            else {
              if (this.options.knownHelpersOnly)
                throw new u.default(
                  "You specified knownHelpersOnly, but used the unknown helper " +
                    o,
                  e
                );
              (r.strict = !0),
                (r.falsy = !0),
                this.accept(r),
                this.opcode(
                  "invokeHelper",
                  i.length,
                  r.original,
                  h.default.helpers.simpleId(r)
                );
            }
          },
          PathExpression: function (e) {
            this.addDepth(e.depth), this.opcode("getContext", e.depth);
            var t = e.parts[0],
              n = h.default.helpers.scopedId(e),
              i = !e.depth && !n && this.blockParamIndex(t);
            i
              ? this.opcode("lookupBlockParam", i, e.parts)
              : t
              ? e.data
                ? ((this.options.data = !0),
                  this.opcode("lookupData", e.depth, e.parts, e.strict))
                : this.opcode("lookupOnContext", e.parts, e.falsy, e.strict, n)
              : this.opcode("pushContext");
          },
          StringLiteral: function (e) {
            this.opcode("pushString", e.value);
          },
          NumberLiteral: function (e) {
            this.opcode("pushLiteral", e.value);
          },
          BooleanLiteral: function (e) {
            this.opcode("pushLiteral", e.value);
          },
          UndefinedLiteral: function () {
            this.opcode("pushLiteral", "undefined");
          },
          NullLiteral: function () {
            this.opcode("pushLiteral", "null");
          },
          Hash: function (e) {
            var t = e.pairs,
              n = 0,
              i = t.length;
            for (this.opcode("pushHash"); i > n; n++)
              this.pushParam(t[n].value);
            for (; n--; ) this.opcode("assignToHash", t[n].key);
            this.opcode("popHash");
          },
          opcode: function (e) {
            this.opcodes.push({
              opcode: e,
              args: f.call(arguments, 1),
              loc: this.sourceNode[0].loc,
            });
          },
          addDepth: function (e) {
            e && (this.useDepths = !0);
          },
          classifySexpr: function (e) {
            var t = h.default.helpers.simpleId(e.path),
              n = t && !!this.blockParamIndex(e.path.parts[0]),
              i = !n && h.default.helpers.helperExpression(e),
              r = !n && (i || t);
            if (r && !i) {
              var o = e.path.parts[0],
                s = this.options;
              s.knownHelpers[o] ? (i = !0) : s.knownHelpersOnly && (r = !1);
            }
            return i ? "helper" : r ? "ambiguous" : "simple";
          },
          pushParams: function (e) {
            for (var t = 0, n = e.length; n > t; t++) this.pushParam(e[t]);
          },
          pushParam: function (e) {
            var t = null != e.value ? e.value : e.original || "";
            if (this.stringParams)
              t.replace &&
                (t = t.replace(/^(\.?\.\/)*/g, "").replace(/\//g, ".")),
                e.depth && this.addDepth(e.depth),
                this.opcode("getContext", e.depth || 0),
                this.opcode("pushStringParam", t, e.type),
                "SubExpression" === e.type && this.accept(e);
            else {
              if (this.trackIds) {
                var n = void 0;
                if (
                  (!e.parts ||
                    h.default.helpers.scopedId(e) ||
                    e.depth ||
                    (n = this.blockParamIndex(e.parts[0])),
                  n)
                ) {
                  var i = e.parts.slice(1).join(".");
                  this.opcode("pushId", "BlockParam", n, i);
                } else
                  (t = e.original || t),
                    t.replace &&
                      (t = t
                        .replace(/^this(?:\.|$)/, "")
                        .replace(/^\.\//, "")
                        .replace(/^\.$/, "")),
                    this.opcode("pushId", e.type, t);
              }
              this.accept(e);
            }
          },
          setupFullMustacheParams: function (e, t, n, i) {
            var r = e.params;
            return (
              this.pushParams(r),
              this.opcode("pushProgram", t),
              this.opcode("pushProgram", n),
              e.hash ? this.accept(e.hash) : this.opcode("emptyHash", i),
              r
            );
          },
          blockParamIndex: function (e) {
            for (var t = 0, n = this.options.blockParams.length; n > t; t++) {
              var i = this.options.blockParams[t],
                r = i && p.indexOf(i, e);
              if (i && r >= 0) return [t, r];
            }
          },
        };
      },
      function (e, t, n) {
        "use strict";
        function i(e) {
          this.value = e;
        }
        function r() {}
        function o(e, t, n, i) {
          var r = t.popStack(),
            o = 0,
            s = n.length;
          for (e && s--; s > o; o++) r = t.nameLookup(r, n[o], i);
          return e
            ? [
                t.aliasable("container.strict"),
                "(",
                r,
                ", ",
                t.quotedString(n[o]),
                ")",
              ]
            : r;
        }
        var s = n(8).default;
        t.__esModule = !0;
        var a = n(10),
          l = n(12),
          c = s(l),
          u = n(13),
          p = n(18),
          d = s(p);
        (r.prototype = {
          nameLookup: function (e, t) {
            return r.isValidJavaScriptVariableName(t)
              ? [e, ".", t]
              : [e, "[", JSON.stringify(t), "]"];
          },
          depthedLookup: function (e) {
            return [this.aliasable("container.lookup"), '(depths, "', e, '")'];
          },
          compilerInfo: function () {
            var e = a.COMPILER_REVISION,
              t = a.REVISION_CHANGES[e];
            return [e, t];
          },
          appendToBuffer: function (e, t, n) {
            return (
              u.isArray(e) || (e = [e]),
              (e = this.source.wrap(e, t)),
              this.environment.isSimple
                ? ["return ", e, ";"]
                : n
                ? ["buffer += ", e, ";"]
                : ((e.appendToBuffer = !0), e)
            );
          },
          initializeBuffer: function () {
            return this.quotedString("");
          },
          compile: function (e, t, n, i) {
            (this.environment = e),
              (this.options = t),
              (this.stringParams = this.options.stringParams),
              (this.trackIds = this.options.trackIds),
              (this.precompile = !i),
              (this.name = this.environment.name),
              (this.isChild = !!n),
              (this.context = n || {
                decorators: [],
                programs: [],
                environments: [],
              }),
              this.preamble(),
              (this.stackSlot = 0),
              (this.stackVars = []),
              (this.aliases = {}),
              (this.registers = { list: [] }),
              (this.hashes = []),
              (this.compileStack = []),
              (this.inlineStack = []),
              (this.blockParams = []),
              this.compileChildren(e, t),
              (this.useDepths =
                this.useDepths ||
                e.useDepths ||
                e.useDecorators ||
                this.options.compat),
              (this.useBlockParams = this.useBlockParams || e.useBlockParams);
            var r = e.opcodes,
              o = void 0,
              s = void 0,
              a = void 0,
              l = void 0;
            for (a = 0, l = r.length; l > a; a++)
              (o = r[a]),
                (this.source.currentLocation = o.loc),
                (s = s || o.loc),
                this[o.opcode].apply(this, o.args);
            if (
              ((this.source.currentLocation = s),
              this.pushSource(""),
              this.stackSlot ||
                this.inlineStack.length ||
                this.compileStack.length)
            )
              throw new c.default(
                "Compile completed with content left on stack"
              );
            this.decorators.isEmpty()
              ? (this.decorators = void 0)
              : ((this.useDecorators = !0),
                this.decorators.prepend(
                  "var decorators = container.decorators;\n"
                ),
                this.decorators.push("return fn;"),
                i
                  ? (this.decorators = Function.apply(this, [
                      "fn",
                      "props",
                      "container",
                      "depth0",
                      "data",
                      "blockParams",
                      "depths",
                      this.decorators.merge(),
                    ]))
                  : (this.decorators.prepend(
                      "function(fn, props, container, depth0, data, blockParams, depths) {\n"
                    ),
                    this.decorators.push("}\n"),
                    (this.decorators = this.decorators.merge())));
            var u = this.createFunctionContext(i);
            if (this.isChild) return u;
            var p = { compiler: this.compilerInfo(), main: u };
            this.decorators &&
              ((p.main_d = this.decorators), (p.useDecorators = !0));
            var d = this.context,
              h = d.programs,
              f = d.decorators;
            for (a = 0, l = h.length; l > a; a++)
              h[a] &&
                ((p[a] = h[a]),
                f[a] && ((p[a + "_d"] = f[a]), (p.useDecorators = !0)));
            return (
              this.environment.usePartial && (p.usePartial = !0),
              this.options.data && (p.useData = !0),
              this.useDepths && (p.useDepths = !0),
              this.useBlockParams && (p.useBlockParams = !0),
              this.options.compat && (p.compat = !0),
              i
                ? (p.compilerOptions = this.options)
                : ((p.compiler = JSON.stringify(p.compiler)),
                  (this.source.currentLocation = {
                    start: { line: 1, column: 0 },
                  }),
                  (p = this.objectLiteral(p)),
                  t.srcName
                    ? ((p = p.toStringWithSourceMap({ file: t.destName })),
                      (p.map = p.map && p.map.toString()))
                    : (p = p.toString())),
              p
            );
          },
          preamble: function () {
            (this.lastContext = 0),
              (this.source = new d.default(this.options.srcName)),
              (this.decorators = new d.default(this.options.srcName));
          },
          createFunctionContext: function (e) {
            var t = "",
              n = this.stackVars.concat(this.registers.list);
            n.length > 0 && (t += ", " + n.join(", "));
            var i = 0;
            for (var r in this.aliases) {
              var o = this.aliases[r];
              this.aliases.hasOwnProperty(r) &&
                o.children &&
                o.referenceCount > 1 &&
                ((t += ", alias" + ++i + "=" + r),
                (o.children[0] = "alias" + i));
            }
            var s = ["container", "depth0", "helpers", "partials", "data"];
            (this.useBlockParams || this.useDepths) && s.push("blockParams"),
              this.useDepths && s.push("depths");
            var a = this.mergeSource(t);
            return e
              ? (s.push(a), Function.apply(this, s))
              : this.source.wrap(["function(", s.join(","), ") {\n  ", a, "}"]);
          },
          mergeSource: function (e) {
            var t = this.environment.isSimple,
              n = !this.forceBuffer,
              i = void 0,
              r = void 0,
              o = void 0,
              s = void 0;
            return (
              this.source.each(function (e) {
                e.appendToBuffer
                  ? (o ? e.prepend("  + ") : (o = e), (s = e))
                  : (o &&
                      (r ? o.prepend("buffer += ") : (i = !0),
                      s.add(";"),
                      (o = s = void 0)),
                    (r = !0),
                    t || (n = !1));
              }),
              n
                ? o
                  ? (o.prepend("return "), s.add(";"))
                  : r || this.source.push('return "";')
                : ((e += ", buffer = " + (i ? "" : this.initializeBuffer())),
                  o
                    ? (o.prepend("return buffer + "), s.add(";"))
                    : this.source.push("return buffer;")),
              e &&
                this.source.prepend("var " + e.substring(2) + (i ? "" : ";\n")),
              this.source.merge()
            );
          },
          blockValue: function (e) {
            var t = this.aliasable("helpers.blockHelperMissing"),
              n = [this.contextName(0)];
            this.setupHelperArgs(e, 0, n);
            var i = this.popStack();
            n.splice(1, 0, i),
              this.push(this.source.functionCall(t, "call", n));
          },
          ambiguousBlockValue: function () {
            var e = this.aliasable("helpers.blockHelperMissing"),
              t = [this.contextName(0)];
            this.setupHelperArgs("", 0, t, !0), this.flushInline();
            var n = this.topStack();
            t.splice(1, 0, n),
              this.pushSource([
                "if (!",
                this.lastHelper,
                ") { ",
                n,
                " = ",
                this.source.functionCall(e, "call", t),
                "}",
              ]);
          },
          appendContent: function (e) {
            this.pendingContent
              ? (e = this.pendingContent + e)
              : (this.pendingLocation = this.source.currentLocation),
              (this.pendingContent = e);
          },
          append: function () {
            if (this.isInline())
              this.replaceStack(function (e) {
                return [" != null ? ", e, ' : ""'];
              }),
                this.pushSource(this.appendToBuffer(this.popStack()));
            else {
              var e = this.popStack();
              this.pushSource([
                "if (",
                e,
                " != null) { ",
                this.appendToBuffer(e, void 0, !0),
                " }",
              ]),
                this.environment.isSimple &&
                  this.pushSource([
                    "else { ",
                    this.appendToBuffer("''", void 0, !0),
                    " }",
                  ]);
            }
          },
          appendEscaped: function () {
            this.pushSource(
              this.appendToBuffer([
                this.aliasable("container.escapeExpression"),
                "(",
                this.popStack(),
                ")",
              ])
            );
          },
          getContext: function (e) {
            this.lastContext = e;
          },
          pushContext: function () {
            this.pushStackLiteral(this.contextName(this.lastContext));
          },
          lookupOnContext: function (e, t, n, i) {
            var r = 0;
            i || !this.options.compat || this.lastContext
              ? this.pushContext()
              : this.push(this.depthedLookup(e[r++])),
              this.resolvePath("context", e, r, t, n);
          },
          lookupBlockParam: function (e, t) {
            (this.useBlockParams = !0),
              this.push(["blockParams[", e[0], "][", e[1], "]"]),
              this.resolvePath("context", t, 1);
          },
          lookupData: function (e, t, n) {
            e
              ? this.pushStackLiteral("container.data(data, " + e + ")")
              : this.pushStackLiteral("data"),
              this.resolvePath("data", t, 0, !0, n);
          },
          resolvePath: function (e, t, n, i, r) {
            var s = this;
            if (this.options.strict || this.options.assumeObjects)
              return void this.push(o(this.options.strict && r, this, t, e));
            for (var a = t.length; a > n; n++)
              this.replaceStack(function (r) {
                var o = s.nameLookup(r, t[n], e);
                return i ? [" && ", o] : [" != null ? ", o, " : ", r];
              });
          },
          resolvePossibleLambda: function () {
            this.push([
              this.aliasable("container.lambda"),
              "(",
              this.popStack(),
              ", ",
              this.contextName(0),
              ")",
            ]);
          },
          pushStringParam: function (e, t) {
            this.pushContext(),
              this.pushString(t),
              "SubExpression" !== t &&
                ("string" == typeof e
                  ? this.pushString(e)
                  : this.pushStackLiteral(e));
          },
          emptyHash: function (e) {
            this.trackIds && this.push("{}"),
              this.stringParams && (this.push("{}"), this.push("{}")),
              this.pushStackLiteral(e ? "undefined" : "{}");
          },
          pushHash: function () {
            this.hash && this.hashes.push(this.hash),
              (this.hash = { values: [], types: [], contexts: [], ids: [] });
          },
          popHash: function () {
            var e = this.hash;
            (this.hash = this.hashes.pop()),
              this.trackIds && this.push(this.objectLiteral(e.ids)),
              this.stringParams &&
                (this.push(this.objectLiteral(e.contexts)),
                this.push(this.objectLiteral(e.types))),
              this.push(this.objectLiteral(e.values));
          },
          pushString: function (e) {
            this.pushStackLiteral(this.quotedString(e));
          },
          pushLiteral: function (e) {
            this.pushStackLiteral(e);
          },
          pushProgram: function (e) {
            null != e
              ? this.pushStackLiteral(this.programExpression(e))
              : this.pushStackLiteral(null);
          },
          registerDecorator: function (e, t) {
            var n = this.nameLookup("decorators", t, "decorator"),
              i = this.setupHelperArgs(t, e);
            this.decorators.push([
              "fn = ",
              this.decorators.functionCall(n, "", [
                "fn",
                "props",
                "container",
                i,
              ]),
              " || fn;",
            ]);
          },
          invokeHelper: function (e, t, n) {
            var i = this.popStack(),
              r = this.setupHelper(e, t),
              o = n ? [r.name, " || "] : "",
              s = ["("].concat(o, i);
            this.options.strict ||
              s.push(" || ", this.aliasable("helpers.helperMissing")),
              s.push(")"),
              this.push(this.source.functionCall(s, "call", r.callParams));
          },
          invokeKnownHelper: function (e, t) {
            var n = this.setupHelper(e, t);
            this.push(this.source.functionCall(n.name, "call", n.callParams));
          },
          invokeAmbiguous: function (e, t) {
            this.useRegister("helper");
            var n = this.popStack();
            this.emptyHash();
            var i = this.setupHelper(0, e, t),
              r = (this.lastHelper = this.nameLookup("helpers", e, "helper")),
              o = ["(", "(helper = ", r, " || ", n, ")"];
            this.options.strict ||
              ((o[0] = "(helper = "),
              o.push(
                " != null ? helper : ",
                this.aliasable("helpers.helperMissing")
              )),
              this.push([
                "(",
                o,
                i.paramsInit ? ["),(", i.paramsInit] : [],
                "),",
                "(typeof helper === ",
                this.aliasable('"function"'),
                " ? ",
                this.source.functionCall("helper", "call", i.callParams),
                " : helper))",
              ]);
          },
          invokePartial: function (e, t, n) {
            var i = [],
              r = this.setupParams(t, 1, i);
            e && ((t = this.popStack()), delete r.name),
              n && (r.indent = JSON.stringify(n)),
              (r.helpers = "helpers"),
              (r.partials = "partials"),
              (r.decorators = "container.decorators"),
              e
                ? i.unshift(t)
                : i.unshift(this.nameLookup("partials", t, "partial")),
              this.options.compat && (r.depths = "depths"),
              (r = this.objectLiteral(r)),
              i.push(r),
              this.push(
                this.source.functionCall("container.invokePartial", "", i)
              );
          },
          assignToHash: function (e) {
            var t = this.popStack(),
              n = void 0,
              i = void 0,
              r = void 0;
            this.trackIds && (r = this.popStack()),
              this.stringParams &&
                ((i = this.popStack()), (n = this.popStack()));
            var o = this.hash;
            n && (o.contexts[e] = n),
              i && (o.types[e] = i),
              r && (o.ids[e] = r),
              (o.values[e] = t);
          },
          pushId: function (e, t, n) {
            "BlockParam" === e
              ? this.pushStackLiteral(
                  "blockParams[" +
                    t[0] +
                    "].path[" +
                    t[1] +
                    "]" +
                    (n ? " + " + JSON.stringify("." + n) : "")
                )
              : "PathExpression" === e
              ? this.pushString(t)
              : "SubExpression" === e
              ? this.pushStackLiteral("true")
              : this.pushStackLiteral("null");
          },
          compiler: r,
          compileChildren: function (e, t) {
            for (
              var n = e.children, i = void 0, r = void 0, o = 0, s = n.length;
              s > o;
              o++
            ) {
              (i = n[o]), (r = new this.compiler());
              var a = this.matchExistingProgram(i);
              null == a
                ? (this.context.programs.push(""),
                  (a = this.context.programs.length),
                  (i.index = a),
                  (i.name = "program" + a),
                  (this.context.programs[a] = r.compile(
                    i,
                    t,
                    this.context,
                    !this.precompile
                  )),
                  (this.context.decorators[a] = r.decorators),
                  (this.context.environments[a] = i),
                  (this.useDepths = this.useDepths || r.useDepths),
                  (this.useBlockParams =
                    this.useBlockParams || r.useBlockParams))
                : ((i.index = a),
                  (i.name = "program" + a),
                  (this.useDepths = this.useDepths || i.useDepths),
                  (this.useBlockParams =
                    this.useBlockParams || i.useBlockParams));
            }
          },
          matchExistingProgram: function (e) {
            for (var t = 0, n = this.context.environments.length; n > t; t++) {
              var i = this.context.environments[t];
              if (i && i.equals(e)) return t;
            }
          },
          programExpression: function (e) {
            var t = this.environment.children[e],
              n = [t.index, "data", t.blockParams];
            return (
              (this.useBlockParams || this.useDepths) && n.push("blockParams"),
              this.useDepths && n.push("depths"),
              "container.program(" + n.join(", ") + ")"
            );
          },
          useRegister: function (e) {
            this.registers[e] ||
              ((this.registers[e] = !0), this.registers.list.push(e));
          },
          push: function (e) {
            return (
              e instanceof i || (e = this.source.wrap(e)),
              this.inlineStack.push(e),
              e
            );
          },
          pushStackLiteral: function (e) {
            this.push(new i(e));
          },
          pushSource: function (e) {
            this.pendingContent &&
              (this.source.push(
                this.appendToBuffer(
                  this.source.quotedString(this.pendingContent),
                  this.pendingLocation
                )
              ),
              (this.pendingContent = void 0)),
              e && this.source.push(e);
          },
          replaceStack: function (e) {
            var t = ["("],
              n = void 0,
              r = void 0,
              o = void 0;
            if (!this.isInline())
              throw new c.default("replaceStack on non-inline");
            var s = this.popStack(!0);
            if (s instanceof i) (n = [s.value]), (t = ["(", n]), (o = !0);
            else {
              r = !0;
              var a = this.incrStack();
              (t = ["((", this.push(a), " = ", s, ")"]), (n = this.topStack());
            }
            var l = e.call(this, n);
            o || this.popStack(),
              r && this.stackSlot--,
              this.push(t.concat(l, ")"));
          },
          incrStack: function () {
            return (
              this.stackSlot++,
              this.stackSlot > this.stackVars.length &&
                this.stackVars.push("stack" + this.stackSlot),
              this.topStackName()
            );
          },
          topStackName: function () {
            return "stack" + this.stackSlot;
          },
          flushInline: function () {
            var e = this.inlineStack;
            this.inlineStack = [];
            for (var t = 0, n = e.length; n > t; t++) {
              var r = e[t];
              if (r instanceof i) this.compileStack.push(r);
              else {
                var o = this.incrStack();
                this.pushSource([o, " = ", r, ";"]), this.compileStack.push(o);
              }
            }
          },
          isInline: function () {
            return this.inlineStack.length;
          },
          popStack: function (e) {
            var t = this.isInline(),
              n = (t ? this.inlineStack : this.compileStack).pop();
            if (!e && n instanceof i) return n.value;
            if (!t) {
              if (!this.stackSlot) throw new c.default("Invalid stack pop");
              this.stackSlot--;
            }
            return n;
          },
          topStack: function () {
            var e = this.isInline() ? this.inlineStack : this.compileStack,
              t = e[e.length - 1];
            return t instanceof i ? t.value : t;
          },
          contextName: function (e) {
            return this.useDepths && e ? "depths[" + e + "]" : "depth" + e;
          },
          quotedString: function (e) {
            return this.source.quotedString(e);
          },
          objectLiteral: function (e) {
            return this.source.objectLiteral(e);
          },
          aliasable: function (e) {
            var t = this.aliases[e];
            return t
              ? (t.referenceCount++, t)
              : ((t = this.aliases[e] = this.source.wrap(e)),
                (t.aliasable = !0),
                (t.referenceCount = 1),
                t);
          },
          setupHelper: function (e, t, n) {
            var i = [],
              r = this.setupHelperArgs(t, e, i, n),
              o = this.nameLookup("helpers", t, "helper"),
              s = this.aliasable(
                this.contextName(0) +
                  " != null ? " +
                  this.contextName(0) +
                  " : {}"
              );
            return {
              params: i,
              paramsInit: r,
              name: o,
              callParams: [s].concat(i),
            };
          },
          setupParams: function (e, t, n) {
            var i = {},
              r = [],
              o = [],
              s = [],
              a = !n,
              l = void 0;
            a && (n = []),
              (i.name = this.quotedString(e)),
              (i.hash = this.popStack()),
              this.trackIds && (i.hashIds = this.popStack()),
              this.stringParams &&
                ((i.hashTypes = this.popStack()),
                (i.hashContexts = this.popStack()));
            var c = this.popStack(),
              u = this.popStack();
            (u || c) &&
              ((i.fn = u || "container.noop"),
              (i.inverse = c || "container.noop"));
            for (var p = t; p--; )
              (l = this.popStack()),
                (n[p] = l),
                this.trackIds && (s[p] = this.popStack()),
                this.stringParams &&
                  ((o[p] = this.popStack()), (r[p] = this.popStack()));
            return (
              a && (i.args = this.source.generateArray(n)),
              this.trackIds && (i.ids = this.source.generateArray(s)),
              this.stringParams &&
                ((i.types = this.source.generateArray(o)),
                (i.contexts = this.source.generateArray(r))),
              this.options.data && (i.data = "data"),
              this.useBlockParams && (i.blockParams = "blockParams"),
              i
            );
          },
          setupHelperArgs: function (e, t, n, i) {
            var r = this.setupParams(e, t, n);
            return (
              (r = this.objectLiteral(r)),
              i
                ? (this.useRegister("options"),
                  n.push("options"),
                  ["options=", r])
                : n
                ? (n.push(r), "")
                : r
            );
          },
        }),
          (function () {
            for (
              var e =
                  "break else new var case finally return void catch for switch while continue function this with default if throw delete in try do instanceof typeof abstract enum int short boolean export interface static byte extends long super char final native synchronized class float package throws const goto private transient debugger implements protected volatile double import public let yield await null true false".split(
                    " "
                  ),
                t = (r.RESERVED_WORDS = {}),
                n = 0,
                i = e.length;
              i > n;
              n++
            )
              t[e[n]] = !0;
          })(),
          (r.isValidJavaScriptVariableName = function (e) {
            return !r.RESERVED_WORDS[e] && /^[a-zA-Z_$][0-9a-zA-Z_$]*$/.test(e);
          }),
          (t.default = r),
          (e.exports = t.default);
      },
      function (e, t, n) {
        "use strict";
        function i() {
          this.parents = [];
        }
        function r(e) {
          this.acceptRequired(e, "path"),
            this.acceptArray(e.params),
            this.acceptKey(e, "hash");
        }
        function o(e) {
          r.call(this, e),
            this.acceptKey(e, "program"),
            this.acceptKey(e, "inverse");
        }
        function s(e) {
          this.acceptRequired(e, "name"),
            this.acceptArray(e.params),
            this.acceptKey(e, "hash");
        }
        var a = n(8).default;
        t.__esModule = !0;
        var l = n(12),
          c = a(l);
        (i.prototype = {
          constructor: i,
          mutating: !1,
          acceptKey: function (e, t) {
            var n = this.accept(e[t]);
            if (this.mutating) {
              if (n && !i.prototype[n.type])
                throw new c.default(
                  'Unexpected node type "' +
                    n.type +
                    '" found when accepting ' +
                    t +
                    " on " +
                    e.type
                );
              e[t] = n;
            }
          },
          acceptRequired: function (e, t) {
            if ((this.acceptKey(e, t), !e[t]))
              throw new c.default(e.type + " requires " + t);
          },
          acceptArray: function (e) {
            for (var t = 0, n = e.length; n > t; t++)
              this.acceptKey(e, t), e[t] || (e.splice(t, 1), t--, n--);
          },
          accept: function (e) {
            if (e) {
              if (!this[e.type])
                throw new c.default("Unknown type: " + e.type, e);
              this.current && this.parents.unshift(this.current),
                (this.current = e);
              var t = this[e.type](e);
              return (
                (this.current = this.parents.shift()),
                !this.mutating || t ? t : t !== !1 ? e : void 0
              );
            }
          },
          Program: function (e) {
            this.acceptArray(e.body);
          },
          MustacheStatement: r,
          Decorator: r,
          BlockStatement: o,
          DecoratorBlock: o,
          PartialStatement: s,
          PartialBlockStatement: function (e) {
            s.call(this, e), this.acceptKey(e, "program");
          },
          ContentStatement: function () {},
          CommentStatement: function () {},
          SubExpression: r,
          PathExpression: function () {},
          StringLiteral: function () {},
          NumberLiteral: function () {},
          BooleanLiteral: function () {},
          UndefinedLiteral: function () {},
          NullLiteral: function () {},
          Hash: function (e) {
            this.acceptArray(e.pairs);
          },
          HashPair: function (e) {
            this.acceptRequired(e, "value");
          },
        }),
          (t.default = i),
          (e.exports = t.default);
      },
      function (e, t, n) {
        (function (n) {
          "use strict";
          (t.__esModule = !0),
            (t.default = function (e) {
              var t = "undefined" != typeof n ? n : window,
                i = t.Handlebars;
              e.noConflict = function () {
                t.Handlebars === e && (t.Handlebars = i);
              };
            }),
            (e.exports = t.default);
        }.call(
          t,
          (function () {
            return this;
          })()
        ));
      },
      function (e, t, n) {
        "use strict";
        (t.default = function (e) {
          return e && e.__esModule ? e : { default: e };
        }),
          (t.__esModule = !0);
      },
      function (e, t, n) {
        "use strict";
        (t.default = function (e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e)
            for (var n in e)
              Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
          return (t.default = e), t;
        }),
          (t.__esModule = !0);
      },
      function (e, t, n) {
        "use strict";
        function i(e, t, n) {
          (this.helpers = e || {}),
            (this.partials = t || {}),
            (this.decorators = n || {}),
            l.registerDefaultHelpers(this),
            c.registerDefaultDecorators(this);
        }
        var r = n(8).default;
        (t.__esModule = !0), (t.HandlebarsEnvironment = i);
        var o = n(13),
          s = n(12),
          a = r(s),
          l = n(19),
          c = n(20),
          u = n(21),
          p = r(u),
          d = "4.0.3";
        t.VERSION = d;
        var h = 7;
        t.COMPILER_REVISION = h;
        var f = {
          1: "<= 1.0.rc.2",
          2: "== 1.0.0-rc.3",
          3: "== 1.0.0-rc.4",
          4: "== 1.x.x",
          5: "== 2.0.0-alpha.x",
          6: ">= 2.0.0-beta.1",
          7: ">= 4.0.0",
        };
        t.REVISION_CHANGES = f;
        var v = "[object Object]";
        i.prototype = {
          constructor: i,
          logger: p.default,
          log: p.default.log,
          registerHelper: function (e, t) {
            if (o.toString.call(e) === v) {
              if (t)
                throw new a.default("Arg not supported with multiple helpers");
              o.extend(this.helpers, e);
            } else this.helpers[e] = t;
          },
          unregisterHelper: function (e) {
            delete this.helpers[e];
          },
          registerPartial: function (e, t) {
            if (o.toString.call(e) === v) o.extend(this.partials, e);
            else {
              if ("undefined" == typeof t)
                throw new a.default(
                  "Attempting to register a partial as undefined"
                );
              this.partials[e] = t;
            }
          },
          unregisterPartial: function (e) {
            delete this.partials[e];
          },
          registerDecorator: function (e, t) {
            if (o.toString.call(e) === v) {
              if (t)
                throw new a.default(
                  "Arg not supported with multiple decorators"
                );
              o.extend(this.decorators, e);
            } else this.decorators[e] = t;
          },
          unregisterDecorator: function (e) {
            delete this.decorators[e];
          },
        };
        var g = p.default.log;
        (t.log = g), (t.createFrame = o.createFrame), (t.logger = p.default);
      },
      function (e, t, n) {
        "use strict";
        function i(e) {
          this.string = e;
        }
        (t.__esModule = !0),
          (i.prototype.toString = i.prototype.toHTML =
            function () {
              return "" + this.string;
            }),
          (t.default = i),
          (e.exports = t.default);
      },
      function (e, t, n) {
        "use strict";
        function i(e, t) {
          var n = t && t.loc,
            o = void 0,
            s = void 0;
          n &&
            ((o = n.start.line),
            (s = n.start.column),
            (e += " - " + o + ":" + s));
          for (
            var a = Error.prototype.constructor.call(this, e), l = 0;
            l < r.length;
            l++
          )
            this[r[l]] = a[r[l]];
          Error.captureStackTrace && Error.captureStackTrace(this, i),
            n && ((this.lineNumber = o), (this.column = s));
        }
        t.__esModule = !0;
        var r = [
          "description",
          "fileName",
          "lineNumber",
          "message",
          "name",
          "number",
          "stack",
        ];
        (i.prototype = new Error()), (t.default = i), (e.exports = t.default);
      },
      function (e, t, n) {
        "use strict";
        function i(e) {
          return p[e];
        }
        function r(e) {
          for (var t = 1; t < arguments.length; t++)
            for (var n in arguments[t])
              Object.prototype.hasOwnProperty.call(arguments[t], n) &&
                (e[n] = arguments[t][n]);
          return e;
        }
        function o(e, t) {
          for (var n = 0, i = e.length; i > n; n++) if (e[n] === t) return n;
          return -1;
        }
        function s(e) {
          if ("string" != typeof e) {
            if (e && e.toHTML) return e.toHTML();
            if (null == e) return "";
            if (!e) return e + "";
            e = "" + e;
          }
          return h.test(e) ? e.replace(d, i) : e;
        }
        function a(e) {
          return (!e && 0 !== e) || !(!g(e) || 0 !== e.length);
        }
        function l(e) {
          var t = r({}, e);
          return (t._parent = e), t;
        }
        function c(e, t) {
          return (e.path = t), e;
        }
        function u(e, t) {
          return (e ? e + "." : "") + t;
        }
        (t.__esModule = !0),
          (t.extend = r),
          (t.indexOf = o),
          (t.escapeExpression = s),
          (t.isEmpty = a),
          (t.createFrame = l),
          (t.blockParams = c),
          (t.appendContextPath = u);
        var p = {
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#x27;",
            "`": "&#x60;",
            "=": "&#x3D;",
          },
          d = /[&<>"'`=]/g,
          h = /[&<>"'`=]/,
          f = Object.prototype.toString;
        t.toString = f;
        var v = function (e) {
          return "function" == typeof e;
        };
        v(/x/) &&
          (t.isFunction = v =
            function (e) {
              return (
                "function" == typeof e && "[object Function]" === f.call(e)
              );
            }),
          (t.isFunction = v);
        var g =
          Array.isArray ||
          function (e) {
            return (
              !(!e || "object" != typeof e) && "[object Array]" === f.call(e)
            );
          };
        t.isArray = g;
      },
      function (e, t, n) {
        "use strict";
        function i(e) {
          var t = (e && e[0]) || 1,
            n = m.COMPILER_REVISION;
          if (t !== n) {
            if (n > t) {
              var i = m.REVISION_CHANGES[n],
                r = m.REVISION_CHANGES[t];
              throw new g.default(
                "Template was precompiled with an older version of Handlebars than the current runtime. Please update your precompiler to a newer version (" +
                  i +
                  ") or downgrade your runtime to an older version (" +
                  r +
                  ")."
              );
            }
            throw new g.default(
              "Template was precompiled with a newer version of Handlebars than the current runtime. Please update your runtime to a newer version (" +
                e[1] +
                ")."
            );
          }
        }
        function r(e, t) {
          function n(n, i, r) {
            r.hash && ((i = f.extend({}, i, r.hash)), r.ids && (r.ids[0] = !0)),
              (n = t.VM.resolvePartial.call(this, n, i, r));
            var o = t.VM.invokePartial.call(this, n, i, r);
            if (
              (null == o &&
                t.compile &&
                ((r.partials[r.name] = t.compile(n, e.compilerOptions, t)),
                (o = r.partials[r.name](i, r))),
              null != o)
            ) {
              if (r.indent) {
                for (
                  var s = o.split("\n"), a = 0, l = s.length;
                  l > a && (s[a] || a + 1 !== l);
                  a++
                )
                  s[a] = r.indent + s[a];
                o = s.join("\n");
              }
              return o;
            }
            throw new g.default(
              "The partial " +
                r.name +
                " could not be compiled when running in runtime-only mode"
            );
          }
          function i(t) {
            function n(t) {
              return "" + e.main(r, t, r.helpers, r.partials, s, l, a);
            }
            var o =
                arguments.length <= 1 || void 0 === arguments[1]
                  ? {}
                  : arguments[1],
              s = o.data;
            i._setup(o), !o.partial && e.useData && (s = c(t, s));
            var a = void 0,
              l = e.useBlockParams ? [] : void 0;
            return (
              e.useDepths &&
                (a = o.depths
                  ? t !== o.depths[0]
                    ? [t].concat(o.depths)
                    : o.depths
                  : [t]),
              (n = u(e.main, n, r, o.depths || [], s, l))(t, o)
            );
          }
          if (!t) throw new g.default("No environment passed to template");
          if (!e || !e.main)
            throw new g.default("Unknown template object: " + typeof e);
          (e.main.decorator = e.main_d), t.VM.checkRevision(e.compiler);
          var r = {
            strict: function (e, t) {
              if (!(t in e))
                throw new g.default('"' + t + '" not defined in ' + e);
              return e[t];
            },
            lookup: function (e, t) {
              for (var n = e.length, i = 0; n > i; i++)
                if (e[i] && null != e[i][t]) return e[i][t];
            },
            lambda: function (e, t) {
              return "function" == typeof e ? e.call(t) : e;
            },
            escapeExpression: f.escapeExpression,
            invokePartial: n,
            fn: function (t) {
              var n = e[t];
              return (n.decorator = e[t + "_d"]), n;
            },
            programs: [],
            program: function (e, t, n, i, r) {
              var s = this.programs[e],
                a = this.fn(e);
              return (
                t || r || i || n
                  ? (s = o(this, e, a, t, n, i, r))
                  : s || (s = this.programs[e] = o(this, e, a)),
                s
              );
            },
            data: function (e, t) {
              for (; e && t--; ) e = e._parent;
              return e;
            },
            merge: function (e, t) {
              var n = e || t;
              return e && t && e !== t && (n = f.extend({}, t, e)), n;
            },
            noop: t.VM.noop,
            compilerInfo: e.compiler,
          };
          return (
            (i.isTop = !0),
            (i._setup = function (n) {
              n.partial
                ? ((r.helpers = n.helpers),
                  (r.partials = n.partials),
                  (r.decorators = n.decorators))
                : ((r.helpers = r.merge(n.helpers, t.helpers)),
                  e.usePartial &&
                    (r.partials = r.merge(n.partials, t.partials)),
                  (e.usePartial || e.useDecorators) &&
                    (r.decorators = r.merge(n.decorators, t.decorators)));
            }),
            (i._child = function (t, n, i, s) {
              if (e.useBlockParams && !i)
                throw new g.default("must pass block params");
              if (e.useDepths && !s)
                throw new g.default("must pass parent depths");
              return o(r, t, e[t], n, 0, i, s);
            }),
            i
          );
        }
        function o(e, t, n, i, r, o, s) {
          function a(t) {
            var r =
                arguments.length <= 1 || void 0 === arguments[1]
                  ? {}
                  : arguments[1],
              a = s;
            return (
              s && t !== s[0] && (a = [t].concat(s)),
              n(
                e,
                t,
                e.helpers,
                e.partials,
                r.data || i,
                o && [r.blockParams].concat(o),
                a
              )
            );
          }
          return (
            (a = u(n, a, e, s, i, o)),
            (a.program = t),
            (a.depth = s ? s.length : 0),
            (a.blockParams = r || 0),
            a
          );
        }
        function s(e, t, n) {
          return (
            e
              ? e.call || n.name || ((n.name = e), (e = n.partials[e]))
              : (e =
                  "@partial-block" === n.name
                    ? n.data["partial-block"]
                    : n.partials[n.name]),
            e
          );
        }
        function a(e, t, n) {
          (n.partial = !0),
            n.ids && (n.data.contextPath = n.ids[0] || n.data.contextPath);
          var i = void 0;
          if (
            (n.fn &&
              n.fn !== l &&
              ((n.data = m.createFrame(n.data)),
              (i = n.data["partial-block"] = n.fn),
              i.partials &&
                (n.partials = f.extend({}, n.partials, i.partials))),
            void 0 === e && i && (e = i),
            void 0 === e)
          )
            throw new g.default(
              "The partial " + n.name + " could not be found"
            );
          return e instanceof Function ? e(t, n) : void 0;
        }
        function l() {
          return "";
        }
        function c(e, t) {
          return (
            (t && "root" in t) ||
              ((t = t ? m.createFrame(t) : {}), (t.root = e)),
            t
          );
        }
        function u(e, t, n, i, r, o) {
          if (e.decorator) {
            var s = {};
            (t = e.decorator(t, s, n, i && i[0], r, o, i)), f.extend(t, s);
          }
          return t;
        }
        var p = n(9).default,
          d = n(8).default;
        (t.__esModule = !0),
          (t.checkRevision = i),
          (t.template = r),
          (t.wrapProgram = o),
          (t.resolvePartial = s),
          (t.invokePartial = a),
          (t.noop = l);
        var h = n(13),
          f = p(h),
          v = n(12),
          g = d(v),
          m = n(10);
      },
      function (e, t, n) {
        "use strict";
        var i = (function () {
          function e() {
            this.yy = {};
          }
          var t = {
              trace: function () {},
              yy: {},
              symbols_: {
                error: 2,
                root: 3,
                program: 4,
                EOF: 5,
                program_repetition0: 6,
                statement: 7,
                mustache: 8,
                block: 9,
                rawBlock: 10,
                partial: 11,
                partialBlock: 12,
                content: 13,
                COMMENT: 14,
                CONTENT: 15,
                openRawBlock: 16,
                rawBlock_repetition_plus0: 17,
                END_RAW_BLOCK: 18,
                OPEN_RAW_BLOCK: 19,
                helperName: 20,
                openRawBlock_repetition0: 21,
                openRawBlock_option0: 22,
                CLOSE_RAW_BLOCK: 23,
                openBlock: 24,
                block_option0: 25,
                closeBlock: 26,
                openInverse: 27,
                block_option1: 28,
                OPEN_BLOCK: 29,
                openBlock_repetition0: 30,
                openBlock_option0: 31,
                openBlock_option1: 32,
                CLOSE: 33,
                OPEN_INVERSE: 34,
                openInverse_repetition0: 35,
                openInverse_option0: 36,
                openInverse_option1: 37,
                openInverseChain: 38,
                OPEN_INVERSE_CHAIN: 39,
                openInverseChain_repetition0: 40,
                openInverseChain_option0: 41,
                openInverseChain_option1: 42,
                inverseAndProgram: 43,
                INVERSE: 44,
                inverseChain: 45,
                inverseChain_option0: 46,
                OPEN_ENDBLOCK: 47,
                OPEN: 48,
                mustache_repetition0: 49,
                mustache_option0: 50,
                OPEN_UNESCAPED: 51,
                mustache_repetition1: 52,
                mustache_option1: 53,
                CLOSE_UNESCAPED: 54,
                OPEN_PARTIAL: 55,
                partialName: 56,
                partial_repetition0: 57,
                partial_option0: 58,
                openPartialBlock: 59,
                OPEN_PARTIAL_BLOCK: 60,
                openPartialBlock_repetition0: 61,
                openPartialBlock_option0: 62,
                param: 63,
                sexpr: 64,
                OPEN_SEXPR: 65,
                sexpr_repetition0: 66,
                sexpr_option0: 67,
                CLOSE_SEXPR: 68,
                hash: 69,
                hash_repetition_plus0: 70,
                hashSegment: 71,
                ID: 72,
                EQUALS: 73,
                blockParams: 74,
                OPEN_BLOCK_PARAMS: 75,
                blockParams_repetition_plus0: 76,
                CLOSE_BLOCK_PARAMS: 77,
                path: 78,
                dataName: 79,
                STRING: 80,
                NUMBER: 81,
                BOOLEAN: 82,
                UNDEFINED: 83,
                NULL: 84,
                DATA: 85,
                pathSegments: 86,
                SEP: 87,
                $accept: 0,
                $end: 1,
              },
              terminals_: {
                2: "error",
                5: "EOF",
                14: "COMMENT",
                15: "CONTENT",
                18: "END_RAW_BLOCK",
                19: "OPEN_RAW_BLOCK",
                23: "CLOSE_RAW_BLOCK",
                29: "OPEN_BLOCK",
                33: "CLOSE",
                34: "OPEN_INVERSE",
                39: "OPEN_INVERSE_CHAIN",
                44: "INVERSE",
                47: "OPEN_ENDBLOCK",
                48: "OPEN",
                51: "OPEN_UNESCAPED",
                54: "CLOSE_UNESCAPED",
                55: "OPEN_PARTIAL",
                60: "OPEN_PARTIAL_BLOCK",
                65: "OPEN_SEXPR",
                68: "CLOSE_SEXPR",
                72: "ID",
                73: "EQUALS",
                75: "OPEN_BLOCK_PARAMS",
                77: "CLOSE_BLOCK_PARAMS",
                80: "STRING",
                81: "NUMBER",
                82: "BOOLEAN",
                83: "UNDEFINED",
                84: "NULL",
                85: "DATA",
                87: "SEP",
              },
              productions_: [
                0,
                [3, 2],
                [4, 1],
                [7, 1],
                [7, 1],
                [7, 1],
                [7, 1],
                [7, 1],
                [7, 1],
                [7, 1],
                [13, 1],
                [10, 3],
                [16, 5],
                [9, 4],
                [9, 4],
                [24, 6],
                [27, 6],
                [38, 6],
                [43, 2],
                [45, 3],
                [45, 1],
                [26, 3],
                [8, 5],
                [8, 5],
                [11, 5],
                [12, 3],
                [59, 5],
                [63, 1],
                [63, 1],
                [64, 5],
                [69, 1],
                [71, 3],
                [74, 3],
                [20, 1],
                [20, 1],
                [20, 1],
                [20, 1],
                [20, 1],
                [20, 1],
                [20, 1],
                [56, 1],
                [56, 1],
                [79, 2],
                [78, 1],
                [86, 3],
                [86, 1],
                [6, 0],
                [6, 2],
                [17, 1],
                [17, 2],
                [21, 0],
                [21, 2],
                [22, 0],
                [22, 1],
                [25, 0],
                [25, 1],
                [28, 0],
                [28, 1],
                [30, 0],
                [30, 2],
                [31, 0],
                [31, 1],
                [32, 0],
                [32, 1],
                [35, 0],
                [35, 2],
                [36, 0],
                [36, 1],
                [37, 0],
                [37, 1],
                [40, 0],
                [40, 2],
                [41, 0],
                [41, 1],
                [42, 0],
                [42, 1],
                [46, 0],
                [46, 1],
                [49, 0],
                [49, 2],
                [50, 0],
                [50, 1],
                [52, 0],
                [52, 2],
                [53, 0],
                [53, 1],
                [57, 0],
                [57, 2],
                [58, 0],
                [58, 1],
                [61, 0],
                [61, 2],
                [62, 0],
                [62, 1],
                [66, 0],
                [66, 2],
                [67, 0],
                [67, 1],
                [70, 1],
                [70, 2],
                [76, 1],
                [76, 2],
              ],
              performAction: function (e, t, n, i, r, o, s) {
                var a = o.length - 1;
                switch (r) {
                  case 1:
                    return o[a - 1];
                  case 2:
                    this.$ = i.prepareProgram(o[a]);
                    break;
                  case 3:
                    this.$ = o[a];
                    break;
                  case 4:
                    this.$ = o[a];
                    break;
                  case 5:
                    this.$ = o[a];
                    break;
                  case 6:
                    this.$ = o[a];
                    break;
                  case 7:
                    this.$ = o[a];
                    break;
                  case 8:
                    this.$ = o[a];
                    break;
                  case 9:
                    this.$ = {
                      type: "CommentStatement",
                      value: i.stripComment(o[a]),
                      strip: i.stripFlags(o[a], o[a]),
                      loc: i.locInfo(this._$),
                    };
                    break;
                  case 10:
                    this.$ = {
                      type: "ContentStatement",
                      original: o[a],
                      value: o[a],
                      loc: i.locInfo(this._$),
                    };
                    break;
                  case 11:
                    this.$ = i.prepareRawBlock(
                      o[a - 2],
                      o[a - 1],
                      o[a],
                      this._$
                    );
                    break;
                  case 12:
                    this.$ = {
                      path: o[a - 3],
                      params: o[a - 2],
                      hash: o[a - 1],
                    };
                    break;
                  case 13:
                    this.$ = i.prepareBlock(
                      o[a - 3],
                      o[a - 2],
                      o[a - 1],
                      o[a],
                      !1,
                      this._$
                    );
                    break;
                  case 14:
                    this.$ = i.prepareBlock(
                      o[a - 3],
                      o[a - 2],
                      o[a - 1],
                      o[a],
                      !0,
                      this._$
                    );
                    break;
                  case 15:
                    this.$ = {
                      open: o[a - 5],
                      path: o[a - 4],
                      params: o[a - 3],
                      hash: o[a - 2],
                      blockParams: o[a - 1],
                      strip: i.stripFlags(o[a - 5], o[a]),
                    };
                    break;
                  case 16:
                    this.$ = {
                      path: o[a - 4],
                      params: o[a - 3],
                      hash: o[a - 2],
                      blockParams: o[a - 1],
                      strip: i.stripFlags(o[a - 5], o[a]),
                    };
                    break;
                  case 17:
                    this.$ = {
                      path: o[a - 4],
                      params: o[a - 3],
                      hash: o[a - 2],
                      blockParams: o[a - 1],
                      strip: i.stripFlags(o[a - 5], o[a]),
                    };
                    break;
                  case 18:
                    this.$ = {
                      strip: i.stripFlags(o[a - 1], o[a - 1]),
                      program: o[a],
                    };
                    break;
                  case 19:
                    var l = i.prepareBlock(
                        o[a - 2],
                        o[a - 1],
                        o[a],
                        o[a],
                        !1,
                        this._$
                      ),
                      c = i.prepareProgram([l], o[a - 1].loc);
                    (c.chained = !0),
                      (this.$ = {
                        strip: o[a - 2].strip,
                        program: c,
                        chain: !0,
                      });
                    break;
                  case 20:
                    this.$ = o[a];
                    break;
                  case 21:
                    this.$ = {
                      path: o[a - 1],
                      strip: i.stripFlags(o[a - 2], o[a]),
                    };
                    break;
                  case 22:
                    this.$ = i.prepareMustache(
                      o[a - 3],
                      o[a - 2],
                      o[a - 1],
                      o[a - 4],
                      i.stripFlags(o[a - 4], o[a]),
                      this._$
                    );
                    break;
                  case 23:
                    this.$ = i.prepareMustache(
                      o[a - 3],
                      o[a - 2],
                      o[a - 1],
                      o[a - 4],
                      i.stripFlags(o[a - 4], o[a]),
                      this._$
                    );
                    break;
                  case 24:
                    this.$ = {
                      type: "PartialStatement",
                      name: o[a - 3],
                      params: o[a - 2],
                      hash: o[a - 1],
                      indent: "",
                      strip: i.stripFlags(o[a - 4], o[a]),
                      loc: i.locInfo(this._$),
                    };
                    break;
                  case 25:
                    this.$ = i.preparePartialBlock(
                      o[a - 2],
                      o[a - 1],
                      o[a],
                      this._$
                    );
                    break;
                  case 26:
                    this.$ = {
                      path: o[a - 3],
                      params: o[a - 2],
                      hash: o[a - 1],
                      strip: i.stripFlags(o[a - 4], o[a]),
                    };
                    break;
                  case 27:
                    this.$ = o[a];
                    break;
                  case 28:
                    this.$ = o[a];
                    break;
                  case 29:
                    this.$ = {
                      type: "SubExpression",
                      path: o[a - 3],
                      params: o[a - 2],
                      hash: o[a - 1],
                      loc: i.locInfo(this._$),
                    };
                    break;
                  case 30:
                    this.$ = {
                      type: "Hash",
                      pairs: o[a],
                      loc: i.locInfo(this._$),
                    };
                    break;
                  case 31:
                    this.$ = {
                      type: "HashPair",
                      key: i.id(o[a - 2]),
                      value: o[a],
                      loc: i.locInfo(this._$),
                    };
                    break;
                  case 32:
                    this.$ = i.id(o[a - 1]);
                    break;
                  case 33:
                    this.$ = o[a];
                    break;
                  case 34:
                    this.$ = o[a];
                    break;
                  case 35:
                    this.$ = {
                      type: "StringLiteral",
                      value: o[a],
                      original: o[a],
                      loc: i.locInfo(this._$),
                    };
                    break;
                  case 36:
                    this.$ = {
                      type: "NumberLiteral",
                      value: Number(o[a]),
                      original: Number(o[a]),
                      loc: i.locInfo(this._$),
                    };
                    break;
                  case 37:
                    this.$ = {
                      type: "BooleanLiteral",
                      value: "true" === o[a],
                      original: "true" === o[a],
                      loc: i.locInfo(this._$),
                    };
                    break;
                  case 38:
                    this.$ = {
                      type: "UndefinedLiteral",
                      original: void 0,
                      value: void 0,
                      loc: i.locInfo(this._$),
                    };
                    break;
                  case 39:
                    this.$ = {
                      type: "NullLiteral",
                      original: null,
                      value: null,
                      loc: i.locInfo(this._$),
                    };
                    break;
                  case 40:
                    this.$ = o[a];
                    break;
                  case 41:
                    this.$ = o[a];
                    break;
                  case 42:
                    this.$ = i.preparePath(!0, o[a], this._$);
                    break;
                  case 43:
                    this.$ = i.preparePath(!1, o[a], this._$);
                    break;
                  case 44:
                    o[a - 2].push({
                      part: i.id(o[a]),
                      original: o[a],
                      separator: o[a - 1],
                    }),
                      (this.$ = o[a - 2]);
                    break;
                  case 45:
                    this.$ = [{ part: i.id(o[a]), original: o[a] }];
                    break;
                  case 46:
                    this.$ = [];
                    break;
                  case 47:
                    o[a - 1].push(o[a]);
                    break;
                  case 48:
                    this.$ = [o[a]];
                    break;
                  case 49:
                    o[a - 1].push(o[a]);
                    break;
                  case 50:
                    this.$ = [];
                    break;
                  case 51:
                    o[a - 1].push(o[a]);
                    break;
                  case 58:
                    this.$ = [];
                    break;
                  case 59:
                    o[a - 1].push(o[a]);
                    break;
                  case 64:
                    this.$ = [];
                    break;
                  case 65:
                    o[a - 1].push(o[a]);
                    break;
                  case 70:
                    this.$ = [];
                    break;
                  case 71:
                    o[a - 1].push(o[a]);
                    break;
                  case 78:
                    this.$ = [];
                    break;
                  case 79:
                    o[a - 1].push(o[a]);
                    break;
                  case 82:
                    this.$ = [];
                    break;
                  case 83:
                    o[a - 1].push(o[a]);
                    break;
                  case 86:
                    this.$ = [];
                    break;
                  case 87:
                    o[a - 1].push(o[a]);
                    break;
                  case 90:
                    this.$ = [];
                    break;
                  case 91:
                    o[a - 1].push(o[a]);
                    break;
                  case 94:
                    this.$ = [];
                    break;
                  case 95:
                    o[a - 1].push(o[a]);
                    break;
                  case 98:
                    this.$ = [o[a]];
                    break;
                  case 99:
                    o[a - 1].push(o[a]);
                    break;
                  case 100:
                    this.$ = [o[a]];
                    break;
                  case 101:
                    o[a - 1].push(o[a]);
                }
              },
              table: [
                {
                  3: 1,
                  4: 2,
                  5: [2, 46],
                  6: 3,
                  14: [2, 46],
                  15: [2, 46],
                  19: [2, 46],
                  29: [2, 46],
                  34: [2, 46],
                  48: [2, 46],
                  51: [2, 46],
                  55: [2, 46],
                  60: [2, 46],
                },
                { 1: [3] },
                { 5: [1, 4] },
                {
                  5: [2, 2],
                  7: 5,
                  8: 6,
                  9: 7,
                  10: 8,
                  11: 9,
                  12: 10,
                  13: 11,
                  14: [1, 12],
                  15: [1, 20],
                  16: 17,
                  19: [1, 23],
                  24: 15,
                  27: 16,
                  29: [1, 21],
                  34: [1, 22],
                  39: [2, 2],
                  44: [2, 2],
                  47: [2, 2],
                  48: [1, 13],
                  51: [1, 14],
                  55: [1, 18],
                  59: 19,
                  60: [1, 24],
                },
                { 1: [2, 1] },
                {
                  5: [2, 47],
                  14: [2, 47],
                  15: [2, 47],
                  19: [2, 47],
                  29: [2, 47],
                  34: [2, 47],
                  39: [2, 47],
                  44: [2, 47],
                  47: [2, 47],
                  48: [2, 47],
                  51: [2, 47],
                  55: [2, 47],
                  60: [2, 47],
                },
                {
                  5: [2, 3],
                  14: [2, 3],
                  15: [2, 3],
                  19: [2, 3],
                  29: [2, 3],
                  34: [2, 3],
                  39: [2, 3],
                  44: [2, 3],
                  47: [2, 3],
                  48: [2, 3],
                  51: [2, 3],
                  55: [2, 3],
                  60: [2, 3],
                },
                {
                  5: [2, 4],
                  14: [2, 4],
                  15: [2, 4],
                  19: [2, 4],
                  29: [2, 4],
                  34: [2, 4],
                  39: [2, 4],
                  44: [2, 4],
                  47: [2, 4],
                  48: [2, 4],
                  51: [2, 4],
                  55: [2, 4],
                  60: [2, 4],
                },
                {
                  5: [2, 5],
                  14: [2, 5],
                  15: [2, 5],
                  19: [2, 5],
                  29: [2, 5],
                  34: [2, 5],
                  39: [2, 5],
                  44: [2, 5],
                  47: [2, 5],
                  48: [2, 5],
                  51: [2, 5],
                  55: [2, 5],
                  60: [2, 5],
                },
                {
                  5: [2, 6],
                  14: [2, 6],
                  15: [2, 6],
                  19: [2, 6],
                  29: [2, 6],
                  34: [2, 6],
                  39: [2, 6],
                  44: [2, 6],
                  47: [2, 6],
                  48: [2, 6],
                  51: [2, 6],
                  55: [2, 6],
                  60: [2, 6],
                },
                {
                  5: [2, 7],
                  14: [2, 7],
                  15: [2, 7],
                  19: [2, 7],
                  29: [2, 7],
                  34: [2, 7],
                  39: [2, 7],
                  44: [2, 7],
                  47: [2, 7],
                  48: [2, 7],
                  51: [2, 7],
                  55: [2, 7],
                  60: [2, 7],
                },
                {
                  5: [2, 8],
                  14: [2, 8],
                  15: [2, 8],
                  19: [2, 8],
                  29: [2, 8],
                  34: [2, 8],
                  39: [2, 8],
                  44: [2, 8],
                  47: [2, 8],
                  48: [2, 8],
                  51: [2, 8],
                  55: [2, 8],
                  60: [2, 8],
                },
                {
                  5: [2, 9],
                  14: [2, 9],
                  15: [2, 9],
                  19: [2, 9],
                  29: [2, 9],
                  34: [2, 9],
                  39: [2, 9],
                  44: [2, 9],
                  47: [2, 9],
                  48: [2, 9],
                  51: [2, 9],
                  55: [2, 9],
                  60: [2, 9],
                },
                {
                  20: 25,
                  72: [1, 35],
                  78: 26,
                  79: 27,
                  80: [1, 28],
                  81: [1, 29],
                  82: [1, 30],
                  83: [1, 31],
                  84: [1, 32],
                  85: [1, 34],
                  86: 33,
                },
                {
                  20: 36,
                  72: [1, 35],
                  78: 26,
                  79: 27,
                  80: [1, 28],
                  81: [1, 29],
                  82: [1, 30],
                  83: [1, 31],
                  84: [1, 32],
                  85: [1, 34],
                  86: 33,
                },
                {
                  4: 37,
                  6: 3,
                  14: [2, 46],
                  15: [2, 46],
                  19: [2, 46],
                  29: [2, 46],
                  34: [2, 46],
                  39: [2, 46],
                  44: [2, 46],
                  47: [2, 46],
                  48: [2, 46],
                  51: [2, 46],
                  55: [2, 46],
                  60: [2, 46],
                },
                {
                  4: 38,
                  6: 3,
                  14: [2, 46],
                  15: [2, 46],
                  19: [2, 46],
                  29: [2, 46],
                  34: [2, 46],
                  44: [2, 46],
                  47: [2, 46],
                  48: [2, 46],
                  51: [2, 46],
                  55: [2, 46],
                  60: [2, 46],
                },
                { 13: 40, 15: [1, 20], 17: 39 },
                {
                  20: 42,
                  56: 41,
                  64: 43,
                  65: [1, 44],
                  72: [1, 35],
                  78: 26,
                  79: 27,
                  80: [1, 28],
                  81: [1, 29],
                  82: [1, 30],
                  83: [1, 31],
                  84: [1, 32],
                  85: [1, 34],
                  86: 33,
                },
                {
                  4: 45,
                  6: 3,
                  14: [2, 46],
                  15: [2, 46],
                  19: [2, 46],
                  29: [2, 46],
                  34: [2, 46],
                  47: [2, 46],
                  48: [2, 46],
                  51: [2, 46],
                  55: [2, 46],
                  60: [2, 46],
                },
                {
                  5: [2, 10],
                  14: [2, 10],
                  15: [2, 10],
                  18: [2, 10],
                  19: [2, 10],
                  29: [2, 10],
                  34: [2, 10],
                  39: [2, 10],
                  44: [2, 10],
                  47: [2, 10],
                  48: [2, 10],
                  51: [2, 10],
                  55: [2, 10],
                  60: [2, 10],
                },
                {
                  20: 46,
                  72: [1, 35],
                  78: 26,
                  79: 27,
                  80: [1, 28],
                  81: [1, 29],
                  82: [1, 30],
                  83: [1, 31],
                  84: [1, 32],
                  85: [1, 34],
                  86: 33,
                },
                {
                  20: 47,
                  72: [1, 35],
                  78: 26,
                  79: 27,
                  80: [1, 28],
                  81: [1, 29],
                  82: [1, 30],
                  83: [1, 31],
                  84: [1, 32],
                  85: [1, 34],
                  86: 33,
                },
                {
                  20: 48,
                  72: [1, 35],
                  78: 26,
                  79: 27,
                  80: [1, 28],
                  81: [1, 29],
                  82: [1, 30],
                  83: [1, 31],
                  84: [1, 32],
                  85: [1, 34],
                  86: 33,
                },
                {
                  20: 42,
                  56: 49,
                  64: 43,
                  65: [1, 44],
                  72: [1, 35],
                  78: 26,
                  79: 27,
                  80: [1, 28],
                  81: [1, 29],
                  82: [1, 30],
                  83: [1, 31],
                  84: [1, 32],
                  85: [1, 34],
                  86: 33,
                },
                {
                  33: [2, 78],
                  49: 50,
                  65: [2, 78],
                  72: [2, 78],
                  80: [2, 78],
                  81: [2, 78],
                  82: [2, 78],
                  83: [2, 78],
                  84: [2, 78],
                  85: [2, 78],
                },
                {
                  23: [2, 33],
                  33: [2, 33],
                  54: [2, 33],
                  65: [2, 33],
                  68: [2, 33],
                  72: [2, 33],
                  75: [2, 33],
                  80: [2, 33],
                  81: [2, 33],
                  82: [2, 33],
                  83: [2, 33],
                  84: [2, 33],
                  85: [2, 33],
                },
                {
                  23: [2, 34],
                  33: [2, 34],
                  54: [2, 34],
                  65: [2, 34],
                  68: [2, 34],
                  72: [2, 34],
                  75: [2, 34],
                  80: [2, 34],
                  81: [2, 34],
                  82: [2, 34],
                  83: [2, 34],
                  84: [2, 34],
                  85: [2, 34],
                },
                {
                  23: [2, 35],
                  33: [2, 35],
                  54: [2, 35],
                  65: [2, 35],
                  68: [2, 35],
                  72: [2, 35],
                  75: [2, 35],
                  80: [2, 35],
                  81: [2, 35],
                  82: [2, 35],
                  83: [2, 35],
                  84: [2, 35],
                  85: [2, 35],
                },
                {
                  23: [2, 36],
                  33: [2, 36],
                  54: [2, 36],
                  65: [2, 36],
                  68: [2, 36],
                  72: [2, 36],
                  75: [2, 36],
                  80: [2, 36],
                  81: [2, 36],
                  82: [2, 36],
                  83: [2, 36],
                  84: [2, 36],
                  85: [2, 36],
                },
                {
                  23: [2, 37],
                  33: [2, 37],
                  54: [2, 37],
                  65: [2, 37],
                  68: [2, 37],
                  72: [2, 37],
                  75: [2, 37],
                  80: [2, 37],
                  81: [2, 37],
                  82: [2, 37],
                  83: [2, 37],
                  84: [2, 37],
                  85: [2, 37],
                },
                {
                  23: [2, 38],
                  33: [2, 38],
                  54: [2, 38],
                  65: [2, 38],
                  68: [2, 38],
                  72: [2, 38],
                  75: [2, 38],
                  80: [2, 38],
                  81: [2, 38],
                  82: [2, 38],
                  83: [2, 38],
                  84: [2, 38],
                  85: [2, 38],
                },
                {
                  23: [2, 39],
                  33: [2, 39],
                  54: [2, 39],
                  65: [2, 39],
                  68: [2, 39],
                  72: [2, 39],
                  75: [2, 39],
                  80: [2, 39],
                  81: [2, 39],
                  82: [2, 39],
                  83: [2, 39],
                  84: [2, 39],
                  85: [2, 39],
                },
                {
                  23: [2, 43],
                  33: [2, 43],
                  54: [2, 43],
                  65: [2, 43],
                  68: [2, 43],
                  72: [2, 43],
                  75: [2, 43],
                  80: [2, 43],
                  81: [2, 43],
                  82: [2, 43],
                  83: [2, 43],
                  84: [2, 43],
                  85: [2, 43],
                  87: [1, 51],
                },
                { 72: [1, 35], 86: 52 },
                {
                  23: [2, 45],
                  33: [2, 45],
                  54: [2, 45],
                  65: [2, 45],
                  68: [2, 45],
                  72: [2, 45],
                  75: [2, 45],
                  80: [2, 45],
                  81: [2, 45],
                  82: [2, 45],
                  83: [2, 45],
                  84: [2, 45],
                  85: [2, 45],
                  87: [2, 45],
                },
                {
                  52: 53,
                  54: [2, 82],
                  65: [2, 82],
                  72: [2, 82],
                  80: [2, 82],
                  81: [2, 82],
                  82: [2, 82],
                  83: [2, 82],
                  84: [2, 82],
                  85: [2, 82],
                },
                {
                  25: 54,
                  38: 56,
                  39: [1, 58],
                  43: 57,
                  44: [1, 59],
                  45: 55,
                  47: [2, 54],
                },
                { 28: 60, 43: 61, 44: [1, 59], 47: [2, 56] },
                { 13: 63, 15: [1, 20], 18: [1, 62] },
                { 15: [2, 48], 18: [2, 48] },
                {
                  33: [2, 86],
                  57: 64,
                  65: [2, 86],
                  72: [2, 86],
                  80: [2, 86],
                  81: [2, 86],
                  82: [2, 86],
                  83: [2, 86],
                  84: [2, 86],
                  85: [2, 86],
                },
                {
                  33: [2, 40],
                  65: [2, 40],
                  72: [2, 40],
                  80: [2, 40],
                  81: [2, 40],
                  82: [2, 40],
                  83: [2, 40],
                  84: [2, 40],
                  85: [2, 40],
                },
                {
                  33: [2, 41],
                  65: [2, 41],
                  72: [2, 41],
                  80: [2, 41],
                  81: [2, 41],
                  82: [2, 41],
                  83: [2, 41],
                  84: [2, 41],
                  85: [2, 41],
                },
                {
                  20: 65,
                  72: [1, 35],
                  78: 26,
                  79: 27,
                  80: [1, 28],
                  81: [1, 29],
                  82: [1, 30],
                  83: [1, 31],
                  84: [1, 32],
                  85: [1, 34],
                  86: 33,
                },
                { 26: 66, 47: [1, 67] },
                {
                  30: 68,
                  33: [2, 58],
                  65: [2, 58],
                  72: [2, 58],
                  75: [2, 58],
                  80: [2, 58],
                  81: [2, 58],
                  82: [2, 58],
                  83: [2, 58],
                  84: [2, 58],
                  85: [2, 58],
                },
                {
                  33: [2, 64],
                  35: 69,
                  65: [2, 64],
                  72: [2, 64],
                  75: [2, 64],
                  80: [2, 64],
                  81: [2, 64],
                  82: [2, 64],
                  83: [2, 64],
                  84: [2, 64],
                  85: [2, 64],
                },
                {
                  21: 70,
                  23: [2, 50],
                  65: [2, 50],
                  72: [2, 50],
                  80: [2, 50],
                  81: [2, 50],
                  82: [2, 50],
                  83: [2, 50],
                  84: [2, 50],
                  85: [2, 50],
                },
                {
                  33: [2, 90],
                  61: 71,
                  65: [2, 90],
                  72: [2, 90],
                  80: [2, 90],
                  81: [2, 90],
                  82: [2, 90],
                  83: [2, 90],
                  84: [2, 90],
                  85: [2, 90],
                },
                {
                  20: 75,
                  33: [2, 80],
                  50: 72,
                  63: 73,
                  64: 76,
                  65: [1, 44],
                  69: 74,
                  70: 77,
                  71: 78,
                  72: [1, 79],
                  78: 26,
                  79: 27,
                  80: [1, 28],
                  81: [1, 29],
                  82: [1, 30],
                  83: [1, 31],
                  84: [1, 32],
                  85: [1, 34],
                  86: 33,
                },
                { 72: [1, 80] },
                {
                  23: [2, 42],
                  33: [2, 42],
                  54: [2, 42],
                  65: [2, 42],
                  68: [2, 42],
                  72: [2, 42],
                  75: [2, 42],
                  80: [2, 42],
                  81: [2, 42],
                  82: [2, 42],
                  83: [2, 42],
                  84: [2, 42],
                  85: [2, 42],
                  87: [1, 51],
                },
                {
                  20: 75,
                  53: 81,
                  54: [2, 84],
                  63: 82,
                  64: 76,
                  65: [1, 44],
                  69: 83,
                  70: 77,
                  71: 78,
                  72: [1, 79],
                  78: 26,
                  79: 27,
                  80: [1, 28],
                  81: [1, 29],
                  82: [1, 30],
                  83: [1, 31],
                  84: [1, 32],
                  85: [1, 34],
                  86: 33,
                },
                { 26: 84, 47: [1, 67] },
                { 47: [2, 55] },
                {
                  4: 85,
                  6: 3,
                  14: [2, 46],
                  15: [2, 46],
                  19: [2, 46],
                  29: [2, 46],
                  34: [2, 46],
                  39: [2, 46],
                  44: [2, 46],
                  47: [2, 46],
                  48: [2, 46],
                  51: [2, 46],
                  55: [2, 46],
                  60: [2, 46],
                },
                { 47: [2, 20] },
                {
                  20: 86,
                  72: [1, 35],
                  78: 26,
                  79: 27,
                  80: [1, 28],
                  81: [1, 29],
                  82: [1, 30],
                  83: [1, 31],
                  84: [1, 32],
                  85: [1, 34],
                  86: 33,
                },
                {
                  4: 87,
                  6: 3,
                  14: [2, 46],
                  15: [2, 46],
                  19: [2, 46],
                  29: [2, 46],
                  34: [2, 46],
                  47: [2, 46],
                  48: [2, 46],
                  51: [2, 46],
                  55: [2, 46],
                  60: [2, 46],
                },
                { 26: 88, 47: [1, 67] },
                { 47: [2, 57] },
                {
                  5: [2, 11],
                  14: [2, 11],
                  15: [2, 11],
                  19: [2, 11],
                  29: [2, 11],
                  34: [2, 11],
                  39: [2, 11],
                  44: [2, 11],
                  47: [2, 11],
                  48: [2, 11],
                  51: [2, 11],
                  55: [2, 11],
                  60: [2, 11],
                },
                { 15: [2, 49], 18: [2, 49] },
                {
                  20: 75,
                  33: [2, 88],
                  58: 89,
                  63: 90,
                  64: 76,
                  65: [1, 44],
                  69: 91,
                  70: 77,
                  71: 78,
                  72: [1, 79],
                  78: 26,
                  79: 27,
                  80: [1, 28],
                  81: [1, 29],
                  82: [1, 30],
                  83: [1, 31],
                  84: [1, 32],
                  85: [1, 34],
                  86: 33,
                },
                {
                  65: [2, 94],
                  66: 92,
                  68: [2, 94],
                  72: [2, 94],
                  80: [2, 94],
                  81: [2, 94],
                  82: [2, 94],
                  83: [2, 94],
                  84: [2, 94],
                  85: [2, 94],
                },
                {
                  5: [2, 25],
                  14: [2, 25],
                  15: [2, 25],
                  19: [2, 25],
                  29: [2, 25],
                  34: [2, 25],
                  39: [2, 25],
                  44: [2, 25],
                  47: [2, 25],
                  48: [2, 25],
                  51: [2, 25],
                  55: [2, 25],
                  60: [2, 25],
                },
                {
                  20: 93,
                  72: [1, 35],
                  78: 26,
                  79: 27,
                  80: [1, 28],
                  81: [1, 29],
                  82: [1, 30],
                  83: [1, 31],
                  84: [1, 32],
                  85: [1, 34],
                  86: 33,
                },
                {
                  20: 75,
                  31: 94,
                  33: [2, 60],
                  63: 95,
                  64: 76,
                  65: [1, 44],
                  69: 96,
                  70: 77,
                  71: 78,
                  72: [1, 79],
                  75: [2, 60],
                  78: 26,
                  79: 27,
                  80: [1, 28],
                  81: [1, 29],
                  82: [1, 30],
                  83: [1, 31],
                  84: [1, 32],
                  85: [1, 34],
                  86: 33,
                },
                {
                  20: 75,
                  33: [2, 66],
                  36: 97,
                  63: 98,
                  64: 76,
                  65: [1, 44],
                  69: 99,
                  70: 77,
                  71: 78,
                  72: [1, 79],
                  75: [2, 66],
                  78: 26,
                  79: 27,
                  80: [1, 28],
                  81: [1, 29],
                  82: [1, 30],
                  83: [1, 31],
                  84: [1, 32],
                  85: [1, 34],
                  86: 33,
                },
                {
                  20: 75,
                  22: 100,
                  23: [2, 52],
                  63: 101,
                  64: 76,
                  65: [1, 44],
                  69: 102,
                  70: 77,
                  71: 78,
                  72: [1, 79],
                  78: 26,
                  79: 27,
                  80: [1, 28],
                  81: [1, 29],
                  82: [1, 30],
                  83: [1, 31],
                  84: [1, 32],
                  85: [1, 34],
                  86: 33,
                },
                {
                  20: 75,
                  33: [2, 92],
                  62: 103,
                  63: 104,
                  64: 76,
                  65: [1, 44],
                  69: 105,
                  70: 77,
                  71: 78,
                  72: [1, 79],
                  78: 26,
                  79: 27,
                  80: [1, 28],
                  81: [1, 29],
                  82: [1, 30],
                  83: [1, 31],
                  84: [1, 32],
                  85: [1, 34],
                  86: 33,
                },
                { 33: [1, 106] },
                {
                  33: [2, 79],
                  65: [2, 79],
                  72: [2, 79],
                  80: [2, 79],
                  81: [2, 79],
                  82: [2, 79],
                  83: [2, 79],
                  84: [2, 79],
                  85: [2, 79],
                },
                { 33: [2, 81] },
                {
                  23: [2, 27],
                  33: [2, 27],
                  54: [2, 27],
                  65: [2, 27],
                  68: [2, 27],
                  72: [2, 27],
                  75: [2, 27],
                  80: [2, 27],
                  81: [2, 27],
                  82: [2, 27],
                  83: [2, 27],
                  84: [2, 27],
                  85: [2, 27],
                },
                {
                  23: [2, 28],
                  33: [2, 28],
                  54: [2, 28],
                  65: [2, 28],
                  68: [2, 28],
                  72: [2, 28],
                  75: [2, 28],
                  80: [2, 28],
                  81: [2, 28],
                  82: [2, 28],
                  83: [2, 28],
                  84: [2, 28],
                  85: [2, 28],
                },
                {
                  23: [2, 30],
                  33: [2, 30],
                  54: [2, 30],
                  68: [2, 30],
                  71: 107,
                  72: [1, 108],
                  75: [2, 30],
                },
                {
                  23: [2, 98],
                  33: [2, 98],
                  54: [2, 98],
                  68: [2, 98],
                  72: [2, 98],
                  75: [2, 98],
                },
                {
                  23: [2, 45],
                  33: [2, 45],
                  54: [2, 45],
                  65: [2, 45],
                  68: [2, 45],
                  72: [2, 45],
                  73: [1, 109],
                  75: [2, 45],
                  80: [2, 45],
                  81: [2, 45],
                  82: [2, 45],
                  83: [2, 45],
                  84: [2, 45],
                  85: [2, 45],
                  87: [2, 45],
                },
                {
                  23: [2, 44],
                  33: [2, 44],
                  54: [2, 44],
                  65: [2, 44],
                  68: [2, 44],
                  72: [2, 44],
                  75: [2, 44],
                  80: [2, 44],
                  81: [2, 44],
                  82: [2, 44],
                  83: [2, 44],
                  84: [2, 44],
                  85: [2, 44],
                  87: [2, 44],
                },
                { 54: [1, 110] },
                {
                  54: [2, 83],
                  65: [2, 83],
                  72: [2, 83],
                  80: [2, 83],
                  81: [2, 83],
                  82: [2, 83],
                  83: [2, 83],
                  84: [2, 83],
                  85: [2, 83],
                },
                { 54: [2, 85] },
                {
                  5: [2, 13],
                  14: [2, 13],
                  15: [2, 13],
                  19: [2, 13],
                  29: [2, 13],
                  34: [2, 13],
                  39: [2, 13],
                  44: [2, 13],
                  47: [2, 13],
                  48: [2, 13],
                  51: [2, 13],
                  55: [2, 13],
                  60: [2, 13],
                },
                {
                  38: 56,
                  39: [1, 58],
                  43: 57,
                  44: [1, 59],
                  45: 112,
                  46: 111,
                  47: [2, 76],
                },
                {
                  33: [2, 70],
                  40: 113,
                  65: [2, 70],
                  72: [2, 70],
                  75: [2, 70],
                  80: [2, 70],
                  81: [2, 70],
                  82: [2, 70],
                  83: [2, 70],
                  84: [2, 70],
                  85: [2, 70],
                },
                { 47: [2, 18] },
                {
                  5: [2, 14],
                  14: [2, 14],
                  15: [2, 14],
                  19: [2, 14],
                  29: [2, 14],
                  34: [2, 14],
                  39: [2, 14],
                  44: [2, 14],
                  47: [2, 14],
                  48: [2, 14],
                  51: [2, 14],
                  55: [2, 14],
                  60: [2, 14],
                },
                { 33: [1, 114] },
                {
                  33: [2, 87],
                  65: [2, 87],
                  72: [2, 87],
                  80: [2, 87],
                  81: [2, 87],
                  82: [2, 87],
                  83: [2, 87],
                  84: [2, 87],
                  85: [2, 87],
                },
                { 33: [2, 89] },
                {
                  20: 75,
                  63: 116,
                  64: 76,
                  65: [1, 44],
                  67: 115,
                  68: [2, 96],
                  69: 117,
                  70: 77,
                  71: 78,
                  72: [1, 79],
                  78: 26,
                  79: 27,
                  80: [1, 28],
                  81: [1, 29],
                  82: [1, 30],
                  83: [1, 31],
                  84: [1, 32],
                  85: [1, 34],
                  86: 33,
                },
                { 33: [1, 118] },
                { 32: 119, 33: [2, 62], 74: 120, 75: [1, 121] },
                {
                  33: [2, 59],
                  65: [2, 59],
                  72: [2, 59],
                  75: [2, 59],
                  80: [2, 59],
                  81: [2, 59],
                  82: [2, 59],
                  83: [2, 59],
                  84: [2, 59],
                  85: [2, 59],
                },
                { 33: [2, 61], 75: [2, 61] },
                { 33: [2, 68], 37: 122, 74: 123, 75: [1, 121] },
                {
                  33: [2, 65],
                  65: [2, 65],
                  72: [2, 65],
                  75: [2, 65],
                  80: [2, 65],
                  81: [2, 65],
                  82: [2, 65],
                  83: [2, 65],
                  84: [2, 65],
                  85: [2, 65],
                },
                { 33: [2, 67], 75: [2, 67] },
                { 23: [1, 124] },
                {
                  23: [2, 51],
                  65: [2, 51],
                  72: [2, 51],
                  80: [2, 51],
                  81: [2, 51],
                  82: [2, 51],
                  83: [2, 51],
                  84: [2, 51],
                  85: [2, 51],
                },
                { 23: [2, 53] },
                { 33: [1, 125] },
                {
                  33: [2, 91],
                  65: [2, 91],
                  72: [2, 91],
                  80: [2, 91],
                  81: [2, 91],
                  82: [2, 91],
                  83: [2, 91],
                  84: [2, 91],
                  85: [2, 91],
                },
                { 33: [2, 93] },
                {
                  5: [2, 22],
                  14: [2, 22],
                  15: [2, 22],
                  19: [2, 22],
                  29: [2, 22],
                  34: [2, 22],
                  39: [2, 22],
                  44: [2, 22],
                  47: [2, 22],
                  48: [2, 22],
                  51: [2, 22],
                  55: [2, 22],
                  60: [2, 22],
                },
                {
                  23: [2, 99],
                  33: [2, 99],
                  54: [2, 99],
                  68: [2, 99],
                  72: [2, 99],
                  75: [2, 99],
                },
                { 73: [1, 109] },
                {
                  20: 75,
                  63: 126,
                  64: 76,
                  65: [1, 44],
                  72: [1, 35],
                  78: 26,
                  79: 27,
                  80: [1, 28],
                  81: [1, 29],
                  82: [1, 30],
                  83: [1, 31],
                  84: [1, 32],
                  85: [1, 34],
                  86: 33,
                },
                {
                  5: [2, 23],
                  14: [2, 23],
                  15: [2, 23],
                  19: [2, 23],
                  29: [2, 23],
                  34: [2, 23],
                  39: [2, 23],
                  44: [2, 23],
                  47: [2, 23],
                  48: [2, 23],
                  51: [2, 23],
                  55: [2, 23],
                  60: [2, 23],
                },
                { 47: [2, 19] },
                { 47: [2, 77] },
                {
                  20: 75,
                  33: [2, 72],
                  41: 127,
                  63: 128,
                  64: 76,
                  65: [1, 44],
                  69: 129,
                  70: 77,
                  71: 78,
                  72: [1, 79],
                  75: [2, 72],
                  78: 26,
                  79: 27,
                  80: [1, 28],
                  81: [1, 29],
                  82: [1, 30],
                  83: [1, 31],
                  84: [1, 32],
                  85: [1, 34],
                  86: 33,
                },
                {
                  5: [2, 24],
                  14: [2, 24],
                  15: [2, 24],
                  19: [2, 24],
                  29: [2, 24],
                  34: [2, 24],
                  39: [2, 24],
                  44: [2, 24],
                  47: [2, 24],
                  48: [2, 24],
                  51: [2, 24],
                  55: [2, 24],
                  60: [2, 24],
                },
                { 68: [1, 130] },
                {
                  65: [2, 95],
                  68: [2, 95],
                  72: [2, 95],
                  80: [2, 95],
                  81: [2, 95],
                  82: [2, 95],
                  83: [2, 95],
                  84: [2, 95],
                  85: [2, 95],
                },
                { 68: [2, 97] },
                {
                  5: [2, 21],
                  14: [2, 21],
                  15: [2, 21],
                  19: [2, 21],
                  29: [2, 21],
                  34: [2, 21],
                  39: [2, 21],
                  44: [2, 21],
                  47: [2, 21],
                  48: [2, 21],
                  51: [2, 21],
                  55: [2, 21],
                  60: [2, 21],
                },
                { 33: [1, 131] },
                { 33: [2, 63] },
                { 72: [1, 133], 76: 132 },
                { 33: [1, 134] },
                { 33: [2, 69] },
                { 15: [2, 12] },
                {
                  14: [2, 26],
                  15: [2, 26],
                  19: [2, 26],
                  29: [2, 26],
                  34: [2, 26],
                  47: [2, 26],
                  48: [2, 26],
                  51: [2, 26],
                  55: [2, 26],
                  60: [2, 26],
                },
                {
                  23: [2, 31],
                  33: [2, 31],
                  54: [2, 31],
                  68: [2, 31],
                  72: [2, 31],
                  75: [2, 31],
                },
                { 33: [2, 74], 42: 135, 74: 136, 75: [1, 121] },
                {
                  33: [2, 71],
                  65: [2, 71],
                  72: [2, 71],
                  75: [2, 71],
                  80: [2, 71],
                  81: [2, 71],
                  82: [2, 71],
                  83: [2, 71],
                  84: [2, 71],
                  85: [2, 71],
                },
                { 33: [2, 73], 75: [2, 73] },
                {
                  23: [2, 29],
                  33: [2, 29],
                  54: [2, 29],
                  65: [2, 29],
                  68: [2, 29],
                  72: [2, 29],
                  75: [2, 29],
                  80: [2, 29],
                  81: [2, 29],
                  82: [2, 29],
                  83: [2, 29],
                  84: [2, 29],
                  85: [2, 29],
                },
                {
                  14: [2, 15],
                  15: [2, 15],
                  19: [2, 15],
                  29: [2, 15],
                  34: [2, 15],
                  39: [2, 15],
                  44: [2, 15],
                  47: [2, 15],
                  48: [2, 15],
                  51: [2, 15],
                  55: [2, 15],
                  60: [2, 15],
                },
                { 72: [1, 138], 77: [1, 137] },
                { 72: [2, 100], 77: [2, 100] },
                {
                  14: [2, 16],
                  15: [2, 16],
                  19: [2, 16],
                  29: [2, 16],
                  34: [2, 16],
                  44: [2, 16],
                  47: [2, 16],
                  48: [2, 16],
                  51: [2, 16],
                  55: [2, 16],
                  60: [2, 16],
                },
                { 33: [1, 139] },
                { 33: [2, 75] },
                { 33: [2, 32] },
                { 72: [2, 101], 77: [2, 101] },
                {
                  14: [2, 17],
                  15: [2, 17],
                  19: [2, 17],
                  29: [2, 17],
                  34: [2, 17],
                  39: [2, 17],
                  44: [2, 17],
                  47: [2, 17],
                  48: [2, 17],
                  51: [2, 17],
                  55: [2, 17],
                  60: [2, 17],
                },
              ],
              defaultActions: {
                4: [2, 1],
                55: [2, 55],
                57: [2, 20],
                61: [2, 57],
                74: [2, 81],
                83: [2, 85],
                87: [2, 18],
                91: [2, 89],
                102: [2, 53],
                105: [2, 93],
                111: [2, 19],
                112: [2, 77],
                117: [2, 97],
                120: [2, 63],
                123: [2, 69],
                124: [2, 12],
                136: [2, 75],
                137: [2, 32],
              },
              parseError: function (e, t) {
                throw new Error(e);
              },
              parse: function (e) {
                function t() {
                  var e;
                  return (
                    (e = n.lexer.lex() || 1),
                    "number" != typeof e && (e = n.symbols_[e] || e),
                    e
                  );
                }
                var n = this,
                  i = [0],
                  r = [null],
                  o = [],
                  s = this.table,
                  a = "",
                  l = 0,
                  c = 0,
                  u = 0;
                this.lexer.setInput(e),
                  (this.lexer.yy = this.yy),
                  (this.yy.lexer = this.lexer),
                  (this.yy.parser = this),
                  "undefined" == typeof this.lexer.yylloc &&
                    (this.lexer.yylloc = {});
                var p = this.lexer.yylloc;
                o.push(p);
                var d = this.lexer.options && this.lexer.options.ranges;
                "function" == typeof this.yy.parseError &&
                  (this.parseError = this.yy.parseError);
                for (var h, f, v, g, m, y, b, k, w, x = {}; ; ) {
                  if (
                    ((v = i[i.length - 1]),
                    this.defaultActions[v]
                      ? (g = this.defaultActions[v])
                      : ((null === h || "undefined" == typeof h) && (h = t()),
                        (g = s[v] && s[v][h])),
                    "undefined" == typeof g || !g.length || !g[0])
                  ) {
                    var S = "";
                    if (!u) {
                      w = [];
                      for (y in s[v])
                        this.terminals_[y] &&
                          y > 2 &&
                          w.push("'" + this.terminals_[y] + "'");
                      (S = this.lexer.showPosition
                        ? "Parse error on line " +
                          (l + 1) +
                          ":\n" +
                          this.lexer.showPosition() +
                          "\nExpecting " +
                          w.join(", ") +
                          ", got '" +
                          (this.terminals_[h] || h) +
                          "'"
                        : "Parse error on line " +
                          (l + 1) +
                          ": Unexpected " +
                          (1 == h
                            ? "end of input"
                            : "'" + (this.terminals_[h] || h) + "'")),
                        this.parseError(S, {
                          text: this.lexer.match,
                          token: this.terminals_[h] || h,
                          line: this.lexer.yylineno,
                          loc: p,
                          expected: w,
                        });
                    }
                  }
                  if (g[0] instanceof Array && g.length > 1)
                    throw new Error(
                      "Parse Error: multiple actions possible at state: " +
                        v +
                        ", token: " +
                        h
                    );
                  switch (g[0]) {
                    case 1:
                      i.push(h),
                        r.push(this.lexer.yytext),
                        o.push(this.lexer.yylloc),
                        i.push(g[1]),
                        (h = null),
                        f
                          ? ((h = f), (f = null))
                          : ((c = this.lexer.yyleng),
                            (a = this.lexer.yytext),
                            (l = this.lexer.yylineno),
                            (p = this.lexer.yylloc),
                            u > 0 && u--);
                      break;
                    case 2:
                      if (
                        ((b = this.productions_[g[1]][1]),
                        (x.$ = r[r.length - b]),
                        (x._$ = {
                          first_line: o[o.length - (b || 1)].first_line,
                          last_line: o[o.length - 1].last_line,
                          first_column: o[o.length - (b || 1)].first_column,
                          last_column: o[o.length - 1].last_column,
                        }),
                        d &&
                          (x._$.range = [
                            o[o.length - (b || 1)].range[0],
                            o[o.length - 1].range[1],
                          ]),
                        (m = this.performAction.call(
                          x,
                          a,
                          c,
                          l,
                          this.yy,
                          g[1],
                          r,
                          o
                        )),
                        "undefined" != typeof m)
                      )
                        return m;
                      b &&
                        ((i = i.slice(0, -1 * b * 2)),
                        (r = r.slice(0, -1 * b)),
                        (o = o.slice(0, -1 * b))),
                        i.push(this.productions_[g[1]][0]),
                        r.push(x.$),
                        o.push(x._$),
                        (k = s[i[i.length - 2]][i[i.length - 1]]),
                        i.push(k);
                      break;
                    case 3:
                      return !0;
                  }
                }
                return !0;
              },
            },
            n = (function () {
              var e = {
                EOF: 1,
                parseError: function (e, t) {
                  if (!this.yy.parser) throw new Error(e);
                  this.yy.parser.parseError(e, t);
                },
                setInput: function (e) {
                  return (
                    (this._input = e),
                    (this._more = this._less = this.done = !1),
                    (this.yylineno = this.yyleng = 0),
                    (this.yytext = this.matched = this.match = ""),
                    (this.conditionStack = ["INITIAL"]),
                    (this.yylloc = {
                      first_line: 1,
                      first_column: 0,
                      last_line: 1,
                      last_column: 0,
                    }),
                    this.options.ranges && (this.yylloc.range = [0, 0]),
                    (this.offset = 0),
                    this
                  );
                },
                input: function () {
                  var e = this._input[0];
                  (this.yytext += e),
                    this.yyleng++,
                    this.offset++,
                    (this.match += e),
                    (this.matched += e);
                  var t = e.match(/(?:\r\n?|\n).*/g);
                  return (
                    t
                      ? (this.yylineno++, this.yylloc.last_line++)
                      : this.yylloc.last_column++,
                    this.options.ranges && this.yylloc.range[1]++,
                    (this._input = this._input.slice(1)),
                    e
                  );
                },
                unput: function (e) {
                  var t = e.length,
                    n = e.split(/(?:\r\n?|\n)/g);
                  (this._input = e + this._input),
                    (this.yytext = this.yytext.substr(
                      0,
                      this.yytext.length - t - 1
                    )),
                    (this.offset -= t);
                  var i = this.match.split(/(?:\r\n?|\n)/g);
                  (this.match = this.match.substr(0, this.match.length - 1)),
                    (this.matched = this.matched.substr(
                      0,
                      this.matched.length - 1
                    )),
                    n.length - 1 && (this.yylineno -= n.length - 1);
                  var r = this.yylloc.range;
                  return (
                    (this.yylloc = {
                      first_line: this.yylloc.first_line,
                      last_line: this.yylineno + 1,
                      first_column: this.yylloc.first_column,
                      last_column: n
                        ? (n.length === i.length
                            ? this.yylloc.first_column
                            : 0) +
                          i[i.length - n.length].length -
                          n[0].length
                        : this.yylloc.first_column - t,
                    }),
                    this.options.ranges &&
                      (this.yylloc.range = [r[0], r[0] + this.yyleng - t]),
                    this
                  );
                },
                more: function () {
                  return (this._more = !0), this;
                },
                less: function (e) {
                  this.unput(this.match.slice(e));
                },
                pastInput: function () {
                  var e = this.matched.substr(
                    0,
                    this.matched.length - this.match.length
                  );
                  return (
                    (e.length > 20 ? "..." : "") +
                    e.substr(-20).replace(/\n/g, "")
                  );
                },
                upcomingInput: function () {
                  var e = this.match;
                  return (
                    e.length < 20 &&
                      (e += this._input.substr(0, 20 - e.length)),
                    (e.substr(0, 20) + (e.length > 20 ? "..." : "")).replace(
                      /\n/g,
                      ""
                    )
                  );
                },
                showPosition: function () {
                  var e = this.pastInput(),
                    t = new Array(e.length + 1).join("-");
                  return e + this.upcomingInput() + "\n" + t + "^";
                },
                next: function () {
                  if (this.done) return this.EOF;
                  this._input || (this.done = !0);
                  var e, t, n, i, r;
                  this._more || ((this.yytext = ""), (this.match = ""));
                  for (
                    var o = this._currentRules(), s = 0;
                    s < o.length &&
                    ((n = this._input.match(this.rules[o[s]])),
                    !n ||
                      (t && !(n[0].length > t[0].length)) ||
                      ((t = n), (i = s), this.options.flex));
                    s++
                  );
                  return t
                    ? ((r = t[0].match(/(?:\r\n?|\n).*/g)),
                      r && (this.yylineno += r.length),
                      (this.yylloc = {
                        first_line: this.yylloc.last_line,
                        last_line: this.yylineno + 1,
                        first_column: this.yylloc.last_column,
                        last_column: r
                          ? r[r.length - 1].length -
                            r[r.length - 1].match(/\r?\n?/)[0].length
                          : this.yylloc.last_column + t[0].length,
                      }),
                      (this.yytext += t[0]),
                      (this.match += t[0]),
                      (this.matches = t),
                      (this.yyleng = this.yytext.length),
                      this.options.ranges &&
                        (this.yylloc.range = [
                          this.offset,
                          (this.offset += this.yyleng),
                        ]),
                      (this._more = !1),
                      (this._input = this._input.slice(t[0].length)),
                      (this.matched += t[0]),
                      (e = this.performAction.call(
                        this,
                        this.yy,
                        this,
                        o[i],
                        this.conditionStack[this.conditionStack.length - 1]
                      )),
                      this.done && this._input && (this.done = !1),
                      e ? e : void 0)
                    : "" === this._input
                    ? this.EOF
                    : this.parseError(
                        "Lexical error on line " +
                          (this.yylineno + 1) +
                          ". Unrecognized text.\n" +
                          this.showPosition(),
                        { text: "", token: null, line: this.yylineno }
                      );
                },
                lex: function () {
                  var e = this.next();
                  return "undefined" != typeof e ? e : this.lex();
                },
                begin: function (e) {
                  this.conditionStack.push(e);
                },
                popState: function () {
                  return this.conditionStack.pop();
                },
                _currentRules: function () {
                  return this.conditions[
                    this.conditionStack[this.conditionStack.length - 1]
                  ].rules;
                },
                topState: function () {
                  return this.conditionStack[this.conditionStack.length - 2];
                },
                pushState: function (e) {
                  this.begin(e);
                },
              };
              return (
                (e.options = {}),
                (e.performAction = function (e, t, n, i) {
                  function r(e, n) {
                    return (t.yytext = t.yytext.substr(e, t.yyleng - n));
                  }
                  switch (n) {
                    case 0:
                      if (
                        ("\\\\" === t.yytext.slice(-2)
                          ? (r(0, 1), this.begin("mu"))
                          : "\\" === t.yytext.slice(-1)
                          ? (r(0, 1), this.begin("emu"))
                          : this.begin("mu"),
                        t.yytext)
                      )
                        return 15;
                      break;
                    case 1:
                      return 15;
                    case 2:
                      return this.popState(), 15;
                    case 3:
                      return this.begin("raw"), 15;
                    case 4:
                      return (
                        this.popState(),
                        "raw" ===
                        this.conditionStack[this.conditionStack.length - 1]
                          ? 15
                          : ((t.yytext = t.yytext.substr(5, t.yyleng - 9)),
                            "END_RAW_BLOCK")
                      );
                    case 5:
                      return 15;
                    case 6:
                      return this.popState(), 14;
                    case 7:
                      return 65;
                    case 8:
                      return 68;
                    case 9:
                      return 19;
                    case 10:
                      return this.popState(), this.begin("raw"), 23;
                    case 11:
                      return 55;
                    case 12:
                      return 60;
                    case 13:
                      return 29;
                    case 14:
                      return 47;
                    case 15:
                      return this.popState(), 44;
                    case 16:
                      return this.popState(), 44;
                    case 17:
                      return 34;
                    case 18:
                      return 39;
                    case 19:
                      return 51;
                    case 20:
                      return 48;
                    case 21:
                      this.unput(t.yytext), this.popState(), this.begin("com");
                      break;
                    case 22:
                      return this.popState(), 14;
                    case 23:
                      return 48;
                    case 24:
                      return 73;
                    case 25:
                      return 72;
                    case 26:
                      return 72;
                    case 27:
                      return 87;
                    case 28:
                      break;
                    case 29:
                      return this.popState(), 54;
                    case 30:
                      return this.popState(), 33;
                    case 31:
                      return (t.yytext = r(1, 2).replace(/\\"/g, '"')), 80;
                    case 32:
                      return (t.yytext = r(1, 2).replace(/\\'/g, "'")), 80;
                    case 33:
                      return 85;
                    case 34:
                      return 82;
                    case 35:
                      return 82;
                    case 36:
                      return 83;
                    case 37:
                      return 84;
                    case 38:
                      return 81;
                    case 39:
                      return 75;
                    case 40:
                      return 77;
                    case 41:
                      return 72;
                    case 42:
                      return (
                        (t.yytext = t.yytext.replace(/\\([\\\]])/g, "$1")), 72
                      );
                    case 43:
                      return "INVALID";
                    case 44:
                      return 5;
                  }
                }),
                (e.rules = [
                  /^(?:[^\x00]*?(?=(\{\{)))/,
                  /^(?:[^\x00]+)/,
                  /^(?:[^\x00]{2,}?(?=(\{\{|\\\{\{|\\\\\{\{|$)))/,
                  /^(?:\{\{\{\{(?=[^\/]))/,
                  /^(?:\{\{\{\{\/[^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=[=}\s\/.])\}\}\}\})/,
                  /^(?:[^\x00]*?(?=(\{\{\{\{)))/,
                  /^(?:[\s\S]*?--(~)?\}\})/,
                  /^(?:\()/,
                  /^(?:\))/,
                  /^(?:\{\{\{\{)/,
                  /^(?:\}\}\}\})/,
                  /^(?:\{\{(~)?>)/,
                  /^(?:\{\{(~)?#>)/,
                  /^(?:\{\{(~)?#\*?)/,
                  /^(?:\{\{(~)?\/)/,
                  /^(?:\{\{(~)?\^\s*(~)?\}\})/,
                  /^(?:\{\{(~)?\s*else\s*(~)?\}\})/,
                  /^(?:\{\{(~)?\^)/,
                  /^(?:\{\{(~)?\s*else\b)/,
                  /^(?:\{\{(~)?\{)/,
                  /^(?:\{\{(~)?&)/,
                  /^(?:\{\{(~)?!--)/,
                  /^(?:\{\{(~)?![\s\S]*?\}\})/,
                  /^(?:\{\{(~)?\*?)/,
                  /^(?:=)/,
                  /^(?:\.\.)/,
                  /^(?:\.(?=([=~}\s\/.)|])))/,
                  /^(?:[\/.])/,
                  /^(?:\s+)/,
                  /^(?:\}(~)?\}\})/,
                  /^(?:(~)?\}\})/,
                  /^(?:"(\\["]|[^"])*")/,
                  /^(?:'(\\[']|[^'])*')/,
                  /^(?:@)/,
                  /^(?:true(?=([~}\s)])))/,
                  /^(?:false(?=([~}\s)])))/,
                  /^(?:undefined(?=([~}\s)])))/,
                  /^(?:null(?=([~}\s)])))/,
                  /^(?:-?[0-9]+(?:\.[0-9]+)?(?=([~}\s)])))/,
                  /^(?:as\s+\|)/,
                  /^(?:\|)/,
                  /^(?:([^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=([=~}\s\/.)|]))))/,
                  /^(?:\[(\\\]|[^\]])*\])/,
                  /^(?:.)/,
                  /^(?:$)/,
                ]),
                (e.conditions = {
                  mu: {
                    rules: [
                      7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
                      22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35,
                      36, 37, 38, 39, 40, 41, 42, 43, 44,
                    ],
                    inclusive: !1,
                  },
                  emu: { rules: [2], inclusive: !1 },
                  com: { rules: [6], inclusive: !1 },
                  raw: { rules: [3, 4, 5], inclusive: !1 },
                  INITIAL: { rules: [0, 1, 44], inclusive: !0 },
                }),
                e
              );
            })();
          return (t.lexer = n), (e.prototype = t), (t.Parser = e), new e();
        })();
        (t.__esModule = !0), (t.default = i);
      },
      function (e, t, n) {
        "use strict";
        function i() {
          var e =
            arguments.length <= 0 || void 0 === arguments[0]
              ? {}
              : arguments[0];
          this.options = e;
        }
        function r(e, t, n) {
          void 0 === t && (t = e.length);
          var i = e[t - 1],
            r = e[t - 2];
          return i
            ? "ContentStatement" === i.type
              ? (r || !n ? /\r?\n\s*?$/ : /(^|\r?\n)\s*?$/).test(i.original)
              : void 0
            : n;
        }
        function o(e, t, n) {
          void 0 === t && (t = -1);
          var i = e[t + 1],
            r = e[t + 2];
          return i
            ? "ContentStatement" === i.type
              ? (r || !n ? /^\s*?\r?\n/ : /^\s*?(\r?\n|$)/).test(i.original)
              : void 0
            : n;
        }
        function s(e, t, n) {
          var i = e[null == t ? 0 : t + 1];
          if (i && "ContentStatement" === i.type && (n || !i.rightStripped)) {
            var r = i.value;
            (i.value = i.value.replace(n ? /^\s+/ : /^[ \t]*\r?\n?/, "")),
              (i.rightStripped = i.value !== r);
          }
        }
        function a(e, t, n) {
          var i = e[null == t ? e.length - 1 : t - 1];
          if (i && "ContentStatement" === i.type && (n || !i.leftStripped)) {
            var r = i.value;
            return (
              (i.value = i.value.replace(n ? /\s+$/ : /[ \t]+$/, "")),
              (i.leftStripped = i.value !== r),
              i.leftStripped
            );
          }
        }
        var l = n(8).default;
        t.__esModule = !0;
        var c = n(6),
          u = l(c);
        (i.prototype = new u.default()),
          (i.prototype.Program = function (e) {
            var t = !this.options.ignoreStandalone,
              n = !this.isRootSeen;
            this.isRootSeen = !0;
            for (var i = e.body, l = 0, c = i.length; c > l; l++) {
              var u = i[l],
                p = this.accept(u);
              if (p) {
                var d = r(i, l, n),
                  h = o(i, l, n),
                  f = p.openStandalone && d,
                  v = p.closeStandalone && h,
                  g = p.inlineStandalone && d && h;
                p.close && s(i, l, !0),
                  p.open && a(i, l, !0),
                  t &&
                    g &&
                    (s(i, l),
                    a(i, l) &&
                      "PartialStatement" === u.type &&
                      (u.indent = /([ \t]+$)/.exec(i[l - 1].original)[1])),
                  t && f && (s((u.program || u.inverse).body), a(i, l)),
                  t && v && (s(i, l), a((u.inverse || u.program).body));
              }
            }
            return e;
          }),
          (i.prototype.BlockStatement =
            i.prototype.DecoratorBlock =
            i.prototype.PartialBlockStatement =
              function (e) {
                this.accept(e.program), this.accept(e.inverse);
                var t = e.program || e.inverse,
                  n = e.program && e.inverse,
                  i = n,
                  l = n;
                if (n && n.chained)
                  for (i = n.body[0].program; l.chained; )
                    l = l.body[l.body.length - 1].program;
                var c = {
                  open: e.openStrip.open,
                  close: e.closeStrip.close,
                  openStandalone: o(t.body),
                  closeStandalone: r((i || t).body),
                };
                if ((e.openStrip.close && s(t.body, null, !0), n)) {
                  var u = e.inverseStrip;
                  u.open && a(t.body, null, !0),
                    u.close && s(i.body, null, !0),
                    e.closeStrip.open && a(l.body, null, !0),
                    !this.options.ignoreStandalone &&
                      r(t.body) &&
                      o(i.body) &&
                      (a(t.body), s(i.body));
                } else e.closeStrip.open && a(t.body, null, !0);
                return c;
              }),
          (i.prototype.Decorator = i.prototype.MustacheStatement =
            function (e) {
              return e.strip;
            }),
          (i.prototype.PartialStatement = i.prototype.CommentStatement =
            function (e) {
              var t = e.strip || {};
              return { inlineStandalone: !0, open: t.open, close: t.close };
            }),
          (t.default = i),
          (e.exports = t.default);
      },
      function (e, t, n) {
        "use strict";
        function i(e, t) {
          if (((t = t.path ? t.path.original : t), e.path.original !== t)) {
            var n = { loc: e.path.loc };
            throw new g.default(e.path.original + " doesn't match " + t, n);
          }
        }
        function r(e, t) {
          (this.source = e),
            (this.start = { line: t.first_line, column: t.first_column }),
            (this.end = { line: t.last_line, column: t.last_column });
        }
        function o(e) {
          return /^\[.*\]$/.test(e) ? e.substr(1, e.length - 2) : e;
        }
        function s(e, t) {
          return {
            open: "~" === e.charAt(2),
            close: "~" === t.charAt(t.length - 3),
          };
        }
        function a(e) {
          return e.replace(/^\{\{~?\!-?-?/, "").replace(/-?-?~?\}\}$/, "");
        }
        function l(e, t, n) {
          n = this.locInfo(n);
          for (
            var i = e ? "@" : "", r = [], o = 0, s = "", a = 0, l = t.length;
            l > a;
            a++
          ) {
            var c = t[a].part,
              u = t[a].original !== c;
            if (
              ((i += (t[a].separator || "") + c),
              u || (".." !== c && "." !== c && "this" !== c))
            )
              r.push(c);
            else {
              if (r.length > 0)
                throw new g.default("Invalid path: " + i, { loc: n });
              ".." === c && (o++, (s += "../"));
            }
          }
          return {
            type: "PathExpression",
            data: e,
            depth: o,
            parts: r,
            original: i,
            loc: n,
          };
        }
        function c(e, t, n, i, r, o) {
          var s = i.charAt(3) || i.charAt(2),
            a = "{" !== s && "&" !== s,
            l = /\*/.test(i);
          return {
            type: l ? "Decorator" : "MustacheStatement",
            path: e,
            params: t,
            hash: n,
            escaped: a,
            strip: r,
            loc: this.locInfo(o),
          };
        }
        function u(e, t, n, r) {
          i(e, n), (r = this.locInfo(r));
          var o = { type: "Program", body: t, strip: {}, loc: r };
          return {
            type: "BlockStatement",
            path: e.path,
            params: e.params,
            hash: e.hash,
            program: o,
            openStrip: {},
            inverseStrip: {},
            closeStrip: {},
            loc: r,
          };
        }
        function p(e, t, n, r, o, s) {
          r && r.path && i(e, r);
          var a = /\*/.test(e.open);
          t.blockParams = e.blockParams;
          var l = void 0,
            c = void 0;
          if (n) {
            if (a)
              throw new g.default("Unexpected inverse block on decorator", n);
            n.chain && (n.program.body[0].closeStrip = r.strip),
              (c = n.strip),
              (l = n.program);
          }
          return (
            o && ((o = l), (l = t), (t = o)),
            {
              type: a ? "DecoratorBlock" : "BlockStatement",
              path: e.path,
              params: e.params,
              hash: e.hash,
              program: t,
              inverse: l,
              openStrip: e.strip,
              inverseStrip: c,
              closeStrip: r && r.strip,
              loc: this.locInfo(s),
            }
          );
        }
        function d(e, t) {
          if (!t && e.length) {
            var n = e[0].loc,
              i = e[e.length - 1].loc;
            n &&
              i &&
              (t = {
                source: n.source,
                start: { line: n.start.line, column: n.start.column },
                end: { line: i.end.line, column: i.end.column },
              });
          }
          return { type: "Program", body: e, strip: {}, loc: t };
        }
        function h(e, t, n, r) {
          return (
            i(e, n),
            {
              type: "PartialBlockStatement",
              name: e.path,
              params: e.params,
              hash: e.hash,
              program: t,
              openStrip: e.strip,
              closeStrip: n && n.strip,
              loc: this.locInfo(r),
            }
          );
        }
        var f = n(8).default;
        (t.__esModule = !0),
          (t.SourceLocation = r),
          (t.id = o),
          (t.stripFlags = s),
          (t.stripComment = a),
          (t.preparePath = l),
          (t.prepareMustache = c),
          (t.prepareRawBlock = u),
          (t.prepareBlock = p),
          (t.prepareProgram = d),
          (t.preparePartialBlock = h);
        var v = n(12),
          g = f(v);
      },
      function (e, t, n) {
        "use strict";
        function i(e, t, n) {
          if (o.isArray(e)) {
            for (var i = [], r = 0, s = e.length; s > r; r++)
              i.push(t.wrap(e[r], n));
            return i;
          }
          return "boolean" == typeof e || "number" == typeof e ? e + "" : e;
        }
        function r(e) {
          (this.srcFile = e), (this.source = []);
        }
        t.__esModule = !0;
        var o = n(13),
          s = void 0;
        try {
        } catch (e) {}
        s ||
          ((s = function (e, t, n, i) {
            (this.src = ""), i && this.add(i);
          }),
          (s.prototype = {
            add: function (e) {
              o.isArray(e) && (e = e.join("")), (this.src += e);
            },
            prepend: function (e) {
              o.isArray(e) && (e = e.join("")), (this.src = e + this.src);
            },
            toStringWithSourceMap: function () {
              return { code: this.toString() };
            },
            toString: function () {
              return this.src;
            },
          })),
          (r.prototype = {
            isEmpty: function () {
              return !this.source.length;
            },
            prepend: function (e, t) {
              this.source.unshift(this.wrap(e, t));
            },
            push: function (e, t) {
              this.source.push(this.wrap(e, t));
            },
            merge: function () {
              var e = this.empty();
              return (
                this.each(function (t) {
                  e.add(["  ", t, "\n"]);
                }),
                e
              );
            },
            each: function (e) {
              for (var t = 0, n = this.source.length; n > t; t++)
                e(this.source[t]);
            },
            empty: function () {
              var e = this.currentLocation || { start: {} };
              return new s(e.start.line, e.start.column, this.srcFile);
            },
            wrap: function (e) {
              var t =
                arguments.length <= 1 || void 0 === arguments[1]
                  ? this.currentLocation || { start: {} }
                  : arguments[1];
              return e instanceof s
                ? e
                : ((e = i(e, this, t)),
                  new s(t.start.line, t.start.column, this.srcFile, e));
            },
            functionCall: function (e, t, n) {
              return (
                (n = this.generateList(n)),
                this.wrap([e, t ? "." + t + "(" : "(", n, ")"])
              );
            },
            quotedString: function (e) {
              return (
                '"' +
                (e + "")
                  .replace(/\\/g, "\\\\")
                  .replace(/"/g, '\\"')
                  .replace(/\n/g, "\\n")
                  .replace(/\r/g, "\\r")
                  .replace(/\u2028/g, "\\u2028")
                  .replace(/\u2029/g, "\\u2029") +
                '"'
              );
            },
            objectLiteral: function (e) {
              var t = [];
              for (var n in e)
                if (e.hasOwnProperty(n)) {
                  var r = i(e[n], this);
                  "undefined" !== r && t.push([this.quotedString(n), ":", r]);
                }
              var o = this.generateList(t);
              return o.prepend("{"), o.add("}"), o;
            },
            generateList: function (e) {
              for (var t = this.empty(), n = 0, r = e.length; r > n; n++)
                n && t.add(","), t.add(i(e[n], this));
              return t;
            },
            generateArray: function (e) {
              var t = this.generateList(e);
              return t.prepend("["), t.add("]"), t;
            },
          }),
          (t.default = r),
          (e.exports = t.default);
      },
      function (e, t, n) {
        "use strict";
        function i(e) {
          s.default(e),
            l.default(e),
            u.default(e),
            d.default(e),
            f.default(e),
            g.default(e),
            y.default(e);
        }
        var r = n(8).default;
        (t.__esModule = !0), (t.registerDefaultHelpers = i);
        var o = n(22),
          s = r(o),
          a = n(23),
          l = r(a),
          c = n(24),
          u = r(c),
          p = n(25),
          d = r(p),
          h = n(26),
          f = r(h),
          v = n(27),
          g = r(v),
          m = n(28),
          y = r(m);
      },
      function (e, t, n) {
        "use strict";
        function i(e) {
          s.default(e);
        }
        var r = n(8).default;
        (t.__esModule = !0), (t.registerDefaultDecorators = i);
        var o = n(29),
          s = r(o);
      },
      function (e, t, n) {
        "use strict";
        t.__esModule = !0;
        var i = n(13),
          r = {
            methodMap: ["debug", "info", "warn", "error"],
            level: "info",
            lookupLevel: function (e) {
              if ("string" == typeof e) {
                var t = i.indexOf(r.methodMap, e.toLowerCase());
                e = t >= 0 ? t : parseInt(e, 10);
              }
              return e;
            },
            log: function (e) {
              if (
                ((e = r.lookupLevel(e)),
                "undefined" != typeof console && r.lookupLevel(r.level) <= e)
              ) {
                var t = r.methodMap[e];
                console[t] || (t = "log");
                for (
                  var n = arguments.length, i = Array(n > 1 ? n - 1 : 0), o = 1;
                  n > o;
                  o++
                )
                  i[o - 1] = arguments[o];
                console[t].apply(console, i);
              }
            },
          };
        (t.default = r), (e.exports = t.default);
      },
      function (e, t, n) {
        "use strict";
        t.__esModule = !0;
        var i = n(13);
        (t.default = function (e) {
          e.registerHelper("blockHelperMissing", function (t, n) {
            var r = n.inverse,
              o = n.fn;
            if (t === !0) return o(this);
            if (t === !1 || null == t) return r(this);
            if (i.isArray(t))
              return t.length > 0
                ? (n.ids && (n.ids = [n.name]), e.helpers.each(t, n))
                : r(this);
            if (n.data && n.ids) {
              var s = i.createFrame(n.data);
              (s.contextPath = i.appendContextPath(n.data.contextPath, n.name)),
                (n = { data: s });
            }
            return o(t, n);
          });
        }),
          (e.exports = t.default);
      },
      function (e, t, n) {
        "use strict";
        var i = n(8).default;
        t.__esModule = !0;
        var r = n(13),
          o = n(12),
          s = i(o);
        (t.default = function (e) {
          e.registerHelper("each", function (e, t) {
            function n(t, n, o) {
              c &&
                ((c.key = t),
                (c.index = n),
                (c.first = 0 === n),
                (c.last = !!o),
                u && (c.contextPath = u + t)),
                (l += i(e[t], {
                  data: c,
                  blockParams: r.blockParams([e[t], t], [u + t, null]),
                }));
            }
            if (!t) throw new s.default("Must pass iterator to #each");
            var i = t.fn,
              o = t.inverse,
              a = 0,
              l = "",
              c = void 0,
              u = void 0;
            if (
              (t.data &&
                t.ids &&
                (u = r.appendContextPath(t.data.contextPath, t.ids[0]) + "."),
              r.isFunction(e) && (e = e.call(this)),
              t.data && (c = r.createFrame(t.data)),
              e && "object" == typeof e)
            )
              if (r.isArray(e))
                for (var p = e.length; p > a; a++)
                  a in e && n(a, a, a === e.length - 1);
              else {
                var d = void 0;
                for (var h in e)
                  e.hasOwnProperty(h) &&
                    (void 0 !== d && n(d, a - 1), (d = h), a++);
                void 0 !== d && n(d, a - 1, !0);
              }
            return 0 === a && (l = o(this)), l;
          });
        }),
          (e.exports = t.default);
      },
      function (e, t, n) {
        "use strict";
        var i = n(8).default;
        t.__esModule = !0;
        var r = n(12),
          o = i(r);
        (t.default = function (e) {
          e.registerHelper("helperMissing", function () {
            if (1 !== arguments.length)
              throw new o.default(
                'Missing helper: "' + arguments[arguments.length - 1].name + '"'
              );
          });
        }),
          (e.exports = t.default);
      },
      function (e, t, n) {
        "use strict";
        t.__esModule = !0;
        var i = n(13);
        (t.default = function (e) {
          e.registerHelper("if", function (e, t) {
            return (
              i.isFunction(e) && (e = e.call(this)),
              (!t.hash.includeZero && !e) || i.isEmpty(e)
                ? t.inverse(this)
                : t.fn(this)
            );
          }),
            e.registerHelper("unless", function (t, n) {
              return e.helpers.if.call(this, t, {
                fn: n.inverse,
                inverse: n.fn,
                hash: n.hash,
              });
            });
        }),
          (e.exports = t.default);
      },
      function (e, t, n) {
        "use strict";
        (t.__esModule = !0),
          (t.default = function (e) {
            e.registerHelper("log", function () {
              for (
                var t = [void 0], n = arguments[arguments.length - 1], i = 0;
                i < arguments.length - 1;
                i++
              )
                t.push(arguments[i]);
              var r = 1;
              null != n.hash.level
                ? (r = n.hash.level)
                : n.data && null != n.data.level && (r = n.data.level),
                (t[0] = r),
                e.log.apply(e, t);
            });
          }),
          (e.exports = t.default);
      },
      function (e, t, n) {
        "use strict";
        (t.__esModule = !0),
          (t.default = function (e) {
            e.registerHelper("lookup", function (e, t) {
              return e && e[t];
            });
          }),
          (e.exports = t.default);
      },
      function (e, t, n) {
        "use strict";
        t.__esModule = !0;
        var i = n(13);
        (t.default = function (e) {
          e.registerHelper("with", function (e, t) {
            i.isFunction(e) && (e = e.call(this));
            var n = t.fn;
            if (i.isEmpty(e)) return t.inverse(this);
            var r = t.data;
            return (
              t.data &&
                t.ids &&
                ((r = i.createFrame(t.data)),
                (r.contextPath = i.appendContextPath(
                  t.data.contextPath,
                  t.ids[0]
                ))),
              n(e, {
                data: r,
                blockParams: i.blockParams([e], [r && r.contextPath]),
              })
            );
          });
        }),
          (e.exports = t.default);
      },
      function (e, t, n) {
        "use strict";
        t.__esModule = !0;
        var i = n(13);
        (t.default = function (e) {
          e.registerDecorator("inline", function (e, t, n, r) {
            var o = e;
            return (
              t.partials ||
                ((t.partials = {}),
                (o = function (r, o) {
                  var s = n.partials;
                  n.partials = i.extend({}, s, t.partials);
                  var a = e(r, o);
                  return (n.partials = s), a;
                })),
              (t.partials[r.args[0]] = r.fn),
              o
            );
          });
        }),
          (e.exports = t.default);
      },
    ]);
  })
  /*!
   * queryParams.js
   */,
  (window.Shopify = window.Shopify || {}),
  (Shopify.queryParams = {}),
  location.search.length)
)
  for (
    var aKeyValue, i = 0, aCouples = location.search.substr(1).split("&");
    i < aCouples.length;
    i++
  )
    (aKeyValue = aCouples[i].split("=")),
      aKeyValue.length > 1 &&
        (Shopify.queryParams[decodeURIComponent(aKeyValue[0])] =
          decodeURIComponent(aKeyValue[1]));
/*!
 * tocca.min.js
 */
/*! tocca v0.2.0-beta.2 || Gianluca Guarini */
var SWIPE_THRESHOLD = 50;
!(function (e, t) {
  "use strict";
  if ("function" != typeof e.createEvent) return !1;
  var n,
    i,
    r,
    o,
    s,
    a,
    l,
    c,
    u = "undefined" != typeof jQuery,
    p = function (e) {
      var t = e.toLowerCase(),
        n = "MS" + e;
      return navigator.msPointerEnabled ? n : t;
    },
    d = !!navigator.pointerEnabled || navigator.msPointerEnabled,
    h = function () {
      return (
        "ontouchstart" in window ||
        (window.DocumentTouch && document instanceof DocumentTouch) ||
        d
      );
    },
    f = function (e) {
      var t = h(),
        n = /mouse/.test(e.type);
      return (
        (!n && t && /touch/.test(e.type) && !d) ||
        (!n && t && !/touch/.test(e.type) && d) ||
        (n && !t)
      );
    },
    v = {
      touchstart: p("PointerDown") + " touchstart",
      touchend: p("PointerUp") + " touchend",
      touchmove: p("PointerMove") + " touchmove",
    },
    g = function (e, t, n) {
      for (var i = t.split(" "), r = i.length; r--; )
        e.addEventListener(i[r], n, !1);
    },
    m = function (e) {
      return e.targetTouches ? e.targetTouches[0] : e;
    },
    y = function () {
      return new Date().getTime();
    },
    b = function (t, r, o, s) {
      var a = e.createEvent("Event");
      if (
        ((a.originalEvent = o),
        (s = s || {}),
        (s.x = n),
        (s.y = i),
        (s.distance = s.distance),
        u && ((a = $.Event(r, { originalEvent: o })), jQuery(t).trigger(a, s)),
        a.initEvent)
      ) {
        for (var l in s) a[l] = s[l];
        a.initEvent(r, !0, !0), t.dispatchEvent(a);
      }
      t["on" + r] && t["on" + r](a);
    },
    k = function (e) {
      if (f(e)) {
        var t = m(e);
        (r = n = t.pageX),
          (o = i = t.pageY),
          (c = setTimeout(function () {
            b(e.target, "longtap", e), (a = e.target);
          }, E)),
          (s = y()),
          A++;
      }
    },
    w = function (e) {
      if (f(e)) {
        var t = [],
          u = y(),
          p = o - i,
          d = r - n;
        if (
          (clearTimeout(l),
          clearTimeout(c),
          -S >= d && t.push("swiperight"),
          d >= S && t.push("swipeleft"),
          -S >= p && t.push("swipedown"),
          p >= S && t.push("swipeup"),
          t.length)
        )
          for (var h = 0; h < t.length; h++) {
            var v = t[h];
            b(e.target, v, e, { distance: { x: Math.abs(d), y: Math.abs(p) } });
          }
        else
          r >= n - P &&
            n + P >= r &&
            o >= i - P &&
            i + P >= o &&
            s + T - u >= 0 &&
            (b(e.target, 2 === A && a === e.target ? "dbltap" : "tap", e),
            (a = e.target)),
            (l = setTimeout(function () {
              A = 0;
            }, C));
      }
    },
    x = function (e) {
      if (f(e)) {
        var t = m(e);
        (n = t.pageX), (i = t.pageY);
      }
    },
    S = t.SWIPE_THRESHOLD || 100,
    T = t.TAP_THRESHOLD || 150,
    C = t.DBL_TAP_THRESHOLD || 200,
    E = t.LONG_TAP_THRESHOLD || 1e3,
    P = t.TAP_PRECISION / 2 || 30,
    _ = t.JUST_ON_TOUCH_DEVICES,
    A = 0;
  g(e, v.touchstart + (_ ? "" : " mousedown"), k),
    g(e, v.touchend + (_ ? "" : " mouseup"), w),
    g(e, v.touchmove + (_ ? "" : " mousemove"), x);
})(document, window)
/*!
 * jquery.ba-throttle-debounce.min.js
 */,
  /*
   * jQuery throttle / debounce - v1.1 - 3/7/2010
   * http://benalman.com/projects/jquery-throttle-debounce-plugin/
   *
   * Copyright (c) 2010 "Cowboy" Ben Alman
   * Dual licensed under the MIT and GPL licenses.
   * http://benalman.com/about/license/
   */
  (function (e, t) {
    var n,
      i = e.jQuery || e.Cowboy || (e.Cowboy = {});
    (i.throttle = n =
      function (e, n, r, o) {
        function s() {
          function i() {
            (l = +new Date()), r.apply(c, p);
          }
          function s() {
            a = t;
          }
          var c = this,
            u = +new Date() - l,
            p = arguments;
          o && !a && i(),
            a && clearTimeout(a),
            o === t && u > e
              ? i()
              : n !== !0 && (a = setTimeout(o ? s : i, o === t ? e - u : e));
        }
        var a,
          l = 0;
        return (
          "boolean" != typeof n && ((o = r), (r = n), (n = t)),
          i.guid && (s.guid = r.guid = r.guid || i.guid++),
          s
        );
      }),
      (i.debounce = function (e, i, r) {
        return r === t ? n(e, i, !1) : n(e, r, i !== !1);
      });
  })(this);

/*
 slick-animation.js

 Version: 0.3.3 Beta
 Author: Marvin HÃ¼bner
 Docs: https://github.com/marvinhuebner/slick-animation
 Repo: https://github.com/marvinhuebner/slick-animation
 */
!(function (a) {
  a.fn.slickAnimation = function () {
    function n(a, n, t, i, o) {
      (o = "undefined" != typeof o ? o : !1),
        1 == n.opacity
          ? (a.addClass(t), a.addClass(i))
          : (a.removeClass(t), a.removeClass(i)),
        o && a.css(n);
    }
    function t(a, n) {
      return a ? 1e3 * a + 1e3 : n ? 1e3 * n : a || n ? 1e3 * a + 1e3 * n : 1e3;
    }
    function i(a, n, t) {
      var i = [
          "animation-" + n,
          "-webkit-animation-" + n,
          "-moz-animation-" + n,
          "-o-animation-" + n,
          "-ms-animation-" + n,
        ],
        o = {};
      i.forEach(function (a) {
        o[a] = t + "s";
      }),
        a.css(o);
    }
    var o = a(this),
      e = o.find(".slick-list .slick-track > div"),
      s = o.find('[data-slick-index="0"]'),
      r = "animated",
      c = { opacity: "1" },
      d = { opacity: "0" };
    return (
      e.each(function () {
        var e = a(this);
        e.find("[data-animation-in]").each(function () {
          var u = a(this);
          u.css(d);
          var l = u.attr("data-animation-in"),
            f = u.attr("data-animation-out"),
            h = u.attr("data-delay-in"),
            m = u.attr("data-duration-in"),
            y = u.attr("data-delay-out"),
            C = u.attr("data-duration-out");
          f
            ? (s.length > 0 &&
                e.hasClass("slick-current") &&
                (n(u, c, l, r, !0),
                h && i(u, "delay", h),
                m && i(u, "duration", m),
                setTimeout(function () {
                  n(u, d, l, r),
                    n(u, c, f, r),
                    y && i(u, "delay", y),
                    C && i(u, "duration", C);
                }, t(h, m))),
              o.on("afterChange", function (a, o, s) {
                e.hasClass("slick-current") &&
                  (n(u, c, l, r, !0),
                  h && i(u, "delay", h),
                  m && i(u, "duration", m),
                  setTimeout(function () {
                    n(u, d, l, r),
                      n(u, c, f, r),
                      y && i(u, "delay", y),
                      C && i(u, "duration", C);
                  }, t(h, m)));
              }),
              o.on("beforeChange", function (a, t, i) {
                n(u, d, f, r, !0);
              }))
            : (s.length > 0 &&
                e.hasClass("slick-current") &&
                (n(u, c, l, r, !0),
                h && i(u, "delay", h),
                m && i(u, "duration", m)),
              o.on("afterChange", function (a, t, o) {
                e.hasClass("slick-current") &&
                  (n(u, c, l, r, !0),
                  h && i(u, "delay", h),
                  m && i(u, "duration", m));
              }),
              o.on("beforeChange", function (a, t, i) {
                n(u, d, l, r, !0);
              }));
        });
      }),
      this
    );
  };
})(jQuery);
